/* eslint-disable no-restricted-globals */
import { useMemo, useState, useRef } from "react";
import DataTable from "../Table/Datatable";
import { format as dateFormat } from "date-fns";
import { useEffect } from "react";
import { DOMAIN_API_HOST } from "../../../configs/main";
import "./reports.scss";
import { INIT_FILTER_VALUE, filterDate, filterEmploye, filterStatsDate, filterStatsPartner } from "./filters";
import { Modal, Box, Typography, MenuItem } from "@material-ui/core";
import { FormControl, InputLabel, Select, Checkbox, ListItemText, ListSubheader, TextField, InputAdornment, Button, Tooltip as MuiTooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { useSearchParams } from 'react-router-dom';
import Chip from "@mui/material/Chip";

import { useSnackbar } from "notistack";
import DateFromTo from "../../../widgets/DateFromTo/DateFromTo";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Select as UiSelect } from "../../../ui";
import useAdminUser from "../../../data/useAdminUser";
import CircularProgress from "@mui/material/CircularProgress";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis, restrictToWindowEdges } from "@dnd-kit/modifiers";

// import useYaRequest from "../../../data/useYaRequest";

import { regionsData } from "./geolist.js";

function mapExternalVerifierFromBackend(items) {
  if (!Array.isArray(items)) return items;
  return items.map((item) => {
    const raw = item.external_verificators ?? item.external_verifier;
    let values;
    if (Array.isArray(raw)) {
      values = raw;
    } else if (typeof raw === "string" && raw.trim() !== "") {
      values = raw
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    } else {
      values = [];
    }
    const normalized = values.length === 0 ? ["Нет"] : values;
    return {
      ...item,
      external_verifier: normalized,
    };
  });
}

const campaignStyles = {
  height: "100vh",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100vw",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const staffStyles = {
  height: "160px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const advancedFilterModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "720px",
  maxWidth: "95vw",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: 3,
};



const StaffSelect = ({ el, field, label, arrStaff, updateField }) => {
  const [searchStaff, setSearchStaff] = useState('');
  const filteredStaff = arrStaff.filter((employee) =>
    employee.full_name?.toLowerCase().includes(searchStaff.toLowerCase())
  );

  return (
    <Box sx={{ width: "230px", textAlign: "start", padding: "2px 0", height: 30 }}>
      <FormControl fullWidth size="small">
        <InputLabel
          id={`${field}-select-label`}
          sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
        >
          {label}
        </InputLabel>
        <Select
          onOpen={() => setTimeout(() => document.getElementById(`search-input-${field}`).focus(), 100)}
          onChange={(e) => updateField(el.id, field, e.target.value === "Нет" ? null : e.target.value)}
          defaultValue={el[field] || "Нет"}
          style={{
            height: 32,
            margin: "0 10px",
            background: "#FFFFFF",
            borderColor: "transparent",
          }}
          sx={{
            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
          label={label}
          id={`${field}-select`}
          onClose={() => setTimeout(() => setSearchStaff(""), 300)}
        >
          <ListSubheader>
            <TextField
              id={`search-input-${field}`}
              size="small"
              autoFocus
              placeholder="Поиск"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchStaff(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById(`search-input-${field}`).focus(), 100)
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          <MenuItem value="Нет">Нет</MenuItem>
          {filteredStaff.map((staff) => (
            <MenuItem key={staff.id} value={staff.id}>
              {staff.full_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

const ListOfGoals = ({ goalsListOptions, filteredGoals, setSearchGoals, setSearchStaffAccount, handleCloseListGoals, defaultGoals, disabled }) => {
  const [listGoals, setListGoals] = useState([]);
  const [openItems, setOpenItems] = useState({});
  const [needUpdateGoals, setNeedUpdateGoals] = useState(false);

  useEffect(() => {
    setListGoals(defaultGoals);

    const newOpenItems = {};
    defaultGoals.forEach((goal) => {
      const goalId = goal.split('-')[0];
      newOpenItems[goalId] = true;
    });
    setOpenItems(newOpenItems);
  }, [defaultGoals]);

  useEffect(() => {
    const hasChanged = JSON.stringify(listGoals) !== JSON.stringify(defaultGoals);
    setNeedUpdateGoals(hasChanged);
  }, [listGoals, defaultGoals]);

  const handleToggleOpen = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleChangeListGoals = (event) => {
    const value = event.target.value;
    setListGoals(typeof value === "string" ? value.split(",") : value);
  };

  const handleCloseSelect = () => {
    setTimeout(() => setSearchStaffAccount(""), 300);

    if (!needUpdateGoals) return;

    handleCloseListGoals(listGoals);
    setNeedUpdateGoals(false);
  };

  const handleSelectChild = (goalId, child) => {
    const childValue = `${goalId}-${child}`;
    if (listGoals.includes(childValue)) {
      setListGoals(listGoals.filter(item => item !== childValue));
    } else {
      setListGoals(listGoals.filter(item => !item.startsWith(goalId)).concat(childValue));
    }
  };

  return (
    <Box sx={{ width: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
      <FormControl fullWidth size="small">
        <InputLabel
          id="demo-select-small-label"
          sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
        >
          Список целей
        </InputLabel>
        <Select
          onOpen={() => setTimeout(() => document.getElementById("search-input-goals").focus(), 100)}
          style={{
            margin: "0 10px",
            fontSize: 14,
            height: 32,
            background: "#FFFFFF",
            borderColor: "transparent",
          }}
          sx={{
            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
          placeholder="Список целей"
          multiple
          value={listGoals || []}
          renderValue={(selected) => selected.join(', ')}
          onChange={handleChangeListGoals}
          onClose={handleCloseSelect}
        >
          <ListSubheader>
            <TextField
              id="search-input-goals"
              size="small"
              autoFocus
              placeholder="Поиск"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchGoals(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-goals").focus(), 100);
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {filteredGoals.map((goal) => {
            const goalIndex = goalsListOptions.findIndex((e) => e.goal_id === goal.goal_id);
            const isStandaloneGoal = ["Лиды(Calltracking)", "Сделки(Calltracking)"].includes(goal.name) && [1, 2].includes(goal.goal_id);
            
            return (
              <div key={goal.goal_id}>
                {isStandaloneGoal ? (
                  <MenuItem
                    disabled={disabled || false}
                    style={{ display: "flex", gap: 10 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectChild(goal.goal_id, "visits");
                  }}>
                    <Checkbox disabled={disabled || false} checked={listGoals.includes(`${goal.goal_id}-visits`)} />
                    <ListItemText primary={`${goal.name}`} />
                  </MenuItem>
                ) : (
                  <>
                    <MenuItem onClick={(e) => {
                      e.stopPropagation();
                      handleToggleOpen(goal.goal_id);
                    }}>
                      <button
                        style={{
                          background: "none",
                          cursor: "pointer",
                          color: "#007bff",
                          marginRight: "10px",
                          fontSize: 20,
                          fontWeight: 500,
                          width: 20,
                          height: 20,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {openItems[goal.goal_id] ? "-" : "+"}
                      </button>
                      <ListItemText primary={`${goalIndex + 1} - ${goal.name} - ${goal.goal_id}`} />
                    </MenuItem>
                    {openItems[goal.goal_id] && (
                      <>
                        <MenuItem disabled={disabled || false} style={{ display: "flex", gap: 10, marginLeft: 25 }} onClick={(e) => {
                          e.stopPropagation();
                          handleSelectChild(goal.goal_id, 'visits');
                        }}>
                          <Checkbox disabled={disabled || false} checked={listGoals.includes(`${goal.goal_id}-visits`)} />
                          <ListItemText primary="Целевые визиты" />
                        </MenuItem>
                        <MenuItem disabled={disabled || false} style={{ display: "flex", gap: 10, marginLeft: 25 }} onClick={(e) => {
                          e.stopPropagation();
                          handleSelectChild(goal.goal_id, 'users');
                        }}>
                          <Checkbox disabled={disabled || false} checked={listGoals.includes(`${goal.goal_id}-users`)} />
                          <ListItemText primary="Достижения целей" />
                        </MenuItem>
                      </>
                    )}
                  </>
                )}
              </div>
            );
          })}
          {filteredGoals.length === 0 && (
            <MenuItem disabled>
              <ListItemText style={{ fontSize: 14 }} primary="Нет доступных целей" />
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
};



const CampaignsSelect = ({ defaultValue, campaigns, handleChange }) => {
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (defaultValue) {
      setSelectedCampaigns(defaultValue);
    }
  }, [defaultValue]);

  const toggleCampaign = (campaignId) => {
    setSelectedCampaigns((prevSelected) => {
      const newSelected = prevSelected.includes(campaignId)
        ? prevSelected.filter((id) => id !== campaignId)
        : [...prevSelected, campaignId];
      handleChange("campaign_ids", newSelected);
      return newSelected;
    });
  };

  const selectAll = () => {
    const allCampaignsIds = campaigns.map(c => c.id);
    setSelectedCampaigns(allCampaignsIds);
    handleChange("campaign_ids", allCampaignsIds);
  };

  const deselectAll = () => {
    setSelectedCampaigns([]);
    handleChange("campaign_ids", []);
  };

  const filteredCampaign = campaigns.filter(campaign =>
    campaign.basic_config.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box sx={{ width: 230, padding: "10px 0", textAlign: "start" }}>
      <FormControl fullWidth size="small">
        <InputLabel>Выбор кампаний</InputLabel>
        <Select
          multiple
          onOpen={() => setTimeout(() => document.getElementById("search-input-campaigns").focus(), 100)}
          value={selectedCampaigns}
          renderValue={(selected) => 
            selected.map(id => 
              campaigns.find(c => c.id === id)?.basic_config.name
            ).filter(Boolean).join(", ")
          }
          style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
          sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
          onClose={() => setTimeout(() => setSearchQuery(""), 100)}
        >
          <ListSubheader>
            <Box sx={{ display: "flex", gap: 5, mb: 1 }}>
              <button onClick={selectAll} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Выбрать все
              </button>
              <button onClick={deselectAll} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Снять все
              </button>
            </Box>
            <TextField
              size="small"
              placeholder="Поиск"
              fullWidth
              autoFocus
              value={searchQuery}
              id="search-input-campaigns"
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-campaigns").focus(), 100);
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {filteredCampaign.map(campaign => (
            <MenuItem 
              key={campaign.id} 
              value={campaign.id} 
              onClick={() => toggleCampaign(campaign.id)}
            >
              <Checkbox 
                checked={selectedCampaigns.includes(campaign.id)} 
                style={{ pointerEvents: "none", marginRight: "8px" }} 
              />
              {campaign.basic_config.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};



const RegionSelect = ({ defaultValue, regions, handleChange, disabled }) => {
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [openRegions, setOpenRegions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [needUpdateRegions, setNeedUpdateRegions] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      const defaultRegionIds = defaultValue.split(",").map(item => {
        const [id, level] = item.split("-");
        return {
          id: id ? id.trim() : null,
          level: level ? parseInt(level.trim(), 10) : null
        };
      }).filter(item => item.id && item.level !== null);
  
      setSelectedRegions(defaultRegionIds.map(item => item.id));
    }
  }, [defaultValue]);

  const toggleRegion = (regionId, isIndeterminate) => {
    if (isIndeterminate) return;

    setSelectedRegions((prevSelected) => {
      setNeedUpdateRegions(true);
      if (prevSelected.includes(regionId)) {
        return prevSelected.filter((id) => id !== regionId);
      } else {
        return [...prevSelected, regionId];
      }
    });
  };

  const handleToggleOpen = (regionId) => {
    setOpenRegions((prevOpen) => {
      if (prevOpen.includes(regionId)) {
        return prevOpen.filter((id) => id !== regionId);
      } else {
        return [...prevOpen, regionId];
      }
    });
  };

  const filterRegions = (regionsList) => {
    return regionsList.filter((region) =>
      region.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (region.chld && filterRegions(region.chld).length > 0)
    );
  };

  const isRegionIndeterminate = (region) => {
    if (!region.chld) return false;

    const childIds = getAllRegionIds(region.chld);
    const selectedChildIds = childIds.filter(id => selectedRegions.includes(id));
    return selectedChildIds.length > 0 && selectedChildIds.length < childIds.length;
  };

  const getAllRegionIds = (regionsList) => {
    let ids = [];
    regionsList.forEach((region) => {
      ids.push(region.id);
      if (region.chld) {
        ids = [...ids, ...getAllRegionIds(region.chld)];
      }
    });
    return ids;
  };

  const renderMenuItems = (regionsList) => {
    const filteredRegions = filterRegions(regionsList);

    return filteredRegions
      .filter(region => region.name !== "Не определено" && region.name !== "Без области")
      .map((region) => {
        const isSelected = selectedRegions.includes(region.id);
        const isIndeterminate = isRegionIndeterminate(region);

        return (
          <div key={region.id}>
            <MenuItem
              disabled={disabled || false}
              onClick={() => toggleRegion(region.id, isIndeterminate)}
              style={{ display: "flex", alignItems: "center" }}
            >
              {region.chld && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggleOpen(region.id);
                  }}
                  style={{
                    background: "none",
                    cursor: "pointer",
                    color: "#007bff",
                    marginRight: "10px",
                    fontSize: "20px",
                    fontWeight: 500,
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {openRegions.includes(region.id) ? "-" : "+"}
                </button>
              )}
              <Checkbox
                disabled={disabled || false}
                checked={isSelected}
                indeterminate={isIndeterminate}
                onChange={() => toggleRegion(region.id, isIndeterminate)}
                style={{ pointerEvents: "none", marginRight: "8px" }}
              />
              <ListItemText primary={`${region.name}`} />
            </MenuItem>
            {openRegions.includes(region.id) && region.chld && (
              <Box sx={{ paddingLeft: "20px" }}>
                {renderMenuItems(region.chld)}
              </Box>
            )}
          </div>
        );
      });
  };

  const findRegionById = (regionsList, id) => {
    for (const region of regionsList) {
      if (region.id === id) return region;
      if (region.chld) {
        const found = findRegionById(region.chld, id);
        if (found) return found;
      }
    }
    return null;
  };

  const getSelectedRegionIdsWithHierarchy = (regionsList) => {
    let selectedWithHierarchy = [];

    const traverseRegions = (regionList, level) => {
      regionList.forEach((region) => {
        if (selectedRegions.includes(region.id)) {
          selectedWithHierarchy.push(`${region.id}-${level}`);
        }
        if (region.chld) {
          traverseRegions(region.chld, level + 1);
        }
      });
    };

    traverseRegions(regionsList, 1);
    return selectedWithHierarchy;
  };

  const handleCloseListRegions = () => {
    if (!needUpdateRegions) return;
  
    const selectedRegionIdsWithHierarchy = getSelectedRegionIdsWithHierarchy(regions);
  
    handleChange("geo", selectedRegionIdsWithHierarchy.join(","), true);
    setNeedUpdateRegions(false);
  };

  const handleRemoveRegion = (regionId) => {
    setSelectedRegions((prevSelected) => prevSelected.filter(id => id !== regionId));
    setNeedUpdateRegions(true);
  };

  return (
    <Box sx={{ width: 200, padding: "10px 0", textAlign: "start" }}>
      <FormControl fullWidth size="small">
        <InputLabel sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}>
          Выбор региона
        </InputLabel>
        <Select
          multiple
          value={selectedRegions}
          renderValue={() => getSelectedRegionIdsWithHierarchy(regions).join(", ")}
          onClose={handleCloseListRegions}
          style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
          sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
        >
          <ListSubheader>
            <Box  
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                mb: 1,
                maxWidth: "500px",
                maxHeight: "300px",
                overflowY: "auto",
                "&::-webkit-scrollbar": { display: "none" },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none"
              }}>
              {selectedRegions.map((regionId) => {
                const region = findRegionById(regions, regionId);
                return (
                  <Chip
                    key={regionId}
                    label={region?.name}
                    disabled={disabled || false}
                    onDelete={() => handleRemoveRegion(regionId)}
                    style={{ border: "2px solid #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                  />
                );
              })}
            </Box>
            <TextField
              size="small"
              autoFocus
              placeholder="Поиск"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {renderMenuItems(regions)}
        </Select>
      </FormControl>
    </Box>
  );
};




const InputCustomArea = ({ value, handleChange, disabled }) => {
  return (
    <input
      disabled={disabled || false}
      onChange={(e) => handleChange(e.target.value)}
      defaultValue={value}
      onDoubleClick={(e) => {
        const input = e.target;
        const fullTextArea = document.createElement("textarea");

        // Настройка textarea
        fullTextArea.value = input.value;
        fullTextArea.spellcheck = false;

        fullTextArea.style.width = "95vw";
        fullTextArea.style.fontFamily = "sans-serif";
        fullTextArea.style.height = "auto";
        fullTextArea.style.padding = "10px";
        fullTextArea.style.border = "1px solid #3f73f9";
        fullTextArea.style.borderRadius = "4px";
        fullTextArea.style.position = "fixed";
        fullTextArea.style.top = "30px";
        fullTextArea.style.left = "30px";
        fullTextArea.style.zIndex = 1000;
        fullTextArea.style.backgroundColor = "#fff";
        fullTextArea.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.2)";

        fullTextArea.onblur = () => {
          fullTextArea.remove();
          input.style.display = "inline-block";
        };

        fullTextArea.oninput = (e) => {
          handleChange(e.target.value);
          input.value = e.target.value;
        };

        document.body.appendChild(fullTextArea);
        input.style.display = "none";

        fullTextArea.focus();
      }}
      style={{
        width: '100%',
        height: '30px',
        padding: '5px',
        borderRadius: '4px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
    />
  );
};





const GraphComponent = ({ report_id, dates, spec }) => {
  const [specForGraph, setSpecForGraph] = useState(Number(spec));
  const [detailForGraph, setDetailForGraph] = useState(0);
  const [graphData, setGraphData] = useState([]);
  const chartOptionFields = ["PRG1", "PRG2", "PRG10", "PRG11", "PRG12", "PRG22", "PRG8", "PRG80", "PRG81", "PRG84", "PRG82", "PRG4", "PRG5", "PRG6", "PRG7", "PRG13", "PRG14", "PRG86", "PRG87", "PRG88"];
  const [graphFields, setGraphFields] = useState([]);

  const chartOptions = ["Показы", "Клики", "Лиды", "Бюджет", "ДРР", "Доходность", "eCPC"];
  const chartOptionsDetail = ["Общая", "Детальная"];
  

  useEffect(() => {
    if (dates.date0 && dates.date1) {
      fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/graphic?_id=${report_id}&date0=${dates.date0}&date1=${dates.date1}&spec=${specForGraph}&detail=${[4, 5, 6].includes(specForGraph) ? 0 : detailForGraph}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
        },
      })
        .then((res) => res.ok && res.json())
        .then((data) => setGraphData(data));
    }
  }, [specForGraph, detailForGraph, dates, report_id]);

  useEffect(() => {
    setGraphFields([])
  }, [detailForGraph])

  const handleChangeListFields = (event) => {
    const {
      target: { value },
    } = event;
    setGraphFields(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div style={{ width: "49%" }}>
      <div style={{ display: "flex" }}>
        <Box sx={{ width: 200, padding: "10px 0", textAlign: "start" }}>
          <FormControl fullWidth size="small">
            <InputLabel sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}>График</InputLabel>
            <Select
              onChange={(e) => setSpecForGraph(chartOptions.indexOf(e.target.value))}
              value={chartOptions[specForGraph]}
              style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
              sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
            >
              {chartOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {![4, 5, 6].includes(specForGraph) && (
          <Box sx={{ width: 200, padding: "10px 0", textAlign: "start", marginLeft: 10 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}>Детализация</InputLabel>
              <Select
                onChange={(e) => setDetailForGraph(chartOptionsDetail.indexOf(e.target.value))}
                value={chartOptionsDetail[detailForGraph]}
                style={{ height: 32, background: "#FFFFFF", borderColor: "transparent" }}
                sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
              >
                {chartOptionsDetail.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        {detailForGraph === 1 && ![4, 5, 6].includes(specForGraph) && (
          <Box sx={{ width: 200, padding: "10px 0", textAlign: "start", marginLeft: 10 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Линии
              </InputLabel>
              <Select
                style={{
                  margin: "0 10px",
                  fontSize: 14,
                  height: 32,
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                placeholder="Линии"
                multiple
                value={graphFields || []}
                renderValue={(selected) => selected.join(', ')}
                onChange={handleChangeListFields}
              >
                {chartOptionFields.map((field) => (
                  <MenuItem style={{ display: "flex", gap: 10 }} key={field} value={field}>
                    <Checkbox checked={graphFields.includes(field)} />
                    <ListItemText primary={field} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </div>

      {graphData.length === 0 ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px", border: "1px dashed #5b5b5b" }}>
          <p style={{ fontSize: 18 }}>Нет данных для графика.</p>
        </div>
      ) : (
        <MultiLineChartByDay data={graphData} label={chartOptions[specForGraph]} fields={graphFields} />
      )}
    </div>
  );
};


// const testDataChart2 = [
//   {
//       "date": 1728248400,
//       "value": 10
//   }, 
//   {
//       "date": 1728334800,
//       "value": 40
//   },
//   {
//       "date": 1728421200,
//       "value": 30
//   }
// ]


// const testDataChart = [
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 6 * 24 * 60 * 60, value: 2340 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 6 * 24 * 60 * 60, value: 1500 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 5 * 24 * 60 * 60, value: 2100 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 5 * 24 * 60 * 60, value: 1300 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 4 * 24 * 60 * 60, value: 2900 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 4 * 24 * 60 * 60, value: 1700 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 3 * 24 * 60 * 60, value: 1800 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 3 * 24 * 60 * 60, value: 2200 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 2 * 24 * 60 * 60, value: 2400 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 2 * 24 * 60 * 60, value: 1600 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000) - 1 * 24 * 60 * 60, value: 2500 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000) - 1 * 24 * 60 * 60, value: 1800 },
//   { name: 'PRG1', date: Math.floor(Date.now() / 1000), value: 2600 },
//   { name: 'PRG2', date: Math.floor(Date.now() / 1000), value: 1900 },
// ];

let globalCalendarManager = {
  activeCalendar: null,
  calendars: new Set(),
  
  register(calendar) {
    this.calendars.add(calendar);
  },
  
  unregister(calendar) {
    this.calendars.delete(calendar);
    if (this.activeCalendar === calendar) {
      this.activeCalendar = null;
    }
  },
  
  setActive(calendar) {
    this.calendars.forEach(cal => {
      if (cal !== calendar && cal.isOpen()) {
        cal.close();
      }
    });
    this.activeCalendar = calendar;
  }
};

const CustomCalendar = ({ defaultValue, value, onChange, disabled }) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue || '');
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  
  const calendarRef = useRef({
    isOpen: () => showCalendar,
    close: () => setShowCalendar(false)
  });

  useEffect(() => {
    calendarRef.current.isOpen = () => showCalendar;
    calendarRef.current.close = () => setShowCalendar(false);
  }, [showCalendar]);

  useEffect(() => {
    globalCalendarManager.register(calendarRef.current);
    return () => {
      globalCalendarManager.unregister(calendarRef.current);
    };
  }, []);

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const formattedDate = formatDatePicker(value);
      setSelectedDate(formattedDate);
      if (formattedDate) {
        setCurrentMonth(new Date(formattedDate));
      }
    } else if (defaultValue) {
      let formattedDate;
      if (typeof defaultValue === 'string') {
        if (defaultValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
          formattedDate = defaultValue;
        } else {
          const parsed = new Date(defaultValue);
          if (!isNaN(parsed.getTime())) {
            const year = parsed.getFullYear();
            const month = String(parsed.getMonth() + 1).padStart(2, '0');
            const day = String(parsed.getDate()).padStart(2, '0');
            formattedDate = `${year}-${month}-${day}`;
          }
        }
      } else if (typeof defaultValue === 'number') {
        formattedDate = formatDatePicker(defaultValue);
      }
      
      if (formattedDate) {
        setSelectedDate(formattedDate);
        setCurrentMonth(new Date(formattedDate));
      }
    }
  }, [value, defaultValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('[data-calendar-container]')) {
        globalCalendarManager.calendars.forEach(calendar => {
          if (calendar.isOpen()) {
            calendar.close();
          }
        });
      }
    };

    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showCalendar]);

  const handleDateSelect = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    
    setSelectedDate(formattedDate);
    if (onChange) {
      onChange(formattedDate);
    }
    setShowCalendar(false);
  };

  const navigateMonth = (direction) => {
    const newMonth = new Date(currentMonth);
    if (direction === 'prev') {
      newMonth.setMonth(newMonth.getMonth() - 1);
    } else {
      newMonth.setMonth(newMonth.getMonth() + 1);
    }
    setCurrentMonth(newMonth);
  };

  const getDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    
    for (let i = 0; i < (startingDayOfWeek === 0 ? 6 : startingDayOfWeek - 1); i++) {
      days.push(null);
    }
    
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  };

  const handleDayHover = (e, isHover) => {
    if (!e.target.dataset.date) return;
    
    const dateString = e.target.dataset.date;
    const dateFromData = new Date(dateString + 'T00:00:00');
    const isSelected = selectedDate === dateString;
    const isTodayDate = isToday(dateFromData) && !isSelected;
    
    if (isHover && !isSelected) {
      e.target.style.backgroundColor = '#f0f7ff';
      e.target.style.border = '1px solid #3f73f9';
      e.target.style.color = '#333';
    } else {
      if (isSelected) {
        e.target.style.backgroundColor = '#3f73f9';
        e.target.style.color = 'white';
        e.target.style.border = '1px solid #3f73f9';
      } else if (isTodayDate) {
        e.target.style.backgroundColor = '#e3f2fd';
        e.target.style.color = '#1976d2';
        e.target.style.border = '1px solid #1976d2';
      } else {
        e.target.style.backgroundColor = 'transparent';
        e.target.style.color = '#333';
        e.target.style.border = '1px solid transparent';
      }
    }
  };

  const handleNavButtonHover = (e, isHover) => {
    if (isHover) {
      e.target.style.backgroundColor = '#3f73f9';
      e.target.style.color = 'white';
    } else {
      e.target.style.backgroundColor = '#dfe8ff';
      e.target.style.color = '#3f73f9';
    }
  };

  const calculateCalendarPosition = (element) => {
    const rect = element.getBoundingClientRect();
    const calendarWidth = 280;
    const calendarHeight = 350;
    
    let top = rect.bottom + 4;
    let left = rect.left;
    
    if (top + calendarHeight > window.innerHeight) {
      top = rect.top - calendarHeight - 4;
    }
    
    if (left + calendarWidth > window.innerWidth) {
      left = window.innerWidth - calendarWidth - 10;
    }
    
    if (left < 10) {
      left = 10;
    }
    
    return { top, left };
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return 'Выберите дату';
    return new Date(dateString).toLocaleDateString('ru-RU');
  };

  const isSelectedDate = (date) => {
    if (!date || !selectedDate) return false;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    return dateString === selectedDate;
  };

  const isToday = (date) => {
    if (!date) return false;
    const today = new Date();
    const dateToCheck = new Date(date);
    return dateToCheck.getFullYear() === today.getFullYear() &&
           dateToCheck.getMonth() === today.getMonth() &&
           dateToCheck.getDate() === today.getDate();
  };

  const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  const dayNames = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

  return (
    <div style={stylesCustomCalendar.container} data-calendar-container>
      <div 
        style={disabled ? {...stylesCustomCalendar.dateDisplay, ...stylesCustomCalendar.disabled} : stylesCustomCalendar.dateDisplay}
        onClick={(e) => {
          if (!disabled) {
            if (!showCalendar) {
              // Уведомляем менеджер о том, что этот календарь станет активным
              globalCalendarManager.setActive(calendarRef.current);
              const position = calculateCalendarPosition(e.currentTarget);
              setCalendarPosition(position);
              setShowCalendar(true);
            } else {
              setShowCalendar(false);
            }
          }
        }}
      >
        <span>{formatDisplayDate(selectedDate)}</span>
        <span style={stylesCustomCalendar.calendarIcon}>📅</span>
      </div>

      {showCalendar && !disabled && (
        <div style={{
          ...stylesCustomCalendar.calendarDropdown,
          top: calendarPosition.top,
          left: calendarPosition.left
        }}>
          <div style={stylesCustomCalendar.calendarHeader}>
            <button 
              onClick={() => navigateMonth('prev')}
              style={stylesCustomCalendar.navButton}
              onMouseEnter={(e) => handleNavButtonHover(e, true)}
              onMouseLeave={(e) => handleNavButtonHover(e, false)}
            >
              ◀
            </button>
            <span style={stylesCustomCalendar.monthYear}>
              {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
            </span>
            <button 
              onClick={() => navigateMonth('next')}
              style={stylesCustomCalendar.navButton}
              onMouseEnter={(e) => handleNavButtonHover(e, true)}
              onMouseLeave={(e) => handleNavButtonHover(e, false)}
            >
              ▶
            </button>
          </div>
          
          <div style={stylesCustomCalendar.dayNames}>
            {dayNames.map((day) => (
              <div key={day} style={stylesCustomCalendar.dayName}>
                {day}
              </div>
            ))}
          </div>
          
          <div style={stylesCustomCalendar.daysGrid}>
            {getDaysInMonth().map((date, index) => {
              // Создаем правильный data-date в локальной timezone
              const dateString = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : null;
              
              return (
                <div
                  key={index}
                  data-date={dateString}
                  style={
                    date 
                      ? {
                          ...stylesCustomCalendar.dayCell,
                          ...(isSelectedDate(date) ? stylesCustomCalendar.selectedDay : {}),
                          ...(isToday(date) && !isSelectedDate(date) ? stylesCustomCalendar.todayDay : {})
                        }
                      : stylesCustomCalendar.emptyCell
                  }
                  onClick={() => date && handleDateSelect(date)}
                  onMouseEnter={(e) => date && handleDayHover(e, true)}
                  onMouseLeave={(e) => date && handleDayHover(e, false)}
                >
                  {date ? date.getDate() : ''}
                </div>
              );
            })}
          </div>
          
          <div style={stylesCustomCalendar.calendarFooter}>
            <button 
              onClick={() => setShowCalendar(false)}
              style={stylesCustomCalendar.closeButton}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f5f5f5';
                e.target.style.borderColor = '#999';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.borderColor = '#ddd';
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}


    </div>
  );
};

const DatePickerTest = CustomCalendar;



const formatDatePicker = (date, istext = false) => {
  if (date === 0 || !date) return;
  const d = new Date(date * 1000);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  if (istext) return `${day}.${month}.${year}`
  return `${year}-${month}-${day}`;
};

const stylesCustomCalendar = {
  container: {
    position: 'relative',
    display: 'inline-block',
    width: '150px',
  },
  dateDisplay: {
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    backgroundColor: 'white',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '34px',
    transition: 'border-color 0.3s ease',
    width: '100%',
    boxSizing: 'border-box',
  },
  disabled: {
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  calendarIcon: {
    fontSize: '14px',
    marginLeft: '8px',
    color: '#666',
  },
  calendarDropdown: {
    position: 'fixed',
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,
    padding: '12px',
    width: '280px',
    boxSizing: 'border-box',
  },
  calendarHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  navButton: {
    padding: '4px 8px',
    fontSize: '16px',
    border: '1px solid #dfe8ff',
    borderRadius: '4px',
    backgroundColor: '#dfe8ff',
    color: '#3f73f9',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.3s ease',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  monthYear: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    minWidth: '140px',
    textAlign: 'center',
  },
  dayNames: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '1px',
    marginBottom: '4px',
  },
  dayName: {
    padding: '6px 2px',
    fontSize: '11px',
    fontWeight: '600',
    color: '#666',
    textAlign: 'center',
    minHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  daysGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '1px',
    marginBottom: '12px',
  },
  dayCell: {
    padding: '4px',
    fontSize: '13px',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    minHeight: '28px',
    width: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid transparent',
  },
  emptyCell: {
    padding: '4px',
    minHeight: '28px',
    width: '32px',
  },
  selectedDay: {
    backgroundColor: '#3f73f9',
    color: 'white',
    fontWeight: '600',
    border: '1px solid #3f73f9',
  },
  todayDay: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontWeight: '600',
    border: '1px solid #1976d2',
  },
  calendarFooter: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #eee',
    paddingTop: '8px',
  },
  closeButton: {
    padding: '4px 12px',
    fontSize: '12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white',
    color: '#666',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.3s ease',
  },

};

const formatDate = (timestamp) => {
  const date = new Date(parseInt(timestamp) * 1000);
  return date.toLocaleDateString();
};

const MultiLineChartByDay = ({ data, label, fields }) => {
  const isSingleLineData = data.every(item => item.name === undefined);

  let formattedData;

  if (isSingleLineData) {
    formattedData = data.map(item => ({
      name: label,
      date: formatDate(item.date),
      value: item.value,
    }));
  } else {
    formattedData = data.map(item => ({
      ...item,
      date: formatDate(item.date),
    }));
  }

  const uniqueNames = [...new Set(formattedData.map(item => item.name))];

  const groupedData = uniqueNames.map(name => {
    const valuesByDate = formattedData.filter(item => item.name === name);
    return {
      name,
      ...Object.fromEntries(valuesByDate.map(item => [item.date, item.value])),
    };
  });

  const finalData = [];
  const uniqueDates = [...new Set(formattedData.map(item => item.date))];

  uniqueDates.forEach(date => {
    const entry = { date };
    uniqueNames.forEach(name => {
      const value = groupedData.find(item => item.name === name)[date] || 0;
      entry[name] = value;
    });
    finalData.push(entry);
  });

  const linesToDisplay = fields && fields.length > 0 ? fields : uniqueNames;

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={finalData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        {linesToDisplay.map((name, index) => (
          <Line 
            key={name} 
            type="monotone" 
            dataKey={name} 
            name={name} 
            stroke={[
              "#e57373",
              "#f06292",
              "#ba68c8",
              "#64b5f6",
              "#4db6ac",
              "#81c784",
              "#ffd54f",
              "#ff8a65", 
              "#ffb74d",
              "#64ffda"
            ][index % 10]}
            strokeWidth={2}
            connectNulls
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

const OpenMarginality = ({ report_id, arrStaff, setOpenModal }) => {
  const [filterArr, setFilterArr] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [selectedCycleId, setSelectedCycleId] = useState("");
  const [projectDates, setProjectDates] = useState({
    start_cycle_date: "",
    end_cycle_date: "",
  });

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));

      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/margin-report?report_id=${report_id}` + (selectedCycleId && selectedCycleId !== 1 ? `&cycle_id=${selectedCycleId}` : ""), {
        method: "GET",
        headers: myHeaders,
      });
      if (response.ok) {
        const data = await response.json();
        setFilterArr([data]);
        if (!selectedCycleId || selectedCycleId === 1) {
        setProjectDates({
            start_cycle_date: data.start_cycle_date,
            end_cycle_date: data.end_cycle_date,
          });
        }
      }
    }

    fetchData();
  }, [report_id, selectedCycleId]);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));

      const responseCycles = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch-cycles-of-report?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseCycles.ok) {
        const data = await responseCycles.json();
        setCycles(data);
      }
    }

    fetchData();
  }, [report_id]);

  const formatCycleDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "2-digit" };
    return new Date(date).toLocaleDateString("ru-RU", options);
  };

  function getTableData() {
    return filterArr.map((el) => {
      return {
        accountManager: <div className="td">{arrStaff.find(staff => staff.id === el.account_manager)?.full_name || "-"}</div>,
        accountManager2: <div className="td">{arrStaff.find(staff => staff.id === el.account_manager_2)?.full_name || "-"}</div>,
        productionManagerContext: <div className="td">{arrStaff.find(staff => staff.id === el.contextologist)?.full_name || "-"}</div>,
        productionManagerTraffic: <div className="td">{arrStaff.find(staff => staff.id === el.traffic_manager)?.full_name || "-"}</div>,
        contextCosts: <div className="td">{Number(el.context_costs).toLocaleString()} ₽</div>,
        networkCosts: <div className="td">{Number(el.network_costs).toLocaleString()} ₽</div>,
        externalCosts: <div className="td">{Number(el.external_costs).toLocaleString()} ₽</div>,
        income: <div className="td">{Number(el.income_vat).toLocaleString()} ₽</div>,
        marginality: <div className="td">{el.margin != null ? el.margin + "%" : "-"}</div>,
        projectMargin: <div className="td">{Number(el.margin_value).toLocaleString()} ₽</div>,
        other_costs: <div className="td">{Number(el.other_costs).toLocaleString()} ₽</div>
      };
    });
  }

  const columns = [
    {
      Header: "Аккаунт-менеджер",
      accessor: "accountManager",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Аккаунт-менеджер 2",
      accessor: "accountManager2",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Менеджер производства (контекст)",
      accessor: "productionManagerContext",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Менеджер производства (трафик)",
      accessor: "productionManagerTraffic",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Затраты контекст",
      accessor: "contextCosts",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Затраты на сети",
      accessor: "networkCosts",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Затраты из внешних систем",
      accessor: "externalCosts",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Остальные затраты",
      accessor: "other_costs",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Доход с НДС",
      accessor: "income",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Маржинальность",
      accessor: "marginality",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Маржа проекта",
      accessor: "projectMargin",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    }
  ];

  return (
    <div>
        <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
          <h2 style={{ marginBottom: "20px" }}>Отчёт маржинальности за</h2>
          <div style={{ width: "500px" }}>
            <Box sx={{ width: "fit-content", minWidth: 150, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Цикл проекта
                </InputLabel>
                <Select
                  value={cycles.length > 0 ? (selectedCycleId || 1) : ""}
                  onChange={(e) => setSelectedCycleId(e.target.value)}
                  displayEmpty
                  style={{
                    height: 32,
                    margin: "0 10px", 
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="Цикл проекта"
                  id="demo-select-small"
                >
                  {cycles.length > 0 ? (
                    [{
                      id: 1,
                      start_cycle_date: projectDates.start_cycle_date,
                      end_cycle_date: projectDates.end_cycle_date
                    }, ...cycles.filter(c => c.id !== 1)].map((option, index) => (
                      <MenuItem style={{ fontSize: 14 }} key={option.id} value={option.id}>
                        {option.id === 1
                          ? `Текущий. ${formatCycleDate(option.start_cycle_date)} - ${formatCycleDate(option.end_cycle_date)}`
                          : `${index}. ${formatCycleDate(option.start_cycle_date)} - ${formatCycleDate(option.end_cycle_date)}`}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      Циклы не найдены
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </div>
        </div>
      <div style={{ width: "100%", height: "100%", overflowX: "scroll", scrollbarWidth: "none", border: "1px solid #dee2e6", borderRadius: "8px", padding: "20px" }}>
        <DataTable
          columns={columns}
          data={getTableData()}
        />
      </div>
      <div style={{ 
        width: "400px",
        marginTop: "20px", 
      }}>
        <h3 style={{ 
          marginBottom: "16px", 
          marginTop: "0", 
          color: "#2c3e50",
          fontSize: "18px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}>
          Остальные затраты
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {filterArr[0]?.other_consumptions?.length === 0 && (
            <div style={{
              backgroundColor: "white",
              padding: "16px 20px",
              borderRadius: "8px",
              border: "1px solid #dee2e6",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}>
              <p style={{ fontSize: 15, fontWeight: "500" }}>Нет остальных затрат</p>
            </div>
          )}
          {filterArr[0]?.other_consumptions?.map((el, index) => (
            <div key={index} style={{
              backgroundColor: "white",
              padding: "16px 20px",
              borderRadius: "8px",
              border: "1px solid #dee2e6",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              transition: "all 0.2s ease"
            }}>
              <div style={{
                color: "#495057",
                fontSize: "14px",
                fontWeight: "500",
                flex: "1"
              }}>
                <p style={{ margin: 0, fontSize: 12, fontWeight: "500", opacity: "70%" }}>Комментарий</p>
                <p style={{ fontSize: 15, fontWeight: "500" }}>{el.comment}</p>
              </div>
              <div style={{
                fontSize: "16px",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "20px",
                minWidth: "80px",
                textAlign: "center"
              }}>
                {el.value.toLocaleString("ru-RU")} {el.value_type === "currency" ? "₽" : "%"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


const OpenCampaign = ({ report_id, arrStaff, setOpenModal, onUpdated }) => {

  const [filterArr, setFilter] = useState([]);

  const [cycles, setCycles] = useState([]);
  const [selectedCycleId, setSelectedCycleId] = useState("");

  const [filterArchive, setFilterArchive] = useState([]);

  const [filterArrSvod, setFilterSvod] = useState([]);
  const [filterArrDetailsSvod, setFilterDetailsSvod] = useState([]);
  const [filterArrDetailsSvodArchive, setFilterDetailsSvodArchive] = useState([]);
  const [filterArrDetails, setFilterDetails] = useState([]);

  const [lastDetailsUpdate, setLastDetailsUpdate] = useState({
    lastClicksUpdate: {},
    lastLeadsUpdate: {},
  });

  const [goalsListOptions, setGoalsListOptions] = useState([]);
  // const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [listGoals, setListGoals] = useState([]);
  // const [openDetails, setOpenDetails] = useState(false);
  const [specForDetails, setSpecForDetails] = useState('PRG1');
  const [openSvod, setOpenSvod] = useState(false);
  const [openSvodArchive, setOpenSvodArchive] = useState(false);
  const [openDetailsArchive, setOpenDetailsArchive] = useState(false);
  const [svodDetails, setSvodDetails] = useState("");
  const [svodDetailsArchive, setSvodDetailsArchive] = useState("");
  const [upd, setUpd] = useState(false);
  const debounceTimers = useRef({});

  const [searchGoals, setSearchGoals] = useState('');
  const [searchStaffAccount, setSearchStaffAccount] = useState('');
  const [searchStaffAccount1, setSearchStaffAccount1] = useState('');
  const [searchStaffContext, setSearchStaffContext] = useState('');
  const [searchStaffTraffic, setSearchStaffTraffic] = useState('');
  // const [searchStaffLead, setSearchStaffLead] = useState('');

  const [fieldsToUpdate, setFieldsToUpdate] = useState([]);
  const [closeModal, setCloseModal] = useState(false);
  const [saveFields, setSaveFields] = useState(false);
  const [graphDate, setGraphDate] = useState({
    date0: 0,
    date1: 0
  })

  const [otherConsumptions, setOtherConsumptions] = useState([]);
  const [openOtherConsumptionsModal, setOpenOtherConsumptionsModal] = useState(false);
  const [newOtherConsumption, setNewOtherConsumption] = useState({
    comment: '',
    value: '',
    value_type: 'currency'
  });
  const [otherConsumptionModalMode, setOtherConsumptionModalMode] = useState('create'); // 'create' or 'edit'
  const [editingOtherConsumptionIndex, setEditingOtherConsumptionIndex] = useState(null);

  // Archive other consumptions states
  const [otherConsumptionsArchive, setOtherConsumptionsArchive] = useState([]);
  const [openOtherConsumptionsModalArchive, setOpenOtherConsumptionsModalArchive] = useState(false);
  const [newOtherConsumptionArchive, setNewOtherConsumptionArchive] = useState({
    comment: '',
    value: '',
    value_type: 'currency'
  });
  const [otherConsumptionModalModeArchive, setOtherConsumptionModalModeArchive] = useState('create'); // 'create' or 'edit'
  const [editingOtherConsumptionIndexArchive, setEditingOtherConsumptionIndexArchive] = useState(null);

  const [openPvSettingsModal, setOpenPvSettingsModal] = useState(false);
  const [pvSettingsList, setPvSettingsList] = useState([]);
  const [pvSettingsInitial, setPvSettingsInitial] = useState([]);
  const [pvWasSaved, setPvWasSaved] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { role } = useAdminUser();

  const [counters, setCounters] = useState([]);

  const [campaigns, setCampaigns] = useState([]);

  const [commentValue, setCommentValue] = useState('');

  const getMoscowMidnight = (date) => {
    const targetDate = new Date(date);

    const year = targetDate.getUTCFullYear();
    const month = String(targetDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(targetDate.getUTCDate()).padStart(2, '0');

    const moscowMidnight = new Date(`${year}-${month}-${day}T00:00:00+03:00`);

    return Math.floor(moscowMidnight.getTime() / 1000);
  };

  const getInitialDetailsDate = () => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem('details_date');
      if (stored) {
        const parsed = Number(stored);
        if (!Number.isNaN(parsed)) {
          return parsed;
        }
      }
    }
    return getMoscowMidnight(new Date());
  };

  const [detailsDate, setDetailsDate] = useState(getInitialDetailsDate);


  const additionalGoals = [
    {
      name: "Лиды(Calltracking)",
      goal_id: 1,
    },
    {
      name: "Сделки(Calltracking)",
      goal_id: 2,
    }
  ];

  const formatCycleDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "2-digit" };
    return new Date(date).toLocaleDateString("ru-RU", options);
  };

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const responseHead = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/head?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseHead.ok) {
        const data = await responseHead.json();
        setFilter(mapExternalVerifierFromBackend(data));
        setListGoals(data[0]?.list_of_goals.split(',').filter(Boolean));
      }
      const responseCounters = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/get-counters?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseCounters.ok) {
        const data = await responseCounters.json();
        setCounters(data);
      }

      const responseCampaigns = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/campaigns?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseCampaigns.ok) {
        const data = await responseCampaigns.json();
        setCampaigns(data);
      }

      const responseGoals = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/get-goals?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseGoals.ok) {
        const data = await responseGoals.json();
        setGoalsListOptions(data.concat(additionalGoals));
      }
      const responseSvod = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/summary?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseSvod.ok) {
        const data = await responseSvod.json();
        setFilterSvod([data]);
        setCommentValue(data.comment_involtra)
        setOtherConsumptions(data.other_consumptions)
      }
      const responseCycles = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch-cycles-of-report?_id=${report_id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseCycles.ok) {
        const data = await responseCycles.json();
        setCycles(data);
      }
    }
    fetchData();
  }, [upd]);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
  
      const isToday = detailsDate === getMoscowMidnight(new Date());
  
      const url = isToday
        ? `${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/detalization?_id=${report_id}&spec=${specForDetails}`
        : `${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/detalization?_id=${report_id}&spec=${specForDetails}&date=${detailsDate}`;
  
      if (specForDetails) {
        const responseDetails = await fetch(url, {
          method: "GET",
          headers: myHeaders,
        });
  
        if (responseDetails.ok) {
          const data = await responseDetails.json();
          if (data.ok !== undefined && !data.ok && !isToday) {
            alert("Нет логов проекта за выбранную дату. Дата сброшена на сегодня.")
            const todayMidnight = getMoscowMidnight(new Date());
            setDetailsDate(todayMidnight);
            if (typeof window !== 'undefined') {
              window.localStorage.setItem('details_date', String(todayMidnight));
            }
          }
          setFilterDetails([data]);
          setLastDetailsUpdate({
            lastClicksUpdate: data.last_clicks_update,
            lastLeadsUpdate: data.last_leads_update
          });
        }
      }
    }
  
    fetchData();
  }, [specForDetails, upd, detailsDate]);


  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      if (svodDetails) {
        const responseDetails = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/summary-prgs?_id=${report_id}&spec=${svodDetails === "consumption" ? "budget" : svodDetails}_fact`, {
          method: "GET",
          headers: myHeaders,
        });
        if (responseDetails.ok) {
          const data = await responseDetails.json();
          setFilterDetailsSvod(
            Object.keys(data)
              .filter(key => key.startsWith('PRG'))
              .map(key => ({ prg: key, count: data[key] }))
          );
        }
      }
    }
    fetchData();
  }, [svodDetails, upd]);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      if (svodDetailsArchive) {
        const responseDetails = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/summary-prgs?_id=${report_id}${selectedCycleId ? `&cycle_id=${selectedCycleId}` : ''}&spec=${svodDetailsArchive === "consumption" ? "budget" : svodDetailsArchive}_fact`, {
          method: "GET",
          headers: myHeaders,
        });
        if (responseDetails.ok) {
          const data = await responseDetails.json();
          setFilterDetailsSvodArchive(
            Object.keys(data)
              .filter(key => key.startsWith('PRG'))
              .map(key => ({ prg: key, count: data[key] }))
          );
        }
      }
    }
    fetchData();
  }, [svodDetailsArchive, upd]);


  useEffect(() => {
    if (closeModal) {
      if (fieldsToUpdate.length === 0 && !pvWasSaved) {
        enqueueSnackbar("В отчёте не было изменений.", {
          variant: "info",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        updateAllFields();
        enqueueSnackbar("Отчёт успешно сохранён.", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
      setPvWasSaved(false);
      setCloseModal(false);
      setOpenModal(false);
      if (typeof onUpdated === "function") onUpdated();
    }
  }, [closeModal]);


  useEffect(() => {
    if (saveFields) {
      updateAllFields();
      enqueueSnackbar("Отчёт успешно сохранён.", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      setPvWasSaved(false);
      setSaveFields(false);
      if (typeof onUpdated === "function") onUpdated();
    }
  }, [saveFields]);

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const responseCycleLog = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/get-latest-log-by-cycle?_id=${selectedCycleId}`, {
        method: "GET",
        headers: myHeaders,
      });
          if (responseCycleLog.ok) {
      const data = await responseCycleLog.json();
      if (data.income_vat === null || data.income_vat === undefined) {
        data.income_vat = 0;
      }
      setFilterArchive([data]);
      setOtherConsumptionsArchive(data.other_consumptions || []);
    }
    }
    if (selectedCycleId) {
      fetchData();
    } else {
      setOtherConsumptionsArchive([]);
    }
  }, [selectedCycleId]);


  const updateAllFields = async () => {
    const fieldsByCycle = fieldsToUpdate.reduce((acc, field) => {
      const isCycleKey = field.isCycle ? 'true' : 'false';
      if (!acc[isCycleKey]) {
        acc[isCycleKey] = { fields: {}, isCycle: field.isCycle };
      }
      acc[isCycleKey].fields[field.field] = field.value;
      return acc;
    }, {});

    for (const group of Object.values(fieldsByCycle)) {
      await updateFields(group.fields, group.isCycle);
    }
    
    setFieldsToUpdate([]);
    setUpd((prev) => !prev);
  };

  const debounceUpdate = (field, callback, delay = 250) => {
    clearTimeout(debounceTimers.current[field]);
    debounceTimers.current[field] = setTimeout(() => {
      callback();
      delete debounceTimers.current[field];
    }, delay);
  };
  
  const handleChange = (field, value, instant, isCycle = false, moment = false) => {
    if (instant) {
      setFieldsToUpdate((prevState) => {
        const updatedFields = prevState.map(item =>
          item.field === field ? { ...item, value, isCycle } : item
        );
        return updatedFields.some(item => item.field === field)
          ? updatedFields
          : [...updatedFields, { field, value, isCycle }];
      });
      return;
    }
    debounceUpdate(field, () => {
      setFieldsToUpdate((prevState) => {
        const updatedFields = prevState.map(item =>
          item.field === field ? { ...item, value, isCycle } : item
        );
        const newState = updatedFields.some(item => item.field === field)
          ? updatedFields
          : [...updatedFields, { field, value, isCycle }];
        
        if (moment) {
          const fieldsToUpdate = { [field]: value };
          updateFields(fieldsToUpdate, isCycle);
        }
        
        return newState;
      });
    });
  };

  const handleChangeDetails = (field, value, index) => {
    setFilterDetails((prevState) =>
      prevState.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            [field]: value,
          };
        }
        return item;
      })
    );
  }


  const updateFields = async (fields, isCycle = false) => {
    const fieldSuffixes = ['_consumption', '_clicks', '_views', '_leads', '_consumption_dol'];
  
    const fieldsWithDate = {};
    const fieldsWithoutDate = {};
  
    Object.entries(fields).forEach(([key, value]) => {
      if (fieldSuffixes.some(suffix => key.endsWith(suffix))) {
        fieldsWithDate[key] = value;
      } else {
        fieldsWithoutDate[key] = value;
      }
    });
  
    const isToday = detailsDate === getMoscowMidnight(new Date());
  
    if (Object.keys(fieldsWithDate).length > 0) {
      const url = isToday
        ? `${DOMAIN_API_HOST}/api/v1/admin/production-reports/update?_id=${report_id}${isCycle ? `&cycle_id=${selectedCycleId}` : ''}`
        : `${DOMAIN_API_HOST}/api/v1/admin/production-reports/update?_id=${report_id}&date=${detailsDate}`;
      
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
        },
        body: JSON.stringify({ ...fieldsWithDate, ...fieldsWithoutDate }),
      });
    } else if (Object.keys(fieldsWithoutDate).length > 0) {
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/update?_id=${report_id}${isCycle ? `&cycle_id=${selectedCycleId}` : ''}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
        },
        body: JSON.stringify(fieldsWithoutDate),
      });
    }
  };



  const calltrackingOptions = ["нет, но в работе", "не нужен, ecom", "да (Calltouch)", "да (Roistat)", "да (Comagic)", "да (Mango)", "да (Callibri)", "да (Битрикс24)"];
  

  const columns = [
    {
      Header: "Проект",
      accessor: "project",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
      isSticky: true,
    },
    {
      Header: "Сайт проекта",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
      isSticky: true,
    },
    {
      Header: "Дата начала цикла",
      accessor: "start_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Дата окончания цикла",
      accessor: "end_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Цель рк",
      accessor: "goal",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Гео",
      accessor: "geo",
      maxWidth: 400,
      minWidth: 80,
      width: 220,
    },
    {
      Header: "CallTracking",
      accessor: "calltracking",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Атрибуция по лидам",
      accessor: "attribution",
      maxWidth: 400,
      minWidth: 80,
      width: 270,
    },
    {
      Header: "Номера целей",
      accessor: "list_of_goals",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Целевые страницы",
      accessor: "landing_pages",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Привязанные кампании",
      accessor: "campaign_ids",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Название в Я. Метрике",
      accessor: "yametrika_name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Счётчик Я. Метрики",
      accessor: "counter_id",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Аккаунт-менеджер-1",
      accessor: "account_manager",
      maxWidth: 400,
      minWidth: 80,
      width: 230,
    },
    {
      Header: "Аккаунт-менеджер-2",
      accessor: "account_manager_1",
      maxWidth: 400,
      minWidth: 80,
      width: 230,
    },
    // {
    //   Header: "TeamLead",
    //   accessor: "team_lead",
    //   maxWidth: 400,
    //   minWidth: 80,
    //   width: 230,
    // },
    {
      Header: "Контекстолог",
      accessor: "contextologist",
      maxWidth: 400,
      minWidth: 80,
      width: 230,
    },
    {
      Header: "Трафик-менеджер",
      accessor: "traffic_manager",
      maxWidth: 400,
      minWidth: 80,
      width: 230,
    }
  ];


  const columnsSvod = [
    {
      id: "clicks_group_svod",
      Header: () => "Клики",
      columns: [
        {
          Header: "КЛИКИ план",
          accessor: "clicks",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "КЛИКИ факт",
          accessor: "clicks_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "КЛИКИ % цели",
          accessor: "clicks_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
      ],
    },
    {
      id: "leads_group_svod",
      Header: () => "Лиды",
      columns: [
        {
          Header: "ЛИДЫ Вал. план",
          accessor: "leads",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ЛИДЫ Вал. факт",
          accessor: "leads_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ЛИДЫ Вал. % цели",
          accessor: "leads_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ЛИДЫ Квал. план",
          accessor: "leads_qual",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ЛИДЫ Квал. факт",
          accessor: "leads_qual_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ЛИДЫ Квал. % цели",
          accessor: "leads_qual_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
      ],
    },
    {
      id: "postviews_group_details",
      Header: () => "PostView",
      columns: [
        {
          Header: "PV план",
          accessor: "postviews_plan",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "PV факт",
          accessor: "postviews_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "PV % цели",
          accessor: "postviews_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "PV Настройка",
          accessor: "postviews_settings",
          maxWidth: 400,
          minWidth: 100,
          width: 110,
        },
      ],
    },
    {
      Header: "eCPL",
      accessor: "eCPL",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      id: "income_group_svod",
      Header: () => "Доход",
      columns: [
        {
          Header: "ДОХОД план",
          accessor: "income",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
        {
          Header: "ДОХОД факт",
          accessor: "income_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 150,
        },
      ],
    },
    {
      Header: "ДРР, % факт",
      accessor: "drr_fact",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "БЮДЖЕТ НА ПРОИЗВОДСТВО",
      accessor: "budget",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "БЮДЖЕТ факт. расход",
      accessor: "budget_fact",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "БЮДЖЕТ % расхода планового бюджета",
      accessor: "budget_goal",
      maxWidth: 400,
      minWidth: 80,
      width: 180,
    },
    {
      Header: "Факт. расход ПОКАЗЫ",
      accessor: "budget_production",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      id: "views_group_details",
      Header: () => "Показы",
      columns: [
        {
          Header: "ПОКАЗЫ план",
          accessor: "views",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ПОКАЗЫ факт",
          accessor: "views_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ПОКАЗЫ % цели",
          accessor: "views_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      Header: "ОБЩИЙ факт. расход",
      accessor: "fact_consumption",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Приход с НДС",
      accessor: "income_vat",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Остальные затраты",
      accessor: "other_costs",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];

  const columnsSvodDetails = [
    {
      Header: "PRG",
      accessor: "prg",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Количество",
      accessor: "count",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ]

  function getColumnsDetails() {
    const queryName = tableDetailsOptions.find((el) => el.value === specForDetails).query;

    let columns = [
      {
        Header: "Клики",
        accessor: "clicks",
        maxWidth: 400,
        minWidth: 80,
        width: 120,
      },
      {
        Header: "Лиды",
        accessor: "leads",
        maxWidth: 400,
        minWidth: 80,
        width: 120,
      },
      {
        Header: "eCPC",
        accessor: "ecpc",
        maxWidth: 400,
        minWidth: 80,
        width: 120,
      },
    ];
  
    if (queryName === "zeropark" || queryName === "rich_ads" || queryName === "bidvert" || queryName === "mybid") {
      columns.unshift(
        {
          Header: "Расход (USD)",
          accessor: "consumption_dol",
          maxWidth: 400,
          minWidth: 80,
          width: 120,
        },
        {
          Header: "Расход (RUB)",
          accessor: "consumption_rub",
          maxWidth: 400,
          minWidth: 80,
          width: 120,
        }
      );
    } else if (queryName === "involtra") {
      columns.unshift(
        {
          Header: "Расход",
          accessor: "consumption",
          maxWidth: 400,
          minWidth: 80,
          width: 120,
        },
      );
    } else {
      columns.unshift(
        {
          Header: "Расход",
          accessor: "consumption",
          maxWidth: 400,
          minWidth: 80,
          width: 120,
        },
        {
          Header: "Показы",
          accessor: "views",
          maxWidth: 400,
          minWidth: 80,
          width: 120,
        }
      );
    }
  
    return columns;
  }


  function getTableDataSvod() {
    return filterArrSvod.map((el) => {
      return {
        income_vat: (
          <div className="td">
            <input onChange={(e) => handleChange('income_vat', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.income_vat || 0} type="number" style={{ height: 0 }}/>
          </div>
        ),
        other_costs: (
          <div className="td">{el.other_costs.toFixed(2)}</div>
        ),
        clicks: (
          <div className="td">
            <input onChange={(e) => handleChange('clicks', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.clicks} type="number" style={{ height: 0 }}/>
          </div>
        ),
        clicks_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.clicks_fact}
            <button onClick={() => {setOpenSvod(true); setSvodDetails("clicks")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        clicks_goal: (
          <div style={{ color: el.clicks_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.clicks_goal) ? el.clicks_goal : el.clicks_goal.toFixed(2)}%</div>
        ),
        leads: (
          <div className="td">
            <input onChange={(e) => handleChange('leads', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.leads} type="number" style={{ height: 0 }}/>
          </div>
        ),
        leads_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.leads_fact}
            <button onClick={() => {setOpenSvod(true); setSvodDetails("leads")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        leads_goal: (
          <div style={{ color: el.leads_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.leads_goal) ? el.leads_goal : el.leads_goal.toFixed(2)}%</div>
        ),
        leads_qual: (
          <div className="td">
            <input onChange={(e) => handleChange('leads_qual', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.leads_qual} type="number" style={{ height: 0 }}/>
          </div>
        ),
        leads_qual_fact: (
          <div className="td" style={{ position: "relative" }}>
            <input onChange={(e) => handleChange('leads_qual_fact', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.leads_qual_fact} type="number" style={{ height: 0 }}/>
            <button onClick={() => {setOpenSvod(true); setSvodDetails("leads_qual")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        leads_qual_goal: (
          <div style={{ color: el.leads_qual_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.leads_qual_goal) ? el.leads_qual_goal : el.leads_qual_goal.toFixed(2)}%</div>
        ),
        eCPL: (
          <div className="td">{Number.isInteger(el.eCPL) ? el.eCPL : el.eCPL.toFixed(2)}</div>
        ),
        income: (
          <div className="td">
            <input onChange={(e) => handleChange('income', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.income} type="number" style={{ height: 0 }}/>
          </div>
        ),
        income_fact: (
          <div className="td">
            <input onChange={(e) => handleChange('income_fact', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.income_fact} type="number" style={{ height: 0 }}/>
          </div>
        ),
        drr_fact: (
          <div className="td">{Number.isInteger(el.drr_fact) ? el.drr_fact : el.drr_fact.toFixed(2)}</div>
        ),
        budget: (
          <div className="td">
            <input onChange={(e) => handleChange('budget', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.budget} type="number" style={{ height: 0 }}/>
          </div>
        ),
        budget_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.budget_fact.toFixed(2)}
            <button onClick={() => {setOpenSvod(true); setSvodDetails("consumption")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        fact_consumption: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {(el.budget_fact + el.budget_production).toFixed(2)}
          </div>
        ),
        budget_production: (
          <div className="td">{Number.isInteger(el.budget_production) ? el.budget_production : el.budget_production.toFixed(2)}</div>
        ),
        budget_goal: (
          <div style={{ color: el.budget_goal >= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.budget_goal) ? el.budget_goal : el.budget_goal.toFixed(2)}</div>
        ),
        views: (
          <div className="td">
            <input onChange={(e) => handleChange('views', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.views} type="number" style={{ height: 0 }}/>
          </div>
        ),
        views_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.views_fact}
            <button onClick={() => {setOpenSvod(true); setSvodDetails("views")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        views_goal: (
          <div style={{ color: el.views_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.views_goal) ? el.views_goal : el.views_goal.toFixed(2)}%</div>
        ),
        postviews_plan: (
          <div className="td">
            <input onChange={(e) => handleChange('postviews_plan', Number(e.target.value))} onWheel={(e) => e.target.blur()} defaultValue={el.postviews_plan} type="number" style={{ height: 0 }}/>
          </div>
        ),
        postviews_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.postviews_fact}
          </div>
        ),
        postviews_goal: (
          <div style={{ color: (el.postviews_goal ?? 0) <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.postviews_goal) ? el.postviews_goal : (el.postviews_goal ?? 0).toFixed(2)}%</div>
        ),
        postviews_settings: (
          <div className="td">
            <button
              type="button"
              onClick={() => {
                const raw = Array.isArray(el.postviews) ? el.postviews : [];
                const list = raw.length ? raw.map((p) => ({ id: p.id, goal_id: p.id ?? p.goal_id ?? null, plan: p.plan ?? 0, fact: p.fact ?? 0 })) : [];
                setPvSettingsInitial(JSON.parse(JSON.stringify(list)));
                setPvSettingsList(list.length ? list : []);
                setOpenPvSettingsModal(true);
              }}
              style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #e2e8f0", backgroundColor: "#fff", cursor: "pointer", fontSize: 13 }}
            >
              Открыть
            </button>
          </div>
        ),
      };
    });
  }


  
  function getTableDataSvodArchive() {

    return filterArchive.map((el) => {
      return {
        clicks: (
          <div className="td">
            <input disabled defaultValue={el.clicks} type="number" style={{ height: 0 }}/>
          </div>
        ),
        income_vat: (
          <div className="td">
            <input onChange={(e) => {
              const inputValue = e.target.value;
              const numericValue = inputValue === '' ? 0 : Number(inputValue);
              setFilterArchive(prevState => 
                prevState.map(item => 
                  item === el ? { ...item, income_vat: numericValue } : item
                )
              );
              handleChange('income_vat', numericValue, false, true, true);
            }} onWheel={(e) => e.target.blur()} value={el.income_vat === null || el.income_vat === undefined || el.income_vat === 0 ? '' : el.income_vat} type="number" style={{ height: 0 }}/>
          </div>
        ),
        other_costs: (
          <div className="td">{el.other_costs.toFixed(2)}</div>
        ),
        budget_production: (
          <div className="td">{Number.isInteger(el.budget_production) ? el.budget_production : el.budget_production.toFixed(2)}</div>
        ),
        fact_consumption: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {(el.budget_fact + el.budget_production).toFixed(2)}
          </div>
        ),
        clicks_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.clicks_fact}
            <button onClick={() => {setOpenSvodArchive(true); setSvodDetailsArchive("clicks")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        clicks_goal: (
          <div style={{ color: el.clicks_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.clicks_goal) ? el.clicks_goal : el.clicks_goal.toFixed(2)}%</div>
        ),
        leads: (
          <div className="td">
            <input disabled defaultValue={el.leads} type="number" style={{ height: 0 }}/>
          </div>
        ),
        leads_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.leads_fact}
            <button onClick={() => {setOpenSvodArchive(true); setSvodDetailsArchive("leads")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        leads_goal: (
          <div style={{ color: el.leads_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.leads_goal) ? el.leads_goal : el.leads_goal.toFixed(2)}%</div>
        ),
        leads_qual: (
          <div className="td">
            <input disabled defaultValue={el.leads_qual} type="number" style={{ height: 0 }}/>
          </div>
        ),
        leads_qual_fact: (
          <div className="td" style={{ position: "relative" }}>
            <input disabled defaultValue={el.leads_qual_fact} type="number" style={{ height: 0 }}/>
            <button onClick={() => {setOpenSvodArchive(true); setSvodDetailsArchive("leads_qual")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        leads_qual_goal: (
          <div style={{ color: el.leads_qual_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.leads_qual_goal) ? el.leads_qual_goal : el.leads_qual_goal.toFixed(2)}%</div>
        ),
        eCPL: (
          <div className="td">{Number.isInteger(el.eCPL) ? el.eCPL : el.eCPL.toFixed(2)}</div>
        ),
        income: (
          <div className="td">
            <input disabled defaultValue={el.income} type="number" style={{ height: 0 }}/>
          </div>
        ),
        income_fact: (
          <div className="td">
            <input disabled defaultValue={el.income_fact} type="number" style={{ height: 0 }}/>
          </div>
        ),
        drr_fact: (
          <div className="td">{Number.isInteger(el.drr_fact) ? el.drr_fact : el.drr_fact.toFixed(2)}</div>
        ),
        budget: (
          <div className="td">
            <input disabled defaultValue={el.budget} type="number" style={{ height: 0 }}/>
          </div>
        ),
        budget_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.budget_fact.toFixed(2)}
            <button onClick={() => {setOpenSvodArchive(true); setSvodDetailsArchive("consumption")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        budget_goal: (
          <div style={{ color: el.budget_goal >= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.budget_goal) ? el.budget_goal : el.budget_goal.toFixed(2)}%</div>
        ),
        views: (
          <div className="td">
            <input disabled defaultValue={el.views} type="number" style={{ height: 0 }}/>
          </div>
        ),
        views_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.views_fact}
            <button onClick={() => {setOpenSvodArchive(true); setSvodDetailsArchive("views")}} style={{ padding: "3px 3px", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"></path></svg>
            </button>
          </div>
        ),
        views_goal: (
          <div style={{ color: el.views_goal <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.views_goal) ? el.views_goal : el.views_goal.toFixed(2)}%</div>
        ),
        postviews_plan: (
          <div className="td">
            <input disabled defaultValue={el.postviews_plan} type="number" style={{ height: 0 }}/>
          </div>
        ),
        postviews_fact: (
          <div className="td" style={{ height: 30, display: "flex", alignItems: "center", gap: 5 }}>
            {el.postviews_fact}
          </div>
        ),
        postviews_goal: (
          <div style={{ color: (el.postviews_goal ?? 0) <= 100 ? "#ff4141" : "#49e02d" }} className="td">{Number.isInteger(el.postviews_goal) ? el.postviews_goal : (el.postviews_goal ?? 0).toFixed(2)}%</div>
        ),
      };
    });
  }


  
  function getTableDataSvodDetails() {
    return filterArrDetailsSvod.map((el) => {
      // const query = `${tableDetailsOptions.find((element) => element.value === el.prg)?.query}_${svodDetails}`
      return {
        prg: (
          <div className="td">
            {el.prg}
          </div>
        ),
        count: (
          <div className="td">
            {Number.isInteger(el.count) ? el.count : el.count.toFixed(2)}
          </div>
        )
      };
    });
  }


  function getTableDataSvodDetailsArchive() {
    return filterArrDetailsSvodArchive.map((el) => {
      return {
        prg: (
          <div className="td">
            {el.prg}
          </div>
        ),
        count: (
          <div className="td">
            {Number.isInteger(el.count) ? el.count : el.count.toFixed(2)}
          </div>
        )
      };
    });
  }


  const columnsLimits = [
    {
      Header: "КЛИКИ Инволтра PRG8 клик/период",
      accessor: "clicks_involtra",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "КЛИКИ РичАдс PRG81 клик/день",
      accessor: "clicks_rich_ads",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "КЛИКИ БидВерт PRG84 клик/день",
      accessor: "clicks_bid_vert",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Средне суточное кол-во кликов",
      accessor: "daily_clicks",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];

  function getTableDataLimits() {
    return filterArrSvod.map((el) => {
      return {
        clicks_involtra: (
          <div className="td" style={{ height: 30, position: "relative" }}>
            <input 
                type="number" 
                onChange={(e) => {
                  handleChange(`clicks_involtra`, Number(e.target.value));
                }}
                onWheel={(e) => e.target.blur()}
                defaultValue={el.clicks_involtra === 0 || el.clicks_involtra 
                  ? el.clicks_involtra
                  : ''}
            />
          </div>
        ),
        clicks_rich_ads: (
          <div className="td" style={{ height: 30 }}>
            <input 
                type="number" 
                onChange={(e) => {
                  handleChange(`clicks_rich_ads`, Number(e.target.value));
                }}
                onWheel={(e) => e.target.blur()}
                defaultValue={el.clicks_rich_ads === 0 || el.clicks_rich_ads 
                  ? el.clicks_rich_ads
                  : ''}
            />
          </div>
        ),
        clicks_bid_vert: (
          <div className="td" style={{ height: 30 }}>
            <input 
                type="number" 
                onChange={(e) => {
                  handleChange(`clicks_bid_vert`, Number(e.target.value));
                }}
                onWheel={(e) => e.target.blur()}
                defaultValue={el.clicks_bid_vert === 0 || el.clicks_bid_vert 
                  ? el.clicks_bid_vert
                  : ''}
            />
          </div>
        ),
        daily_clicks: (
          <div className="td">
            {el.daily_clicks != null
              ? Number.isInteger(el.daily_clicks) 
                ? el.daily_clicks 
                : el.daily_clicks.toFixed(2)
              : '0'}
          </div>
        )
      };
    });
  }

  
  function getTableDataDetails() {
    const queryName = tableDetailsOptions.find((el) => el.value === specForDetails).query;
  
    return filterArrDetails.map((el, index) => {
        const dynamicFields = {};
        if (queryName === "zeropark" || queryName === "rich_ads" || queryName === "bidvert" || queryName === "mybid") {
            dynamicFields.consumption_dol = (
                <div className="td" style={{ height: 30 }}>
                  <input 
                      type="number" 
                      onChange={(e) => {
                        handleChangeDetails(`${queryName}_consumption_dol`, e.target.value, index);
                        handleChange(`${queryName}_consumption_dol`, Number(e.target.value));
                      }}
                      onWheel={(e) => e.target.blur()}
                      value={el[`${queryName}_consumption_dol`] === 0 || el[`${queryName}_consumption_dol`] 
                        ? el[`${queryName}_consumption_dol`]
                        : ''}
                  />
                </div>
            );
            dynamicFields.consumption_rub = (
                <div className="td" style={{ height: 30, display: "flex", alignItems: "center" }}>
                  {Number.isInteger(el[`${queryName}_consumption_rub`]) 
                  ? el[`${queryName}_consumption_rub`] 
                  : el[`${queryName}_consumption_rub`]?.toFixed(2) || ''}
                </div>
            );
        } else if (queryName === "involtra") {
          dynamicFields.consumption = (
            <div className="td" style={{ height: 30 }}>
              <input 
                  type="number" 
                  onChange={(e) => {
                    handleChangeDetails(`${queryName}_consumption`, e.target.value, index);
                    handleChange(`${queryName}_consumption`, Number(e.target.value));
                  }}
                  onWheel={(e) => e.target.blur()}
                  value={el[`${queryName}_consumption`] === 0 || el[`${queryName}_consumption`] 
                    ? el[`${queryName}_consumption`]
                    : ''}
              />
            </div>
        );
        } else {
            dynamicFields.consumption = (
                <div className="td" style={{ height: 30 }}>
                  <input 
                      type="number" 
                      onChange={(e) => {
                        handleChangeDetails(`${queryName}_consumption`, e.target.value, index);
                        handleChange(`${queryName}_consumption`, Number(e.target.value));
                      }}
                      onWheel={(e) => e.target.blur()}
                      value={el[`${queryName}_consumption`] === 0 || el[`${queryName}_consumption`] 
                        ? el[`${queryName}_consumption`]
                        : ''}
                  />
                </div>
            );
            dynamicFields.views = (
                <div className="td" style={{ height: 30 }}>
                  <input 
                      type="number" 
                      onChange={(e) => {
                        handleChangeDetails(`${queryName}_views`, e.target.value, index);
                        handleChange(`${queryName}_views`, Number(e.target.value));
                      }}
                      onWheel={(e) => e.target.blur()}
                      value={el[`${queryName}_views`] === 0 || el[`${queryName}_views`] 
                        ? el[`${queryName}_views`]
                        : ''}
                  />
                </div>
            );
        }
        
        return {
            ...dynamicFields,
            clicks: (
                <div className="td" style={{ height: 30, display: "flex", alignItems: "center" }}>
                  <input 
                    type="number" 
                    onChange={(e) => {
                      handleChangeDetails(`${queryName}_clicks`, e.target.value, index);
                      handleChange(`${queryName}_clicks`, Number(e.target.value));
                    }}
                    onWheel={(e) => e.target.blur()}
                    value={el[`${queryName}_clicks`] === 0 || el[`${queryName}_clicks`] 
                      ? el[`${queryName}_clicks`]
                      : ''}
                  />
                </div>
            ),
            leads: (
                <div className="td" style={{ height: 30 }}>
                  <input 
                      type="number" 
                      onChange={(e) => {
                        handleChangeDetails(`${queryName}_leads`, e.target.value, index);
                        handleChange(`${queryName}_leads`, Number(e.target.value));
                      }}
                      onWheel={(e) => e.target.blur()}
                      value={el[`${queryName}_leads`] === 0 || el[`${queryName}_leads`] 
                        ? el[`${queryName}_leads`]
                        : ''}
                  />
                </div>
            ),
            ecpc: (
                <div className="td" style={{ height: 30, display: "flex", alignItems: "center" }}>
                    {Number.isInteger(el[`${queryName}_ecpc`]) 
                      ? el[`${queryName}_ecpc`] 
                      : el[`${queryName}_ecpc`]?.toFixed(2) || ''}
                </div>
            ),
        };
    });
}


  const filteredGoals = goalsListOptions.filter((goal) =>
    goal.name.toLowerCase().includes(searchGoals.toLowerCase())
  );

  const filteredStaffAccount = arrStaff.filter((employee) =>
    employee.full_name?.toLowerCase().includes(searchStaffAccount.toLowerCase())
  );

  const filteredStaffContext = arrStaff.filter((employee) =>
    employee.full_name?.toLowerCase().includes(searchStaffContext.toLowerCase())
  );

  const filteredStaffTraffic = arrStaff.filter((employee) =>
    employee.full_name?.toLowerCase().includes(searchStaffTraffic.toLowerCase())
  );


  const goalsOptions = ["Лидогенерация", "Охват", "ДРР"]
  const attributionsOptions = ["Автоматическая атрибуция", "Последний значимый источник", "Последний переход из Директа", "Последний источник", "Последний значимый источник (Кросс-девайс)", "Последний переход из Директа (Кросс-девайс)", "Последний источник (Кросс-девайс)", "Первый источник трафика", "Первый источник трафика (Кросс-девайс)", "Один из источников трафика"]
  
  const handleCloseListGoals = (changesListGoals) => {
    const filteredGoals = changesListGoals.filter(goal => goal);
    handleChange('list_of_goals', filteredGoals.join(','), true);
  }

  function getTableData() {

    return filterArr.map((el) => {
      return {
        project: (
          <div className="td" style={{ height: 30, width: "100%" }}>
            <InputCustomArea value={el.project} handleChange={(value) => handleChange('project', value)} />
          </div>
        ),
        domain: <div className="td">{el.domain}</div>,
        goal: (
          <Box sx={{ width: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Цель РК
              </InputLabel>
              <Select
                defaultValue={el.goal || "0"}
                onChange={(e) => handleChange('goal', e.target.value, true)}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="Цель РК"
                id="demo-select-small"
              >
                <MenuItem value="0">Нет</MenuItem>
                {goalsOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        calltracking: (
          <Box sx={{ width: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                CallTracking
              </InputLabel>
              <Select
                onChange={(e) => handleChange('calltracking', e.target.value, true)}
                defaultValue={el.calltracking || "нет, не планируют"}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="CallTracking"
                id="demo-select-small"
              >
                <MenuItem value="нет, не планируют">нет, не планируют</MenuItem>
                {calltrackingOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        attribution: (
          <Box sx={{ width: 240, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Атрибуция по лидам
              </InputLabel>
              <Select
                onChange={(e) => handleChange('attribution', e.target.value, true)}
                defaultValue={el.attribution || "Нет"}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="CallTracking"
                id="demo-select-small"
              >
                <MenuItem value="Нет">Нет</MenuItem>
                {attributionsOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        list_of_goals: (
          <ListOfGoals goalsListOptions={goalsListOptions} filteredGoals={filteredGoals} setSearchGoals={setSearchGoals} setSearchStaffAccount={setSearchStaffAccount} handleCloseListGoals={handleCloseListGoals} defaultGoals={listGoals} />
        ),
        geo: <RegionSelect defaultValue={el.geo} regions={regionsData} handleChange={handleChange} />,
        landing_pages: <div className="td" style={{ height: 30 }}>
          <InputCustomArea value={el.landing_pages} handleChange={(value) => handleChange('landing_pages', value)} />
        </div>,
        yametrika_name: <div className="td" style={{ height: 30 }}>
          <InputCustomArea value={el.yametrika_name} handleChange={(value) => handleChange('yametrika_name', value)} />
        </div>,
        campaign_ids: <CampaignsSelect defaultValue={el.campaign_ids} campaigns={campaigns} handleChange={handleChange} />,
        counter_id: (
          <Box sx={{ width: 250, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Счётчик
              </InputLabel>
              <Select
                onChange={(e) => handleChange('counter_id', e.target.value === "Нет" ? null : e.target.value, true)}
                defaultValue={el.counter_id}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="CallTracking"
                id="demo-select-small"
                renderValue={(selected) => {
                  const selectedCounter = counters.find((counter) => counter.id === selected);
                  return selectedCounter ? (
                    <p style={{ fontSize: 14 }}>{selectedCounter.name} - {selectedCounter.ya_metrika_id}</p>
                  ) : "Счётчик";
                }}
              >
                {counters?.map((el) => (
                  <MenuItem key={el.id} value={el.id}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p style={{ fontSize: 14 }}>{el.name} - {el.ya_metrika_id}</p>
                      <p style={{ fontSize: 12, color: "#727272" }}>Создан: {new Date(el.created_at).toLocaleDateString("ru-RU")}</p>
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        account_manager: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Аккаунт менеджер 1
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-account").focus(), 100)}
                  onChange={(e) => handleChange('account_manager', e.target.value === "Нет" ? null : e.target.value, true)}
                  defaultValue={el.account_manager || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffAccount(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-account"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffAccount(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-account").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffAccount.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.account_manager)?.full_name || "Нет"
          ),
        account_manager_1: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Аккаунт менеджер 2
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-account").focus(), 100)}
                  onChange={(e) => handleChange('account_manager_1', e.target.value === "Нет" ? null : e.target.value, true)}
                  defaultValue={el.account_manager_1 || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffAccount1(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-account"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffAccount1(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-account").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffAccount.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.account_manager_1)?.full_name || "Нет"
          ),
        contextologist: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Контекстолог
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-contextologist").focus(), 100)}
                  onChange={(e) => handleChange('contextologist', e.target.value === "Нет" ? null : e.target.value, true)}
                  defaultValue={el.contextologist || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffContext(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-contextologist"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffContext(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-contextologist").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffContext.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.contextologist)?.full_name || "Нет"
          ),
        traffic_manager: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Трафик менеджер
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-traffic").focus(), 100)}
                  onChange={(e) => handleChange('traffic_manager', e.target.value === "Нет" ? null : e.target.value, true)}
                  defaultValue={el.traffic_manager || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffTraffic(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-traffic"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffTraffic(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-traffic").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffTraffic.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.traffic_manager)?.full_name || "Нет"
          ),
        start_cycle_date: <div className="td" style={{ height: 40 }}>
          <DatePickerTest defaultValue={el.start_cycle_date} onChange={(date) => handleChange('start_cycle_date', Math.floor(new Date(date).getTime() / 1000), true)} />
        </div>,
        end_cycle_date: <div className="td" style={{ height: 40 }}>
          <DatePickerTest defaultValue={el.end_cycle_date} onChange={(date) => handleChange('end_cycle_date', Math.floor(new Date(date).getTime() / 1000), true)} />
        </div>,
      };
    });
  }





  
  function getTableDataArchive() {

    return filterArchive.map((el) => {
      return {
        project: (
          <div className="td" style={{ height: 30 }}>
            <InputCustomArea value={el.project} disabled />
          </div>
        ),
        domain: <div className="td">{el.domain}</div>,
        goal: (
          <Box sx={{ width: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Цель РК
              </InputLabel>
              <Select
                defaultValue={el.goal || "0"}
                disabled
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="Цель РК"
                id="demo-select-small"
              >
                <MenuItem value="0">Нет</MenuItem>
                {goalsOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        calltracking: (
          <Box sx={{ width: 200, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                CallTracking
              </InputLabel>
              <Select
                disabled
                defaultValue={el.calltracking || "нет, не планируют"}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="CallTracking"
                id="demo-select-small"
              >
                <MenuItem value="нет, не планируют">нет, не планируют</MenuItem>
                {calltrackingOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        attribution: (
          <Box sx={{ width: 240, textAlign: "start", padding: "2px 0", height: 30 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-select-small-label"
                sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
              >
                Атрибуция по лидам
              </InputLabel>
              <Select
                disabled
                defaultValue={el.attribution || "Нет"}
                style={{
                  height: 32,
                  margin: "0 10px",
                  background: "#FFFFFF",
                  borderColor: "transparent",
                }}
                sx={{
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }}
                label="CallTracking"
                id="demo-select-small"
              >
                <MenuItem value="Нет">Нет</MenuItem>
                {attributionsOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ),
        list_of_goals: (
          <ListOfGoals goalsListOptions={goalsListOptions} filteredGoals={filteredGoals} setSearchGoals={setSearchGoals} setSearchStaffAccount={setSearchStaffAccount} handleCloseListGoals={handleCloseListGoals} defaultGoals={listGoals} disabled={true}/>
        ),
        geo: <RegionSelect defaultValue={el.geo} regions={regionsData} handleChange={handleChange} disabled={true}/>,
        landing_pages: <div className="td" style={{ height: 30 }}>
          <InputCustomArea value={el.landing_pages} handleChange={(value) => handleChange('landing_pages', value)} disabled={true} />
        </div>,
        yametrika_name: <div className="td" style={{ height: 30 }}>
          <InputCustomArea value={el.yametrika_name} handleChange={(value) => handleChange('yametrika_name', value)} disabled={true} />
        </div>,
        account_manager: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Аккаунт менеджер 1
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-account").focus(), 100)}
                  disabled
                  defaultValue={el.account_manager || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffAccount(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-account"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffAccount(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-account").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffAccount.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.account_manager)?.full_name || "Нет"
          ),
        account_manager_1: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Аккаунт менеджер 2
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-account").focus(), 100)}
                  disabled
                  defaultValue={el.account_manager_1 || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffAccount1(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-account"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffAccount1(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-account").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffAccount.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.account_manager_1)?.full_name || "Нет"
          ),
        contextologist: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Контекстолог
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-contextologist").focus(), 100)}
                  disabled
                  defaultValue={el.contextologist || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffContext(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-contextologist"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffContext(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-contextologist").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffContext.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.contextologist)?.full_name || "Нет"
          ),
        traffic_manager: 
          ["ADMIN", "SUPERUSER"].some((el) => el === role) ? (
            <Box sx={{ width: 220, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Трафик менеджер
                </InputLabel>
                <Select
                  onOpen={() => setTimeout(() => document.getElementById("search-input-traffic").focus(), 100)}
                  disabled
                  defaultValue={el.traffic_manager || "Нет"}
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="CallTracking"
                  id="demo-select-small"
                  onClose={() => setTimeout(() => setSearchStaffTraffic(""), 300)}
                >
                  <ListSubheader>
                    <TextField
                      id="search-input-traffic"
                      size="small"
                      autoFocus
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchStaffTraffic(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setTimeout(() => document.getElementById("search-input-traffic").focus(), 100)
                        }
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value="Нет">Нет</MenuItem>
                  {filteredStaffTraffic.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      {staff.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            arrStaff.find((staff) => staff.id === el.traffic_manager)?.full_name || "Нет"
          ),
        start_cycle_date: <div className="td" style={{ height: 40 }}>
          <DatePickerTest defaultValue={Math.floor(new Date(el.start_cycle_date).getTime() / 1000)} onChange={(date) => handleChange('start_cycle_date', Math.floor(new Date(date).getTime() / 1000), true)} disabled={true} />
        </div>,
        end_cycle_date: <div className="td" style={{ height: 40 }}>
          <DatePickerTest defaultValue={Math.floor(new Date(el.end_cycle_date).getTime() / 1000)} onChange={(date) => handleChange('end_cycle_date', Math.floor(new Date(date).getTime() / 1000), true)} disabled={true} />
        </div>,
      };
    });
  }


  

  const tableDetailsOptions = [
    {
      name: "Я.ПОИСК PRG1",
      value: "PRG1",
      query: "yasearch"
    },
    {
      name: "РСЯ PRG2",
      value: "PRG2",
      query: "rsy"
    },
    {
      name: "ЯНДЕКС РЕТАРГЕТ PRG10",
      value: "PRG10",
      query: "yaretarget"
    },
    {
      name: "ЯНДЕКС ДПО PRG11",
      value: "PRG11",
      query: "yadpo"
    },
    {
      name: "ТОВАРКА ИЛИ МК PRG12",
      value: "PRG12",
      query: "tov_or_mk"
    },
    {
      name: "ЯНДЕКС СМАРТ PRG22",
      value: "PRG22",
      query: "yasmart"
    },
    {
      name: "ИНВОЛТРА PRG8",
      value: "PRG8",
      query: "involtra"
    },
    {
      name: "MYBID ₽ PRG80",
      value: "PRG80",
      query: "mybid"
    },
    {
      name: "RICHADS ₽ PRG81",
      value: "PRG81",
      query: "rich_ads"
    },
    {
      name: "БИДВЕРТ ₽ PRG84",
      value: "PRG84",
      query: "bidvert"
    },
    {
      name: "ZEROPARK ₽ PRG82",
      value: "PRG82",
      query: "zeropark"
    },
    {
      name: "SSP PRG4",
      value: "PRG4",
      query: "ssp_prg4"
    },
    {
      name: "SSP PRG5",
      value: "PRG5",
      query: "ssp_prg5"
    },
    {
      name: "SSP PRG6",
      value: "PRG6",
      query: "ssp_prg6"
    },
    {
      name: "SSP PRG7",
      value: "PRG7",
      query: "ssp_prg7"
    },
    {
      name: "Яндекс Охватная PRG13",
      value: "PRG13",
      query: "ya_ohvat"
    },
    {
      name: "Баннеры Я.Поиск PRG14",
      value: "PRG14",
      query: "banners_yasearch"
    },
    {
      name: "Sape PRG86",
      value: "PRG86",
      query: "sape"
    },
    {
      name: "Getintent PRG87",
      value: "PRG87",
      query: "getintent"
    },
    {
      name: "Hybrid PRG88",
      value: "PRG88",
      query: "hybrid"
    }
  ]

  const handleDateChange = (value) => {
    const startDate = new Date(value[0]);
    const endDate = new Date(value[1]);
  
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
  
    setGraphDate(() => ({
      date0: Math.floor(startDate.getTime() / 1000),
      date1: Math.floor(endDate.getTime() / 1000),
    }));
  };

  // const handleWheel = (e) => {
  //   e.preventDefault();
  //   const scrollAmount = e.deltaY * 0.8;
  //   e.currentTarget.scrollLeft += scrollAmount;
  // };

  const svodDetailsKeys = {
    leads_qual: "Лиды Квал. факт",
    clicks: "КЛИКИ факт",
    leads: "ЛИДЫ Вал. факт",
    consumption: "БЮДЖЕТ факт. расход",
    views: "ПОКАЗЫ факт",
  }

  const handleDetailsDateChange = (value) => {
    const selectedDate = new Date(value);
    const currentDate = new Date();

    console.debug(selectedDate, currentDate);
    const fieldSuffixes = ['_consumption', '_clicks', '_views', '_leads', '_consumption_dol'];
  
    if (selectedDate > currentDate) {
      enqueueSnackbar("Нельзя выбрать дату больше сегодняшней.", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
  
    const hasFieldsToUpdate = fieldsToUpdate.some(fieldObj =>
      fieldSuffixes.some(suffix => fieldObj.field.endsWith(suffix))
    );
  
    if (hasFieldsToUpdate) {
      const confirmChange = window.confirm(
        "У вас есть несохраненные изменения за текущий день. Вы уверены, что хотите сменить дату и потерять все изменения?"
      );
  
      if (confirmChange) {
        const updatedFields = fieldsToUpdate.filter(fieldObj =>
          !fieldSuffixes.some(suffix => fieldObj.field.endsWith(suffix))
        );
        setFieldsToUpdate(updatedFields);
      } else {
        return;
      }
    }
    
    const newDate = getMoscowMidnight(value);
    setDetailsDate(newDate);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('details_date', String(newDate));
    }
  };

  const refreshArchiveData = async () => {
    if (!selectedCycleId) return;
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));

    try {
      const responseCycleLog = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/get-latest-log-by-cycle?_id=${selectedCycleId}`, {
        method: "GET",
        headers: myHeaders,
      });
      
      if (responseCycleLog.ok) {
        const data = await responseCycleLog.json();
        if (data.income_vat === null || data.income_vat === undefined) {
          data.income_vat = 0;
        }
        setFilterArchive([data]);
        setOtherConsumptionsArchive(data.other_consumptions || []);
        
        enqueueSnackbar("Данные архива успешно обновлены.", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        enqueueSnackbar("Ошибка при обновлении данных архива.", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
      enqueueSnackbar("Ошибка при обновлении данных архива.", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  return (
    <div>
      <button onClick={() => setSaveFields(true)} style={{ backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", height: 35, borderRadius: 5, position: "absolute", right: 190, top: 30 }}>Сохранить</button>
      <button onClick={() => setCloseModal(true)} style={{ backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", height: 35, borderRadius: 5, position: "absolute", right: 30, top: 30 }}>Сохранить и выйти</button>

      <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "20px"}}>
        <div style={{ width: "100%", overflowX: "auto", scrollbarWidth: "none" }}>
          <DataTable data={getTableData()} columns={columns} />
        </div>
      </div>

      <h2 style={{ marginBottom: "10px" }}>Свод</h2>
      <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "30px"}}>
        <div style={{ width: "100%", overflowX: "auto", scrollbarWidth: "none" }}>
          <DataTable key={String(upd)} data={getTableDataSvod()} columns={columnsSvod} />
        </div>
        {
          openSvod && (
            <div style={{ margin: "20px 0", paddingLeft: 25 }}>

              <div style={{ display: "flex", gap: "50px", marginBottom: "10px" }}>
                <h2 style={{ marginBottom: "10px", fontSize: 16 }}>{svodDetailsKeys[svodDetails]}</h2>
                <button onClick={() => setOpenSvod(false)} style={{ backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", height: 25, fontSize: 14, borderRadius: 5 }}>Закрыть детализацию</button>
              </div>

              <DataTable data={getTableDataSvodDetails()} columns={columnsSvodDetails} />
            </div>
          )
        }
      </div>

      <div style={{ display: "flex", gap: 40}}>
        <div style={{ width: "fit-content" }}>
          <div>
            <div style={{ display: "flex", gap: "16px", marginBottom: "10px", alignItems: "center" }}>
              <h2>Детализация</h2>
              <Box sx={{ width: "fit-content", textAlign: "start", paddingTop: "6px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    id="demo-select-small-label"
                    sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                  >
                    Таблица
                  </InputLabel>
                  <Select
                    defaultValue={"PRG1"}
                    onChange={(e) => {
                      setSpecForDetails(e.target.value);
                    }}
                    style={{
                      height: 32,
                      background: "#FFFFFF",
                      borderColor: "transparent",
                    }}
                    sx={{
                      "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                    }}
                    label="CallTracking"
                    id="demo-select-small"
                  >
                    {tableDetailsOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <div style={{ width: "fit-content", display: "flex", gap: "20px" }}>
                <h3 style={{ paddingTop: "11px" }}>за день:</h3>
                <div style={{ width: "150px" }}>
                  <DatePickerTest value={detailsDate} onChange={(date) => handleDetailsDateChange(date)} />
                </div>
              </div>
            </div>
            <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "20px" }}>
              <div style={{ width: "100%", overflowX: "auto", scrollbarWidth: "none", '-ms-overflow-style': 'none' }}>
                <DataTable data={getTableDataDetails()} columns={getColumnsDetails()} />
              </div>
            </div>
            <div style={{ display: "flex", gap: "20px"}}>
              {lastDetailsUpdate.lastClicksUpdate?.email && (
                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  <p style={{ fontSize: "14px", fontWeight: "bold" }}>Клики были изменены</p>
                  <p>Время изменения: {new Date(lastDetailsUpdate.lastClicksUpdate.datetime * 1000).toLocaleString("ru-RU")}</p>
                  <p>Почта менеджера: {lastDetailsUpdate.lastClicksUpdate.email}</p>
                </div>
              )}
              {lastDetailsUpdate.lastLeadsUpdate?.email && (
                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  <p style={{ fontSize: "14px", fontWeight: "bold" }}>Лиды были изменены</p>
                  <p>Время изменения: {new Date(lastDetailsUpdate.lastLeadsUpdate.datetime * 1000).toLocaleString("ru-RU")}</p>
                  <p>Почта менеджера: {lastDetailsUpdate.lastLeadsUpdate.email}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ width: "fit-content", marginBottom: "10px"}}>
          <div style={{ display: "flex", gap: "16px", marginBottom: "10px", alignItems: "center", paddingTop: "6px" }}>
            <h2>Лимиты</h2>
          </div>
          <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "10px" }}>
            <div style={{ width: "100%", overflowX: "auto", scrollbarWidth: "none", '-ms-overflow-style': 'none' }}>
              <DataTable data={getTableDataLimits()} columns={columnsLimits} />
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <TextField
              multiline
              size="small"
              maxRows={8}
              placeholder="Комментарий"
              style={{ width: "100%" }}
              value={commentValue}
              onChange={(e) => {
                setCommentValue(e.target.value);
                handleChange("comment_involtra", e.target.value);
              }}
            />
          </div>
        </div>

        <div style={{ width: "100%", marginBottom: "10px"}}>
          <div style={{ display: "flex", gap: "16px", marginBottom: "10px", alignItems: "center", paddingTop: "6px" }}>
            <h2>Остальные затраты</h2>
          </div>
          <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "10px" }}>
            {otherConsumptions.length > 0 ? <div>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "230px", overflowY: "auto" }}>
                {otherConsumptions.map((el, index) => (
                  <div key={index} style={{
                    backgroundColor: "white",
                    padding: "16px 20px",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    transition: "all 0.2s ease"
                  }}>
                    <div style={{
                      color: "#495057",
                      fontSize: "14px",
                      fontWeight: "500",
                      flex: "1"
                    }}>
                      <p style={{ margin: 0, fontSize: 12, fontWeight: "500", opacity: "70%" }}>Комментарий</p>
                      <p style={{ fontSize: 15, fontWeight: "500", margin: 0 }}>{el.comment}</p>
                    </div>
                    <div style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      minWidth: "80px",
                      textAlign: "center",
                      marginRight: "12px"
                    }}>
                      {el.value.toLocaleString("ru-RU")} {el.value_type === "currency" ? "₽" : "%"}
                    </div>
                    <button
                      onClick={() => {
                        setOtherConsumptionModalMode('edit');
                        setEditingOtherConsumptionIndex(index);
                        setNewOtherConsumption({ ...el });
                        setOpenOtherConsumptionsModal(true);
                      }}
                      style={{
                        padding: "6px 8px",
                        border: "1px solid #d1d9e0", 
                        backgroundColor: "#ffffff", 
                        borderRadius: "4px",
                        color: "#6c757d", 
                        fontSize: "12px",
                        cursor: "pointer",
                        transition: "background-color 0.2s ease"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#f8f9fa";
                        e.target.style.borderColor = "#adb5bd";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#ffffff";
                        e.target.style.borderColor = "#d1d9e0";
                      }}
                      title="Редактировать"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-pen-line-icon lucide-pen-line"><path d="M12 20h9"/><path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"/></svg>
                    </button>
                  </div>
                ))}
              </div>
            </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", padding: "20px" }}>
              <p style={{ fontSize: 14, fontWeight: "500", color: "#6c757d" }}>Нет остальных затрат</p>
            </div>}
          </div>
          {openOtherConsumptionsModal && (
            <div style={{ 
              padding: "20px", 
              border: "1px solid #e0e6ed", 
              borderRadius: "8px", 
              marginBottom: "15px"
            }}>
              <h3 style={{ 
                margin: "0 0 20px 0", 
                fontSize: "16px", 
                fontWeight: "500", 
                color: "#2c3e50" 
              }}>
                {otherConsumptionModalMode === 'create' ? 'Создание траты' : 'Редактирование траты'}
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <div>
                  <label style={{ 
                    display: "block", 
                    marginBottom: "6px", 
                    fontSize: "14px", 
                    fontWeight: "500", 
                    color: "#34495e" 
                  }}>
                    Комментарий
                  </label>
                  <input
                    type="text"
                    value={newOtherConsumption.comment}
                    onChange={(e) => setNewOtherConsumption({ ...newOtherConsumption, comment: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "1px solid #d1d9e0",
                      borderRadius: "6px",
                      fontSize: "14px",
                      outline: "none",
                      transition: "border-color 0.2s ease",
                      backgroundColor: "#ffffff"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                    onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                  />
                </div>
                <div style={{ display: "flex", gap: "12px" }}>
                  <div style={{ flex: "1" }}>
                    <label style={{ 
                      display: "block", 
                      marginBottom: "6px", 
                      fontSize: "14px", 
                      fontWeight: "500", 
                      color: "#34495e" 
                    }}>
                      Значение
                    </label>
                    <input
                      type="number"
                      value={newOtherConsumption.value}
                      onChange={(e) => setNewOtherConsumption({ ...newOtherConsumption, value: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        border: "1px solid #d1d9e0",
                        borderRadius: "6px",
                        fontSize: "14px",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                        backgroundColor: "#ffffff"
                      }}
                      onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                      onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                    />
                  </div>
                  <div style={{ flex: "1" }}>
                    <label style={{ 
                      display: "block", 
                      marginBottom: "6px", 
                      fontSize: "14px", 
                      fontWeight: "500", 
                      color: "#34495e" 
                    }}>
                      Тип
                    </label>
                    <select
                      value={newOtherConsumption.value_type}
                      onChange={(e) => setNewOtherConsumption({ ...newOtherConsumption, value_type: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "5px 12px",
                        border: "1px solid #d1d9e0",
                        borderRadius: "6px",
                        fontSize: "14px",
                        outline: "none",
                        backgroundColor: "#ffffff",
                        cursor: "pointer"
                      }}
                      onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                      onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                    >
                      <option value="currency">Валюта</option>
                      <option value="percent">Процент</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", gap: "10px", marginTop: "20px", justifyContent: otherConsumptionModalMode === 'edit' ? "space-between" : "flex-end" }}>
                {otherConsumptionModalMode === 'edit' && (
                  <button 
                    onClick={() => {
                      const updated = otherConsumptions.filter((_, i) => i !== editingOtherConsumptionIndex);
                      setOtherConsumptions(updated);
                      handleChange("other_consumptions", updated, false, false, true);
                      setNewOtherConsumption({
                        comment: '',
                        value: '',
                        value_type: 'currency'
                      });
                      setOtherConsumptionModalMode('create');
                      setEditingOtherConsumptionIndex(null);
                      setOpenOtherConsumptionsModal(false);
                    }}
                    style={{ 
                      padding: "8px 16px", 
                      border: "none", 
                      borderRadius: "6px", 
                      backgroundColor: "#dc3545", 
                      color: "#ffffff", 
                      fontSize: "14px", 
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#c82333"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#dc3545"}
                  >
                    Удалить
                  </button>
                )}
                <div style={{ display: "flex", gap: "10px" }}>
                  <button 
                    onClick={() => {
                      setNewOtherConsumption({
                        comment: '',
                        value: '',
                        value_type: 'currency'
                      });
                      setOtherConsumptionModalMode('create');
                      setEditingOtherConsumptionIndex(null);
                      setOpenOtherConsumptionsModal(false);
                    }}
                    style={{ 
                      padding: "8px 16px", 
                      border: "1px solid #d1d9e0", 
                      borderRadius: "6px", 
                      backgroundColor: "#ffffff", 
                      color: "#6c757d", 
                      fontSize: "14px", 
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                      e.target.style.borderColor = "#adb5bd";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#ffffff";
                      e.target.style.borderColor = "#d1d9e0";
                    }}
                  >
                    Закрыть
                  </button>
                  <button 
                    onClick={() => {
                      if (newOtherConsumption.comment && newOtherConsumption.value) {
                        const toNumber = (arr) => arr.map(item => ({ ...item, value: Number(item.value) }));
                        if (otherConsumptionModalMode === 'create') {
                          const updated = [...otherConsumptions, newOtherConsumption];
                          setOtherConsumptions(updated);
                          handleChange("other_consumptions", toNumber(updated), false, false, true);
                        } else {
                          const updated = [...otherConsumptions];
                          updated[editingOtherConsumptionIndex] = { ...newOtherConsumption };
                          setOtherConsumptions(updated);
                          handleChange("other_consumptions", toNumber(updated), false, false, true);
                        }
                        setNewOtherConsumption({
                          comment: '',
                          value: '',
                          value_type: 'currency'
                        });
                        setOtherConsumptionModalMode('create');
                        setEditingOtherConsumptionIndex(null);
                        setOpenOtherConsumptionsModal(false);
                      }
                    }}
                    style={{ 
                      padding: "8px 16px", 
                      border: "none", 
                      borderRadius: "6px", 
                      backgroundColor: "#3f73f9", 
                      color: "#ffffff", 
                      fontSize: "14px", 
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#2c5aa0"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#3f73f9"}
                  >
                    Сохранить
                  </button>
                </div>
              </div>
            </div>
          )}
          {!openOtherConsumptionsModal && 
            <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "flex-end", alignItems: "center" }}>
              <button 
                style={{ 
                  backgroundColor: "#dfe8ff", 
                  color: "#3f73f9", 
                  width: "fit-content", 
                  padding: "3px 15px", 
                  height: 25, 
                  fontSize: 14, 
                  borderRadius: 5, 
                  border: "none", 
                  cursor: "pointer" 
                }} 
                onClick={() => {
                  setOtherConsumptionModalMode('create');
                  setEditingOtherConsumptionIndex(null);
                  setNewOtherConsumption({
                    comment: '',
                    value: '',
                    value_type: 'currency'
                  });
                  setOpenOtherConsumptionsModal(true);
                }}
              >
                Создать трату
              </button>
            </div>
          }
        </div>
      </div>



      <div style={{ marginBottom: "20px", marginTop: "30px" }}>
        <div style={{ display: "flex", gap: "25px" }}>
          <h2 style={{ marginBottom: "20px" }}>Графики</h2>
          <div style={{ width: "500px" }}>
            <DateFromTo
              from={new Date(new Date().setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000).getTime()}
              to={new Date(new Date().setHours(23, 59, 59, 999)).getTime()}
              handleChange={handleDateChange}
            />
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "20px" }}>
          <GraphComponent report_id={report_id} dates={graphDate} spec={2} />  
          <GraphComponent report_id={report_id} dates={graphDate} spec={3} />  
        </div>
      </div>

      <div style={{ marginTop: "60px" }}>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px", alignItems: "center" }}>
          <h2>Архив проекта за</h2>
          <div style={{ width: "fit-content" }}>
            <Box sx={{ width: "fit-content", minWidth: 150, textAlign: "start", padding: "2px 0", height: 30 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Цикл проекта
                </InputLabel>
                <Select
                  value={cycles.length > 0 ? selectedCycleId : ""}
                  onChange={(e) => setSelectedCycleId(e.target.value)}
                  displayEmpty
                  style={{
                    height: 32,
                    margin: "0 10px",
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="Цикл проекта"
                  id="demo-select-small"
                >
                  {cycles.length > 0 ? (
                    cycles.map((option, index) => (
                      <MenuItem style={{ fontSize: 14 }} key={option.id} value={option.id}>
                          {`${index + 1}. ${formatCycleDate(option.start_cycle_date)} - ${formatCycleDate(option.end_cycle_date)}`}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      Циклы не найдены
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </div>
          <button
            onClick={refreshArchiveData}
            disabled={!selectedCycleId}
            style={{
              backgroundColor: selectedCycleId ? "#dfe8ff" : "#f0f0f0",
              color: selectedCycleId ? "#3f73f9" : "#999",
              padding: "5px 20px",
              fontSize: 14,
              borderRadius: 5,
              marginTop: "2px",
              border: "none",
              cursor: selectedCycleId ? "pointer" : "not-allowed",
            }}
          >
            Обновить данные
          </button>
        </div>
        <div style={{ padding: 20, border: "1px solid #E0E0E0", borderRadius: 10 }}>
          <div>
            <h2 style={{ fontSize: 18 }}>Шапка</h2>
            <div style={{ width: "100%", overflowX: "auto", paddingBottom: "20px", scrollbarWidth: "none" }}>
              <DataTable data={getTableDataArchive()} columns={columns} />
            </div>
          </div>
          <div>
            <h2 style={{ fontSize: 18 }}>Свод</h2>
            <div style={{ width: "100%", overflowX: "auto", paddingBottom: "20px", scrollbarWidth: "none" }}>
              <DataTable data={getTableDataSvodArchive()} columns={columnsSvod} />
            </div>
          </div>
          {
            openSvodArchive && (
              <div style={{ margin: "20px 0", paddingLeft: 25 }}>

                <div style={{ display: "flex", gap: "50px", marginBottom: "10px" }}>
                  <h2 style={{ marginBottom: "10px", fontSize: 16 }}>{svodDetailsKeys[svodDetailsArchive]}</h2>
                  <button onClick={() => setOpenSvodArchive(false)} style={{ backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", height: 25, fontSize: 14, borderRadius: 5 }}>Закрыть детализацию</button>
                </div>

                <DataTable data={getTableDataSvodDetailsArchive()} columns={columnsSvodDetails} />
              </div>
            )
          }
          {selectedCycleId && (
            <div style={{ width: "400px", marginBottom: "10px"}}>
              <div style={{ display: "flex", gap: "16px", marginBottom: "10px", alignItems: "center", paddingTop: "6px" }}>
                <h2>Остальные затраты</h2>
              </div>
              <div style={{ padding: 10, border: "1px solid #E0E0E0", borderRadius: 10, marginBottom: "10px" }}>
                {otherConsumptionsArchive.length > 0 ? <div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "230px", overflowY: "auto" }}>
                    {otherConsumptionsArchive.map((el, index) => (
                      <div key={index} style={{
                        backgroundColor: "white",
                        padding: "16px 20px",
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        transition: "all 0.2s ease"
                      }}>
                        <div style={{
                          color: "#495057",
                          fontSize: "14px",
                          fontWeight: "500",
                          flex: "1"
                        }}>
                          <p style={{ margin: 0, fontSize: 12, fontWeight: "500", opacity: "70%" }}>Комментарий</p>
                          <p style={{ fontSize: 15, fontWeight: "500", margin: 0 }}>{el.comment}</p>
                        </div>
                        <div style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          minWidth: "80px",
                          textAlign: "center",
                          marginRight: "12px"
                        }}>
                          {el.value.toLocaleString("ru-RU")} {el.value_type === "currency" ? "₽" : "%"}
                        </div>
                        <button
                          onClick={() => {
                            setOtherConsumptionModalModeArchive('edit');
                            setEditingOtherConsumptionIndexArchive(index);
                            setNewOtherConsumptionArchive({ ...el });
                            setOpenOtherConsumptionsModalArchive(true);
                          }}
                          style={{
                            padding: "6px 8px",
                            border: "1px solid #d1d9e0", 
                            backgroundColor: "#ffffff", 
                            borderRadius: "4px",
                            color: "#6c757d", 
                            fontSize: "12px",
                            cursor: "pointer",
                            transition: "background-color 0.2s ease"
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = "#f8f9fa";
                            e.target.style.borderColor = "#adb5bd";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = "#ffffff";
                            e.target.style.borderColor = "#d1d9e0";
                          }}
                          title="Редактировать"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-pen-line-icon lucide-pen-line"><path d="M12 20h9"/><path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a .5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"/></svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", padding: "20px" }}>
                  <p style={{ fontSize: 14, fontWeight: "500", color: "#6c757d" }}>Нет остальных затрат</p>
                </div>}
              </div>
              {openOtherConsumptionsModalArchive && (
                <div style={{ 
                  padding: "20px", 
                  border: "1px solid #e0e6ed", 
                  borderRadius: "8px", 
                  marginBottom: "15px"
                }}>
                  <h3 style={{ 
                    margin: "0 0 20px 0", 
                    fontSize: "16px", 
                    fontWeight: "500", 
                    color: "#2c3e50" 
                  }}>
                    {otherConsumptionModalModeArchive === 'create' ? 'Создание траты' : 'Редактирование траты'}
                  </h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <div>
                      <label style={{ 
                        display: "block", 
                        marginBottom: "6px", 
                        fontSize: "14px", 
                        fontWeight: "500", 
                        color: "#34495e" 
                      }}>
                        Комментарий
                      </label>
                      <input
                        type="text"
                        value={newOtherConsumptionArchive.comment}
                        onChange={(e) => setNewOtherConsumptionArchive({ ...newOtherConsumptionArchive, comment: e.target.value })}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          border: "1px solid #d1d9e0",
                          borderRadius: "6px",
                          fontSize: "14px",
                          outline: "none",
                          transition: "border-color 0.2s ease",
                          backgroundColor: "#ffffff"
                        }}
                        onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                        onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                      />
                    </div>
                    <div style={{ display: "flex", gap: "12px" }}>
                      <div style={{ flex: "1" }}>
                        <label style={{ 
                          display: "block", 
                          marginBottom: "6px", 
                          fontSize: "14px", 
                          fontWeight: "500", 
                          color: "#34495e" 
                        }}>
                          Значение
                        </label>
                        <input
                          type="number"
                          value={newOtherConsumptionArchive.value}
                          onChange={(e) => setNewOtherConsumptionArchive({ ...newOtherConsumptionArchive, value: e.target.value })}
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d9e0",
                            borderRadius: "6px",
                            fontSize: "14px",
                            outline: "none",
                            transition: "border-color 0.2s ease",
                            backgroundColor: "#ffffff"
                          }}
                          onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                          onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                        />
                      </div>
                      <div style={{ flex: "1" }}>
                        <label style={{ 
                          display: "block", 
                          marginBottom: "6px", 
                          fontSize: "14px", 
                          fontWeight: "500", 
                          color: "#34495e" 
                        }}>
                          Тип
                        </label>
                        <select
                          value={newOtherConsumptionArchive.value_type}
                          onChange={(e) => setNewOtherConsumptionArchive({ ...newOtherConsumptionArchive, value_type: e.target.value })}
                          style={{
                            width: "100%",
                            padding: "5px 12px",
                            border: "1px solid #d1d9e0",
                            borderRadius: "6px",
                            fontSize: "14px",
                            outline: "none",
                            backgroundColor: "#ffffff",
                            cursor: "pointer"
                          }}
                          onFocus={(e) => e.target.style.borderColor = "#3f73f9"}
                          onBlur={(e) => e.target.style.borderColor = "#d1d9e0"}
                        >
                          <option value="currency">Валюта</option>
                          <option value="percent">Процент</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "10px", marginTop: "20px", justifyContent: otherConsumptionModalModeArchive === 'edit' ? "space-between" : "flex-end" }}>
                    {otherConsumptionModalModeArchive === 'edit' && (
                      <button 
                        onClick={() => {
                          const updated = otherConsumptionsArchive.filter((_, i) => i !== editingOtherConsumptionIndexArchive);
                          setOtherConsumptionsArchive(updated);
                          handleChange("other_consumptions", updated, false, true, true);
                          setNewOtherConsumptionArchive({
                            comment: '',
                            value: '',
                            value_type: 'currency'
                          });
                          setOtherConsumptionModalModeArchive('create');
                          setEditingOtherConsumptionIndexArchive(null);
                          setOpenOtherConsumptionsModalArchive(false);
                        }}
                        style={{ 
                          padding: "8px 16px", 
                          border: "none", 
                          borderRadius: "6px", 
                          backgroundColor: "#dc3545", 
                          color: "#ffffff", 
                          fontSize: "14px", 
                          fontWeight: "500",
                          cursor: "pointer",
                          transition: "background-color 0.2s ease"
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = "#c82333"}
                        onMouseOut={(e) => e.target.style.backgroundColor = "#dc3545"}
                      >
                        Удалить
                      </button>
                    )}
                    <div style={{ display: "flex", gap: "10px" }}>
                      <button 
                        onClick={() => {
                          setNewOtherConsumptionArchive({
                            comment: '',
                            value: '',
                            value_type: 'currency'
                          });
                          setOtherConsumptionModalModeArchive('create');
                          setEditingOtherConsumptionIndexArchive(null);
                          setOpenOtherConsumptionsModalArchive(false);
                        }}
                        style={{ 
                          padding: "8px 16px", 
                          border: "1px solid #d1d9e0", 
                          borderRadius: "6px", 
                          backgroundColor: "#ffffff", 
                          color: "#6c757d", 
                          fontSize: "14px", 
                          fontWeight: "500",
                          cursor: "pointer",
                          transition: "all 0.2s ease"
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#f8f9fa";
                          e.target.style.borderColor = "#adb5bd";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "#ffffff";
                          e.target.style.borderColor = "#d1d9e0";
                        }}
                      >
                        Закрыть
                      </button>
                      <button 
                        onClick={() => {
                          if (newOtherConsumptionArchive.comment && newOtherConsumptionArchive.value) {
                            const toNumber = (arr) => arr.map(item => ({ ...item, value: Number(item.value) }));
                            if (otherConsumptionModalModeArchive === 'create') {
                              const updated = [...otherConsumptionsArchive, newOtherConsumptionArchive];
                              setOtherConsumptionsArchive(updated);
                              handleChange("other_consumptions", toNumber(updated), false, true, true);
                            } else {
                              const updated = [...otherConsumptionsArchive];
                              updated[editingOtherConsumptionIndexArchive] = { ...newOtherConsumptionArchive };
                              setOtherConsumptionsArchive(updated);
                              handleChange("other_consumptions", toNumber(updated), false, true, true);
                            }
                            setNewOtherConsumptionArchive({
                              comment: '',
                              value: '',
                              value_type: 'currency'
                            });
                            setOtherConsumptionModalModeArchive('create');
                            setEditingOtherConsumptionIndexArchive(null);
                            setOpenOtherConsumptionsModalArchive(false);
                          }
                        }}
                        style={{ 
                          padding: "8px 16px", 
                          border: "none", 
                          borderRadius: "6px", 
                          backgroundColor: "#3f73f9", 
                          color: "#ffffff", 
                          fontSize: "14px", 
                          fontWeight: "500",
                          cursor: "pointer",
                          transition: "background-color 0.2s ease"
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = "#2c5aa0"}
                        onMouseOut={(e) => e.target.style.backgroundColor = "#3f73f9"}
                      >
                        Сохранить
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {!openOtherConsumptionsModalArchive && 
                <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "flex-end", alignItems: "center" }}>
                  <button 
                    style={{ 
                      backgroundColor: "#dfe8ff", 
                      color: "#3f73f9", 
                      width: "fit-content", 
                      padding: "3px 15px", 
                      height: 25, 
                      fontSize: 14, 
                      borderRadius: 5, 
                      border: "none", 
                      cursor: "pointer" 
                    }} 
                    onClick={() => {
                      setOtherConsumptionModalModeArchive('create');
                      setEditingOtherConsumptionIndexArchive(null);
                      setNewOtherConsumptionArchive({
                        comment: '',
                        value: '',
                        value_type: 'currency'
                      });
                      setOpenOtherConsumptionsModalArchive(true);
                    }}
                  >
                    Создать трату
                  </button>
                </div>
              }
            </div>
          )}
        </div>
      </div>

      {openPvSettingsModal && (() => {
        const isPvDirty = JSON.stringify(pvSettingsList) !== JSON.stringify(pvSettingsInitial);
        const closePvModal = () => {
          if (isPvDirty && !window.confirm("Есть несохранённые изменения. Вы уверены, что хотите выйти без сохранения?")) return;
          setOpenPvSettingsModal(false);
        };
        const handlePvSave = async () => {
          const payload = pvSettingsList
            .filter((i) => i.goal_id != null && i.goal_id !== "")
            .map((i) => ({ id: Number(i.goal_id) || i.goal_id, plan: Number(i.plan) || 0 }));
          const newPvPlan = payload.reduce((sum, i) => sum + i.plan, 0);
          setFilterSvod((prev) => prev.map((el) => {
            const newPostviews = pvSettingsList
              .filter((i) => i.goal_id != null && i.goal_id !== "")
              .map((i) => ({ id: Number(i.goal_id) || i.goal_id, goal_id: i.goal_id, plan: Number(i.plan) || 0, fact: i.fact ?? 0 }));
            const newFact = el.postviews_fact ?? 0;
            const newGoal = newPvPlan > 0 ? (newFact / newPvPlan) * 100 : 0;
            return { ...el, postviews: newPostviews, postviews_plan: newPvPlan, postviews_goal: newGoal };
          }));
          await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/update?_id=${report_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
            },
            body: JSON.stringify({ postviews: payload }),
          });
          setPvSettingsInitial(JSON.parse(JSON.stringify(pvSettingsList)));
          setPvWasSaved(true);
          setOpenPvSettingsModal(false);
          setUpd((u) => !u);
        };
        return (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
            onClick={closePvModal}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                marginTop: 4,
                padding: "24px",
                borderRadius: 10,
                backgroundColor: "#fff",
                border: "1px solid #e2e8f0",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                gap: 14,
                width: 520,
                maxWidth: "95vw",
                maxHeight: "90vh",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: 8, borderBottom: "1px solid #e2e8f0" }}>
                <span style={{ fontSize: 16, fontWeight: 600, color: "#1e293b" }}>Настройка PostView</span>
                <button
                  type="button"
                  onClick={closePvModal}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    fontSize: 16,
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                  }}
                >
                  ×
                </button>
              </div>
              <div style={{ display: "flex", gap: 12, fontWeight: 600, fontSize: 12, color: "#475569", paddingBottom: 4 }}>
                <div style={{ flex: "1 1 0", minWidth: 0 }}>Цель</div>
                <div style={{ width: 100, flexShrink: 0 }}>План</div>
                <div style={{ width: 80, flexShrink: 0 }}>Факт</div>
                <div style={{ width: 32 }} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8, overflowY: "auto", maxHeight: 280 }}>
                {pvSettingsList.map((row, idx) => (
                  <div key={idx} style={{ display: "flex", gap: 12, alignItems: "center" }}>
                    <div style={{ flex: "1 1 0", minWidth: 0 }}>
                      <FormControl fullWidth size="small">
                        <Select
                          value={row.goal_id ?? ""}
                          onChange={(e) => setPvSettingsList((prev) => prev.map((r, i) => i === idx ? { ...r, goal_id: e.target.value || null } : r))}
                          displayEmpty
                          sx={{ minHeight: 36 }}
                        >
                          <MenuItem value="">Не выбрано</MenuItem>
                          {goalsListOptions.filter((g) => !additionalGoals.some((a) => a.goal_id === g.goal_id)).map((g) => (
                            <MenuItem key={g.goal_id} value={g.goal_id}>{g.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ width: 100, flexShrink: 0 }}>
                      <input
                        type="number"
                        value={row.plan === "" ? "" : row.plan}
                        onChange={(e) => setPvSettingsList((prev) => prev.map((r, i) => i === idx ? { ...r, plan: e.target.value === "" ? "" : (Number(e.target.value) || 0) } : r))}
                        onBlur={() => setPvSettingsList((prev) => prev.map((r, i) => i === idx ? { ...r, plan: r.plan === "" ? 0 : r.plan } : r))}
                        style={{ width: "100%", padding: "6px 8px", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 14 }}
                      />
                    </div>
                    <div style={{ width: 80, flexShrink: 0, fontSize: 14, color: "#64748b" }}>{row.fact ?? 0}</div>
                    <button
                      type="button"
                      onClick={() => setPvSettingsList((prev) => prev.filter((_, i) => i !== idx))}
                      style={{ width: 28, height: 28, padding: 0, border: "1px solid #e2e8f0", borderRadius: 6, backgroundColor: "#fff", cursor: "pointer", color: "#64748b", fontSize: 16 }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
              <button
                type="button"
                onClick={() => setPvSettingsList((prev) => [...prev, { goal_id: goalsListOptions.filter((g) => !additionalGoals.some((a) => a.goal_id === g.goal_id))[0]?.goal_id ?? null, plan: 0, fact: 0 }])}
                style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #e2e8f0", backgroundColor: "#f8fafc", cursor: "pointer", fontSize: 13, alignSelf: "flex-start" }}
              >
                Добавить строку
              </button>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 4 }}>
                <button
                  type="button"
                  onClick={handlePvSave}
                  style={{ padding: "6px 14px", borderRadius: 6, border: "none", cursor: "pointer", backgroundColor: "#00B35D", color: "#fff", fontSize: 14, fontWeight: 500 }}
                >
                  Сохранить
                </button>
              </div>
            </div>
          </div>
        );
      })()}

    </div>
  )
}



const OpenModal = ({ openModal, setOpenModal, type, report_id, arrStaff, updateField, modalTableElement, field, label, userEmail, onUpdated }) => {
  let modalContent;

  const ModalStats = ({ openModal, setOpenModal, children }) => {
    const closeModal = () => setOpenModal(false);

    const modalStyles = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: openModal ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    };

    return (
      <div style={modalStyles} onClick={closeModal}>
        <div onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  };

  const formatStatusDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  switch (type) {
    case "detail":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={campaignStyles}>
            <div  style={{ display: "flex", justifyContent: "space-between", width: "100%", marginBottom: 10 }}>
              <h2>
                Шапка проекта
              </h2>
            </div>

            {report_id && <OpenCampaign report_id={report_id} arrStaff={arrStaff} setOpenModal={setOpenModal} onUpdated={onUpdated} />}
          </Box>
        </ModalStats>
      );
      break;

    case "marginality":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={{...campaignStyles, width: "85%", height: "fit-content"}}>
            {report_id && <OpenMarginality report_id={report_id} arrStaff={arrStaff} setOpenModal={setOpenModal} />}
          </Box>
        </ModalStats>
      );
      break;

    case "staff":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={staffStyles}>
            <div style={{ display: "flex", width: "100%", gap: 20, flexDirection: "column" }}>
              <h3 style={{ fontSize: 18 }}>
                Проект - {modalTableElement?.project}
              </h3>
              <StaffSelect el={modalTableElement} field={field} label={label} arrStaff={arrStaff} updateField={updateField} />
            </div>
          </Box>
        </ModalStats>
      );
      break;

    case "status": {
      const status = modalTableElement?.status || {};
      const statusValue =
        status && typeof status === "object" ? status.value : null;

      let statusLabel = "Нет";
      let statusColor = "#7A7A7A";
      if (statusValue === true) {
        statusLabel = "OK";
        statusColor = "#00B35D";
      } else if (statusValue === false) {
        statusLabel = "не OK";
        statusColor = "#FF4141";
      }

      const handleChangeStatus = async (value) => {
        const comment = window.prompt(
          "Комментарий к изменению статуса:",
          status.comment || ""
        );
        if (comment === null) return;

        const newStatus = {
          updated_at: new Date().toISOString(),
          value,
          email: userEmail || status.email || "",
          comment,
        };

        await updateField(report_id, "status", newStatus);

        if (typeof onUpdated === "function") {
          onUpdated();
        }

        setOpenModal(false);
      };

      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <div
            style={{
              marginTop: 4,
              padding: "24px",
              borderRadius: 10,
              backgroundColor: "#fff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              display: "flex",
              flexDirection: "column",
              gap: 14,
              width: 480,
              maxWidth: "95vw",
            }}
          >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: 8,
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#1e293b",
                  }}
                >
                  Статус проекта — {modalTableElement?.project}
                </span>
                <button
                  type="button"
                  onClick={() => setOpenModal(false)}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    fontSize: 16,
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                  }}
                >
                  ×
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  fontSize: 14,
                  color: "#0f172a",
                }}
              >
                <div
                  style={{
                    padding: "8px 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 500,
                      color: "#0f172a",
                    }}
                  >
                    Текущий статус
                  </span>
                  <span
                    style={{
                      padding: "4px 10px",
                      borderRadius: 999,
                      backgroundColor:
                        statusLabel === "OK"
                          ? "rgba(0,179,93,0.08)"
                          : statusLabel === "не OK"
                          ? "rgba(255,65,65,0.08)"
                          : "#e2e8f0",
                      color: statusColor,
                      fontWeight: 600,
                      fontSize: 13,
                    }}
                  >
                    {statusLabel}
                  </span>
                </div>

                <div
                  style={{
                    padding: "8px 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 500,
                      color: "#0f172a",
                    }}
                  >
                    Последнее изменение
                  </span>
                  <span style={{ color: "#475569" }}>
                    {formatStatusDate(status.updated_at)}
                  </span>
                </div>

                <div
                  style={{
                    padding: "8px 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 500,
                      color: "#0f172a",
                    }}
                  >
                    Кто изменил
                  </span>
                  <span style={{ color: "#475569" }}>
                    {status.email || "—"}
                  </span>
                </div>

                <div
                  style={{
                    padding: "8px 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 500,
                      color: "#0f172a",
                    }}
                  >
                    Комментарий
                  </span>
                  <div
                    style={{
                      padding: "6px 8px",
                      borderRadius: 6,
                      border: "1px solid #e2e8f0",
                      minHeight: 32,
                      backgroundColor: "#fff",
                      fontSize: 13,
                      color: "#1e293b",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {status.comment || "—"}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 10,
                  marginTop: 4,
                }}
              >
                <button
                  type="button"
                  style={{
                    padding: "6px 14px",
                    borderRadius: 6,
                    border: "1px solid #e2e8f0",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    color: "#FF4141",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  onClick={() => handleChangeStatus(false)}
                >
                  Сделать не OK
                </button>
                <button
                  type="button"
                  style={{
                    padding: "6px 14px",
                    borderRadius: 6,
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "#00B35D",
                    color: "#ffffff",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  onClick={() => handleChangeStatus(true)}
                >
                  Сделать OK
                </button>
              </div>
            </div>
        </ModalStats>
      );
      break;
    }

    default:
      modalContent = null;
  }

  return modalContent;
};

function CampaignsReports() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeReportTab = searchParams.get("reportTab") === "retargeo" ? "retargeo" : "production";
  const [arrStaff, setStaff] = useState([]);
  const [filterArr, setFilter] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTableElement, setModalTableElement] = useState({});
  const [report_id, setReport_id] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [page, setPage] = useState("all");
  const [isLoading, setIsLoading] = useState(false);

  const [searchValue, setSearchValue] = useState({
    project: '',
    domain: '',
    manager: ''
  });
  const [upd, setUpd] = useState(false);
  // const { link } = useYaRequest();
  const { role, user } = useAdminUser();

  const [selectedDomains, setSelectedDomains] = useState([]);
  const [onlyImportant, setOnlyImportant] = useState(false);
  const [importantProjects, setImportantProjects] = useState([]);
  const [expandedDomains, setExpandedDomains] = useState({});

  const [onlyMyFirstAccount, setOnlyMyFirstAccount] = useState(false);
  const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);
  const [isDomainFilterOpen, setIsDomainFilterOpen] = useState(false);
  const [isColumnsModalOpen, setIsColumnsModalOpen] = useState(false);
  const [rowColors, setRowColors] = useState(() => {
    try {
      const saved = localStorage.getItem('campaigns_row_colors');
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  const EXTERNAL_VERIFIER_OPTIONS = [
    "ЯММ",
    "Smartis",
    "AdRiver",
    "Weborama",
    "TargetAds",
    "Adserving",
    "Botfaqtor",
    "Adloox",
    "Нет",
  ];

  const COLOR_OPTIONS = [
    { value: "#f5f5f5", label: "Серый" },
    { value: "#e8f5e9", label: "Зеленый" },
    { value: "#fff8e1", label: "Желтый" },
    { value: "#fff3e0", label: "Оранжевый" },
    { value: "#fce4ec", label: "Розовый" },
    { value: "#f3e5f5", label: "Фиолетовый" },
    { value: "#efebe9", label: "Бежевый" },
    { value: "#e0f2f1", label: "Мятный" },
    { value: "#fbe9e7", label: "Коралловый" },
    { value: "#f1f8e9", label: "Лайм" },
  ];

  const saveRowColor = (rowId, color) => {
    const newColors = { ...rowColors, [rowId]: color };
    setRowColors(newColors);
    try {
      localStorage.setItem('campaigns_row_colors', JSON.stringify(newColors));
    } catch (e) {
      console.error('Failed to save row color:', e);
    }
  };

  const getRowColor = (rowId, isGroupTotal = false) => {
    if (rowColors[rowId]) {
      return rowColors[rowId];
    }
    if (isGroupTotal) {
      return "#f5f5f5";
    }
    return null;
  };

  const FIXED_COLUMNS_CONFIG = [
    { key: "important", label: "★ Значимые проекты" },
    { key: "open", label: "Открыть" },
    { key: "status", label: "Статус" },
    { key: "project", label: "Проект" },
    { key: "start_cycle_date", label: "Дата начала цикла" },
    { key: "end_cycle_date", label: "Дата окончания цикла" },
  ];

  const HIDEABLE_COLUMNS_CONFIG = [
    { key: "domain", label: "Домен" },
    { key: "payment_type", label: "Тип оплаты" },
    { key: "drr_fact", label: "ДРР, % факт" },
    { key: "budget_goal", label: "БЮДЖЕТ % расхода планового бюджета" },
    { key: "account_manager", label: "Аккаунт-менеджер-1" },
    { key: "account_manager_1", label: "Аккаунт-менеджер-2" },
    { key: "contextologist", label: "Контекстолог" },
    { key: "traffic_manager", label: "Трафик-менеджер" },
    { key: "external_verifier", label: "Внешний верификатор" },
    { key: "arсhive", label: "Архив" },
    { key: "delete", label: "Удалить проект" },
    { key: "dublicate", label: "Дублировать проект" },
    { key: "open_marginality", label: "Отчёт марж." },
    { key: "row_color", label: "Цвет" },
  ];
  const GROUPED_COLUMNS_CONFIG = [
    {
      groupKey: "views_group_details",
      groupLabel: "Показы",
      columns: [
        { key: "views", label: "ПОКАЗЫ план" },
        { key: "views_fact", label: "ПОКАЗЫ факт" },
        { key: "views_goal", label: "ПОКАЗЫ % цели" },
      ],
    },
    {
      groupKey: "clicks_group_details",
      groupLabel: "Клики",
      columns: [
        { key: "clicks", label: "КЛИКИ план" },
        { key: "clicks_fact", label: "КЛИКИ факт" },
        { key: "clicks_goal", label: "КЛИКИ % цели" },
      ],
    },
    {
      groupKey: "leads_group_details",
      groupLabel: "Лиды",
      columns: [
        { key: "leads", label: "ЛИДЫ Вал. план" },
        { key: "leads_fact", label: "ЛИДЫ Вал. факт" },
        { key: "leads_goal", label: "ЛИДЫ Вал. % цели" },
        { key: "leads_qual", label: "ЛИДЫ Квал. план" },
        { key: "leads_qual_fact", label: "ЛИДЫ Квал. факт" },
        { key: "leads_qual_goal", label: "ЛИДЫ Квал. % цели" },
      ],
    },
    {
      groupKey: "postviews_group_details",
      groupLabel: "PostView",
      columns: [
        { key: "postviews_plan", label: "PV план" },
        { key: "postviews_fact", label: "PV факт" },
        { key: "postviews_goal", label: "PV % цели" },
      ],
    },
    {
      groupKey: "income_group_details",
      groupLabel: "Доход",
      columns: [
        { key: "income", label: "ДОХОД план" },
        { key: "income_fact", label: "ДОХОД факт" },
      ],
    },
  ];
  const groupedColumnsKeys = GROUPED_COLUMNS_CONFIG.flatMap((group) =>
    group.columns.map((column) => column.key)
  );
  const groupedOrderKeys = GROUPED_COLUMNS_CONFIG.map(({ groupKey }) => groupKey);
  const REQUIRED_GROUP_COLUMN_KEYS = ["views_goal", "clicks_goal", "leads_qual_goal", "postviews_goal"];
  const defaultVisibleColumns = Object.fromEntries(
    [...HIDEABLE_COLUMNS_CONFIG.map(({ key }) => key), ...groupedColumnsKeys].map((key) => [key, true])
  );
  const normalizeVisibleColumns = (columns) => {
    const next = { ...columns };
    REQUIRED_GROUP_COLUMN_KEYS.forEach((key) => {
      next[key] = true;
    });
    return next;
  };
  const columnsStorageKey = (email) => `reports_columns_visibility_${email || "anonymous"}`;
  const COLUMNS_CONFIG_VERSION = 2;
  const columnsVersionKey = "reports_columns_config_version";

  const [visibleColumns, setVisibleColumns] = useState(() =>
    normalizeVisibleColumns(defaultVisibleColumns)
  );

  const hideableOrderKeys = HIDEABLE_COLUMNS_CONFIG.map(({ key }) => key);
  const paymentTypeIndex = hideableOrderKeys.indexOf("payment_type");
  const defaultColumnsOrder = paymentTypeIndex === -1
    ? [...hideableOrderKeys, ...groupedOrderKeys]
    : [
      ...hideableOrderKeys.slice(0, paymentTypeIndex + 1),
      ...groupedOrderKeys,
      ...hideableOrderKeys.slice(paymentTypeIndex + 1),
    ];
  const [columnsOrder, setColumnsOrder] = useState(defaultColumnsOrder);

  const [modalVisibleColumns, setModalVisibleColumns] = useState(null);
  const [modalColumnsOrder, setModalColumnsOrder] = useState(null);
  const columnsModalScrollRef = useRef(null);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;
    try {
      if (localStorage.getItem(columnsVersionKey) !== String(COLUMNS_CONFIG_VERSION)) {
        localStorage.setItem(columnsVersionKey, String(COLUMNS_CONFIG_VERSION));
        return;
      }
      const raw = localStorage.getItem(`${columnsStorageKey(email)}_order`);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          const known = new Set(defaultColumnsOrder);
          const cleaned = parsed.filter((key) => known.has(key));
          const added = defaultColumnsOrder.filter((key) => !cleaned.includes(key));
          setColumnsOrder([...cleaned, ...added]);
        }
      }
    } catch (_) {
      void 0;
    }
  }, [user?.email]);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;
    try {
      localStorage.setItem(`${columnsStorageKey(email)}_order`, JSON.stringify(columnsOrder));
    } catch (_) {
      void 0;
    }
  }, [columnsOrder, user?.email]);

  useEffect(() => {
    if (!isColumnsModalOpen) return;
    setModalVisibleColumns(normalizeVisibleColumns(visibleColumns));
    setModalColumnsOrder(columnsOrder);
  }, [isColumnsModalOpen, visibleColumns, columnsOrder]);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;
    try {
      if (localStorage.getItem(columnsVersionKey) !== String(COLUMNS_CONFIG_VERSION)) {
        localStorage.setItem(columnsVersionKey, String(COLUMNS_CONFIG_VERSION));
        return;
      }
      const raw = localStorage.getItem(columnsStorageKey(email));
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === "object") {
          setVisibleColumns(
            normalizeVisibleColumns({ ...defaultVisibleColumns, ...parsed })
          );
        }
      }
    } catch (_) {
      void 0;
    }
  }, [user?.email]);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;
    try {
      localStorage.setItem(columnsStorageKey(email), JSON.stringify(visibleColumns));
    } catch (_) {
      void 0;
    }
  }, [visibleColumns, user?.email]);

  const [sortImportant, setSortImportant] = useState("default");
  const [sortStatus, setSortStatus] = useState("default");
  const [sortEndCycle, setSortEndCycle] = useState("default");

  const filterableFields = [
    { value: "project", label: "Проект", type: "string" },
    { value: "domain", label: "Домен", type: "string" },
    { value: "payment_type", label: "Тип оплаты", type: "string" },
    { value: "views", label: "ПОКАЗЫ план", type: "number" },
    { value: "views_fact", label: "ПОКАЗЫ факт", type: "number" },
    { value: "views_goal", label: "ПОКАЗЫ % цели", type: "number" },
    { value: "clicks", label: "КЛИКИ план", type: "number" },
    { value: "clicks_fact", label: "КЛИКИ факт", type: "number" },
    { value: "clicks_goal", label: "КЛИКИ % цели", type: "number" },
    { value: "leads", label: "ЛИДЫ Вал. план", type: "number" },
    { value: "leads_fact", label: "ЛИДЫ Вал. факт", type: "number" },
    { value: "leads_goal", label: "ЛИДЫ Вал. % цели", type: "number" },
    { value: "leads_qual", label: "ЛИДЫ Квал. план", type: "number" },
    { value: "leads_qual_fact", label: "ЛИДЫ Квал. факт", type: "number" },
    { value: "leads_qual_goal", label: "ЛИДЫ Квал. % цели", type: "number" },
    { value: "postviews_plan", label: "PV план", type: "number" },
    { value: "postviews_fact", label: "PV факт", type: "number" },
    { value: "postviews_goal", label: "PV % цели", type: "number" },
    { value: "income", label: "ДОХОД план", type: "number" },
    { value: "income_fact", label: "ДОХОД факт", type: "number" },
    { value: "drr_fact", label: "ДРР, % факт", type: "number" },
    { value: "budget_goal", label: "БЮДЖЕТ % расхода планового бюджета", type: "number" },
  ];

  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [advancedLogic, setAdvancedLogic] = useState("AND");
  const [newFilterField, setNewFilterField] = useState(filterableFields[0].value);
  const [newFilterOperator, setNewFilterOperator] = useState("contains");
  const [newFilterValue, setNewFilterValue] = useState("");

  const [fieldAndLabel, setFieldAndLabel] = useState({
    field: '',
    label: ''
  })

  const [retargeoSearch, setRetargeoSearch] = useState("");
  const [retargeoClickRuFilter, setRetargeoClickRuFilter] = useState("all");
  const [retargeoReportDate, setRetargeoReportDate] = useState(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() - 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  });

  const retargeoReportDateUnix = (isoDate) => {
    if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return null;
    const [yy, mm, dd] = isoDate.split("-").map((x) => parseInt(x, 10));
    return Math.floor(new Date(yy, mm - 1, dd).getTime() / 1000);
  };

  const RETARGEO_PAGE_SIZE = 100;
  const [retargeoIsLoading, setRetargeoIsLoading] = useState(false);
  const [retargeoRows, setRetargeoRows] = useState([]);
  const [retargeoCurrentPage, setRetargeoCurrentPage] = useState(1);
  const [retargeoTotalPages, setRetargeoTotalPages] = useState(1);
  const [retargeoTotalRecords, setRetargeoTotalRecords] = useState(0);

  const retargeoQuery = useMemo(() => {
    const params = new URLSearchParams();
    params.set("page", String(retargeoCurrentPage));
    params.set("limit", String(RETARGEO_PAGE_SIZE));

    const trimmedSearch = (retargeoSearch || "").trim();
    if (trimmedSearch) params.set("search", trimmedSearch);

    if (retargeoClickRuFilter === "click.ru") {
      params.set("agency", "click.ru");
      params.set("agency_filter_mode", "0");
    } else     if (retargeoClickRuFilter === "без click.ru") {
      params.set("agency", "click.ru");
      params.set("agency_filter_mode", "1");
    }

    if (retargeoReportDate) params.set("date", retargeoReportDate);

    return params.toString();
  }, [retargeoCurrentPage, retargeoSearch, retargeoClickRuFilter, retargeoReportDate]);

  useEffect(() => {
    if (activeReportTab !== "retargeo") return;
    setRetargeoCurrentPage(1);
  }, [activeReportTab, retargeoSearch, retargeoClickRuFilter, retargeoReportDate]);

  useEffect(() => {
    if (activeReportTab !== "retargeo") return;
    const token = localStorage.getItem("admin_token");
    if (!token) return;

    setRetargeoIsLoading(true);
    fetch(`${DOMAIN_API_HOST}/api/v1/retargeo-production-report?${retargeoQuery}`, {
      method: "GET",
      headers: { Authorization: "Bearer " + token },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Ошибка ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setRetargeoRows(Array.isArray(data?.data) ? data.data : []);
        setRetargeoTotalPages(Math.max(1, Number(data?.total_pages || 1)));
        setRetargeoTotalRecords(Number(data?.total_records || 0));
      })
      .catch((err) => {
        setRetargeoRows([]);
        setRetargeoTotalPages(1);
        setRetargeoTotalRecords(0);
        enqueueSnackbar(`Retargeo: не удалось загрузить данные (${err?.message || "ошибка"})`, {
          variant: "error",
          autoHideDuration: 3500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      })
      .finally(() => setRetargeoIsLoading(false));
  }, [activeReportTab, retargeoQuery]);

  const handleRetargeoPageChange = (direction) => {
    if (direction === "prev" && retargeoCurrentPage > 1) {
      setRetargeoCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && retargeoCurrentPage < retargeoTotalPages) {
      setRetargeoCurrentPage((prev) => prev + 1);
    }
  };

  const retargeoSnapshotNum = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const RETARGEO_AGE_BUCKET_LABELS = [
    "До 18 лет",
    "18–24 года",
    "25–34 года",
    "35–44 года",
    "45–54 года",
    "55 лет и старше",
    "Не определено",
  ];

  const retargeoFmtPct = (value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
    const n = Number(value);
    const s = Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
    return `${s}%`;
  };

  const retargeoDevicePcMobilePlan = (row) => {
    const m = row.device_plan_percent;
    if (m === null || m === undefined) return "—";
    const mobile = Number(m);
    const pc = 100 - mobile;
    return `${retargeoFmtPct(pc)} / ${retargeoFmtPct(mobile)}`;
  };

  const retargeoDevicePcMobileFact = (row) => {
    const dev = row.secondary_stats_snapshot?.device;
    if (dev && typeof dev === "object" && !Array.isArray(dev)) {
      const mobileRaw =
        retargeoSnapshotNum(dev.mobile) + retargeoSnapshotNum(dev.tablet);
      const desktopRaw = retargeoSnapshotNum(dev.desktop) + retargeoSnapshotNum(dev.pc);
      const total = mobileRaw + desktopRaw;
      if (total > 0) {
        const pcPct = (desktopRaw / total) * 100;
        const mobPct = (mobileRaw / total) * 100;
        return `${retargeoFmtPct(pcPct)} / ${retargeoFmtPct(mobPct)}`;
      }
    }
    return "—";
  };

  const retargeoGenderMenWomenPlan = (row) => {
    const men = row.gender_plan_percent;
    if (men === null || men === undefined) return "—";
    const w = 100 - Number(men);
    return `${retargeoFmtPct(men)} / ${retargeoFmtPct(w)}`;
  };

  const retargeoGenderMenWomenFact = (row) => {
    const g = row.secondary_stats_snapshot?.gender;
    if (g && typeof g === "object" && !Array.isArray(g)) {
      let male = 0;
      let female = 0;
      let other = 0;
      Object.entries(g).forEach(([key, val]) => {
        const n = retargeoSnapshotNum(val);
        const kl = String(key).trim().toLowerCase();
        if (kl === "male" || kl === "м" || kl.startsWith("муж")) male += n;
        else if (kl === "female" || kl === "ж" || kl.startsWith("жен")) female += n;
        else other += n;
      });
      const total = male + female + other;
      if (total > 0) {
        const menPct = (male / total) * 100;
        const womenPct = (female / total) * 100;
        return `${retargeoFmtPct(menPct)} / ${retargeoFmtPct(womenPct)}`;
      }
    }
    return "—";
  };

  const retargeoAgePercentArrayFromSnapshotObj = (ageObj) => {
    if (!ageObj || typeof ageObj !== "object" || Array.isArray(ageObj)) return null;
    const buckets = [0, 0, 0, 0, 0, 0, 0];
    Object.entries(ageObj).forEach(([key, val]) => {
      const n = retargeoSnapshotNum(val);
      if (n <= 0) return;
      const k = String(key).replace(/\u2011|\u2010|\u2013|\u2212/g, "-").trim().toLowerCase();
      let idx = -1;
      if (/младше\s*18|до\s*18|^<\s*18/.test(k)) idx = 0;
      else if (/18\D{0,3}24/.test(k)) idx = 1;
      else if (/25\D{0,3}34/.test(k)) idx = 2;
      else if (/35\D{0,3}44/.test(k)) idx = 3;
      else if (/45\D{0,3}54/.test(k)) idx = 4;
      else if (/(^|\s)55|старше/.test(k)) idx = 5;
      else if (/не\s*определ|неопредел|unknown/.test(k)) idx = 6;
      else idx = 6;
      if (idx >= 0) buckets[idx] += n;
    });
    const total = buckets.reduce((a, b) => a + b, 0);
    if (total <= 0) return null;
    return buckets.map((c) => (c / total) * 100);
  };

  const retargeoAgeFactSeven = (row) => {
    const snapAge = row.secondary_stats_snapshot?.age;
    const fromCounts = retargeoAgePercentArrayFromSnapshotObj(snapAge);
    if (!fromCounts) return "—";
    return fromCounts
      .map((pct) => {
        const n = Number(pct);
        const s = Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
        return `${s}%`;
      })
      .join(" / ");
  };

  const retargeoDevicePlanTooltip = (row) => {
    const m = row.device_plan_percent;
    if (m === null || m === undefined) return "";
    const mobile = Number(m);
    const pc = 100 - mobile;
    return `ПК: ${retargeoFmtPct(pc)}\nМобильные (смартфоны + планшеты): ${retargeoFmtPct(mobile)}\n\nПорядок в ячейке слева направо: ПК, затем мобильные`;
  };

  const retargeoDeviceFactTooltip = (row) => {
    const dev = row.secondary_stats_snapshot?.device;
    if (!dev || typeof dev !== "object" || Array.isArray(dev)) return "";
    const mobileRaw = retargeoSnapshotNum(dev.mobile) + retargeoSnapshotNum(dev.tablet);
    const desktopRaw = retargeoSnapshotNum(dev.desktop) + retargeoSnapshotNum(dev.pc);
    const total = mobileRaw + desktopRaw;
    if (total <= 0) return "";
    const pcPct = (desktopRaw / total) * 100;
    const mobPct = (mobileRaw / total) * 100;
    return `ПК: ${retargeoFmtPct(pcPct)} (визитов: ${desktopRaw})\nМобильные: ${retargeoFmtPct(mobPct)} (визитов: ${mobileRaw}, mobile + tablet)\n\nПорядок в ячейке: ПК | мобильные`;
  };

  const retargeoGenderPlanTooltip = (row) => {
    const men = row.gender_plan_percent;
    if (men === null || men === undefined) return "";
    const w = 100 - Number(men);
    return `Мужчины: ${retargeoFmtPct(men)}\nЖенщины: ${retargeoFmtPct(w)}\n\nПорядок в ячейке слева направо: мужчины, затем женщины`;
  };

  const retargeoGenderFactTooltip = (row) => {
    const g = row.secondary_stats_snapshot?.gender;
    if (!g || typeof g !== "object" || Array.isArray(g)) return "";
    let male = 0;
    let female = 0;
    let other = 0;
    Object.entries(g).forEach(([key, val]) => {
      const n = retargeoSnapshotNum(val);
      const kl = String(key).trim().toLowerCase();
      if (kl === "male" || kl === "м" || kl.startsWith("муж")) male += n;
      else if (kl === "female" || kl === "ж" || kl.startsWith("жен")) female += n;
      else other += n;
    });
    const total = male + female + other;
    if (total <= 0) return "";
    const menPct = (male / total) * 100;
    const womenPct = (female / total) * 100;
    const otherPct = (other / total) * 100;
    return `Мужчины: ${retargeoFmtPct(menPct)} (визитов: ${male})\nЖенщины: ${retargeoFmtPct(womenPct)} (визитов: ${female})\nНе определено: ${retargeoFmtPct(otherPct)} (визитов: ${other})\n\nДоли от всех визитов в снапшоте.\nВ ячейке только м | ж (без «не определено»).`;
  };

  const retargeoAgeFactTooltip = (row) => {
    const snapAge = row.secondary_stats_snapshot?.age;
    const fromCounts = retargeoAgePercentArrayFromSnapshotObj(snapAge);
    if (!fromCounts) return "";
    const lines = fromCounts.map((pct, i) => {
      const n = Number(pct);
      const s = Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
      return `${RETARGEO_AGE_BUCKET_LABELS[i]}: ${s}%`;
    });
    return `${lines.join("\n")}\n\nПорядок в ячейке такой же: 7 диапазонов через « / ».`;
  };

  const retargeoHintWrap = (text, tip) => {
    if (!tip || text === "—") {
      return text;
    }
    return (
      <MuiTooltip
        title={
          <span style={{ whiteSpace: "pre-line", display: "block", fontSize: 13, lineHeight: 1.5 }}>
            {tip}
          </span>
        }
        arrow
        enterDelay={200}
        placement="top"
        componentsProps={{
          tooltip: {
            sx: { maxWidth: 440, bgcolor: "#1e293b", "& .MuiTooltip-arrow": { color: "#1e293b" } },
          },
        }}
      >
        <span
          style={{
            cursor: "help",
            borderBottom: "1px dashed #64748b",
            display: "inline-block",
            maxWidth: "100%",
          }}
        >
          {text}
        </span>
      </MuiTooltip>
    );
  };

  const retargeoDailyClicksPlanDisplay = (row) => {
    const pt = row.payment_type != null ? String(row.payment_type).toUpperCase() : "";
    const isClicksModel = pt === "CLICKS";
    let plan = row.daily_clicks_plan;
    if (isClicksModel && (plan === null || plan === undefined) && row.daily_impressions_plan != null) {
      plan = Math.round(0.2 * Number(row.daily_impressions_plan) / 100);
    }
    if (plan === null || plan === undefined) return "—";
    return plan;
  };

  const retargeoStatusReasons = (row) => {
    if (Array.isArray(row.status_reasons) && row.status_reasons.length) {
      return row.status_reasons;
    }

    const missing = [];
    if (row.fact_impressions == null) missing.push("показы (факт)");
    if (row.fact_clicks == null) missing.push("клики (факт)");
    if (row.daily_impressions_plan == null) missing.push("план показов");
    if (row.daily_clicks_plan == null) missing.push("план кликов");
    if (row.device_plan_percent == null) missing.push("план устройств");
    if (row.device_fact_percent == null) missing.push("факт устройств");
    if (row.gender_plan_percent == null) missing.push("план пола");
    if (row.gender_fact_percent == null) missing.push("факт пола");

    const agePercents = retargeoAgePercentArrayFromSnapshotObj(row.secondary_stats_snapshot?.age);
    const under18 = agePercents ? agePercents[0] : null;
    if (under18 == null) missing.push("возраст");

    if (missing.length) {
      return [`Недостаточно данных: ${missing.join(", ")}`];
    }

    const reasons = [];
    const impRatio = row.fact_impressions / row.daily_impressions_plan;
    if (impRatio < 0.9) {
      reasons.push(`Показы: ${Math.round(impRatio * 1000) / 10}% от плана (нужно ≥90%)`);
    }

    const clkRatio = row.fact_clicks / row.daily_clicks_plan;
    if (clkRatio < 0.9) {
      reasons.push(`Клики: ${Math.round(clkRatio * 1000) / 10}% от плана (нужно ≥90%)`);
    }

    const deviceDiff = Math.abs(Number(row.device_plan_percent) - Number(row.device_fact_percent));
    if (deviceDiff > 10) {
      reasons.push(`Устройства: отклонение ${Math.round(deviceDiff * 10) / 10} п.п. (допустимо ≤10 п.п.)`);
    }

    const genderDiff = Math.abs(Number(row.gender_plan_percent) - Number(row.gender_fact_percent));
    if (genderDiff > 10) {
      reasons.push(`Пол: отклонение ${Math.round(genderDiff * 10) / 10} п.п. (допустимо ≤10 п.п.)`);
    }

    if (under18 > 3) {
      const under18Rounded = Math.round(under18 * 100) / 100;
      reasons.push(`Возраст: доля младше 18 лет ${under18Rounded}% (допустимо ≤3%)`);
    }

    return reasons;
  };

  const retargeoStatusTooltip = (row) => {
    const reasons = retargeoStatusReasons(row);
    if (!reasons.length) return "";
    return reasons.join("\n");
  };

  const retargeoPaymentTypeLabel = (row) => {
    const pt = row.payment_type != null ? String(row.payment_type).toUpperCase() : "";
    if (pt === "SHOWS") return "CPM";
    if (pt === "CLICKS") return "CPC";
    if (!pt) return "—";
    return String(row.payment_type);
  };

  const retargeoAgencyLabel = (row) => {
    const a = row.agency;
    if (a === null || a === undefined) return "Нет";
    if (String(a).trim() === "") return "Нет";
    return String(a);
  };

  const handleRetargeoExport = async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) return;
    try {
      const exportParams = new URLSearchParams(retargeoQuery);
      exportParams.delete("page");
      exportParams.delete("limit");
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/retargeo-production-report/export?${exportParams}`, {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
      });
      if (!response.ok) throw new Error(`Ошибка ${response.status}`);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers.get("content-disposition");
      let filename = `retargeo_production_report.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename\\*=(?:UTF-8'')?([^;]+)|filename="?([^"]+)"?/i);
        const rawName = filenameMatch?.[1] || filenameMatch?.[2];
        if (rawName) {
          try {
            filename = decodeURIComponent(rawName);
          } catch {
            filename = rawName;
          }
        }
      }

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      enqueueSnackbar(`Retargeo: не получилось скачать файл (${error?.message || "ошибка"})`, {
        variant: "error",
        autoHideDuration: 3500,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  const handleRetargeoAccessToken = async (campaignId) => {
    if (!campaignId) return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));
    const response = await fetch(
      `${DOMAIN_API_HOST}/api/v1/admin/auth/access-token-by-campaign/${campaignId}`,
      { method: "get", headers: myHeaders }
    );
    const data = await response.json();
    localStorage.setItem("token", data.access_token);
    window.open("/");
  };

  const retargeoColumns = useMemo(
    () => [
      {
        Header: "Статус",
        accessor: "status",
        width: 110,
        Cell: ({ row, value }) => {
          let statusLabel = "Нет";
          let statusColor = "#7A7A7A";
          let statusBg = "#e2e8f0";
          if (value === true) {
            statusLabel = "OK";
            statusColor = "#00B35D";
            statusBg = "rgba(0,179,93,0.1)";
          } else if (value === false) {
            statusLabel = "не OK";
            statusColor = "#FF4141";
            statusBg = "rgba(255,65,65,0.12)";
          }
          const tip = retargeoStatusTooltip(row.original);
          const badge = (
            <span
              style={{
                padding: "3px 10px",
                borderRadius: 5,
                fontSize: 12,
                fontWeight: 600,
                backgroundColor: statusBg,
                color: statusColor,
                display: "inline-block",
                border: value === false ? "1px solid rgba(255,65,65,0.35)" : value === true ? "1px solid rgba(0,179,93,0.25)" : "1px solid #cbd5e1",
                cursor: tip ? "help" : "default",
              }}
            >
              {statusLabel}
            </span>
          );
          return (
            <div className="td">
              {tip ? retargeoHintWrap(badge, tip) : badge}
            </div>
          );
        },
      },
      {
        Header: "Перейти в ЛК",
        accessor: "redirect",
        width: 120,
        Cell: ({ row }) => (
          <div className="td">
            <button
              type="button"
              onClick={() => handleRetargeoAccessToken(row.original.campaign_id)}
              style={{
                padding: "5px 10px",
                fontSize: "12px",
                fontWeight: "500",
                borderRadius: 5,
                background: "#DFE8FF",
                color: "#3F73F9",
                border: "none",
                cursor: "pointer",
              }}
            >
              Перейти
            </button>
          </div>
        ),
      },
      { Header: "Название РК", accessor: "campaign_name", width: 260 },
      { Header: "Почта клиента", accessor: "client_email", width: 220 },
      { Header: "Дневной бюджет", accessor: "daily_budget", width: 150 },
      {
        Header: "Тип оплаты",
        id: "payment_type_label",
        accessor: "payment_type",
        width: 120,
        Cell: ({ row }) => retargeoPaymentTypeLabel(row.original),
      },
      { Header: "План показов дневной", accessor: "daily_impressions_plan", width: 190 },
      { Header: "Факт показов вчера", accessor: "fact_impressions", width: 180 },
      {
        Header: "План кликов дневной",
        id: "daily_clicks_plan_display",
        accessor: "daily_clicks_plan",
        width: 180,
        Cell: ({ row }) => retargeoDailyClicksPlanDisplay(row.original),
      },
      { Header: "Факт кликов вчера", accessor: "fact_clicks", width: 170 },
      {
        Header: "План устройства (ПК/моб.), %",
        id: "device_plan_pc_mobile",
        accessor: "device_plan_percent",
        width: 200,
        Cell: ({ row }) =>
          retargeoHintWrap(
            retargeoDevicePcMobilePlan(row.original),
            retargeoDevicePlanTooltip(row.original)
          ),
      },
      {
        Header: "Факт устройства (ПК/моб.), %",
        id: "device_fact_pc_mobile",
        accessor: "device_fact_percent",
        width: 200,
        Cell: ({ row }) =>
          retargeoHintWrap(
            retargeoDevicePcMobileFact(row.original),
            retargeoDeviceFactTooltip(row.original)
          ),
      },
      {
        Header: "План пол (м/ж), %",
        id: "gender_plan_mw",
        accessor: "gender_plan_percent",
        width: 160,
        Cell: ({ row }) =>
          retargeoHintWrap(
            retargeoGenderMenWomenPlan(row.original),
            retargeoGenderPlanTooltip(row.original)
          ),
      },
      {
        Header: "Факт пол (м/ж), %",
        id: "gender_fact_mw",
        accessor: "gender_fact_percent",
        width: 160,
        Cell: ({ row }) =>
          retargeoHintWrap(
            retargeoGenderMenWomenFact(row.original),
            retargeoGenderFactTooltip(row.original)
          ),
      },
      {
        Header: "Факт возраст (7 диапазонов), %",
        id: "age_fact_seven",
        accessor: "age_fact_breakdown",
        width: 380,
        Cell: ({ row }) =>
          retargeoHintWrap(retargeoAgeFactSeven(row.original), retargeoAgeFactTooltip(row.original)),
      },
      {
        Header: "Агентство",
        id: "agency_display",
        accessor: "agency",
        width: 160,
        Cell: ({ row }) => retargeoAgencyLabel(row.original),
      },
    ],
    []
  );

  const switchReportTab = (nextTab) => {
    const next = new URLSearchParams(searchParams.toString());
    if (nextTab === "retargeo") {
      next.set("reportTab", "retargeo");
    } else {
      next.delete("reportTab");
    }
    setSearchParams(next);
  };

  // useEffect(() => {
  //   if (link !== null && report_id !== null && redirect) {
  //     console.log(link)
  //     const url = new URL(link);
  //     url.searchParams.set("redirect_uri", "https://lk.programmatic.ru/admin/campaigns-reports?report_id=" + report_id);
  //     // url.searchParams.set("redirect_uri", "http://localhost:3000/admin/campaigns-reports?report_id=" + report_id);
  //     const updatedLink = url.toString()
  //     window.location.href = updatedLink
  //   }
  // }, [report_id])

  useEffect(() => {
    const codeParam = searchParams.get('code');
    const codeReportId = searchParams.get('report_id');  

    if (codeParam !== null && codeReportId !== null) {
      const params = { "code": codeParam, "_id": codeReportId.toString() };
      console.log("params: ", params);
      // const myHeaders = new Headers();
      // myHeaders.append('Content-Type', 'application/json');
      // myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem("admin_token"));
      // fetch(`${DOMAIN_API_HOST}/api/v1/production-reports/access-code`, {
      //   method: 'POST',
      //   headers: myHeaders,
      //   body: JSON.stringify(params),
      // }).then(async response => {
      //   if (!response.ok) {
      //     alert("Ошибка подключения Яндекс Метрики!");
      //   }
      // });
      // searchParams.delete('code');
      // setSearchParams(searchParams);
    }
  }, []);

  useEffect(() => {
    if (activeReportTab === "retargeo") return;
    if (modalType === "marginality") return;
    setIsLoading(true);
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/fetch/head${page === "all" ? "" : `?is_archive=true`}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        const mapped = mapExternalVerifierFromBackend(data);
        setFilter(mapped);
        setImportantProjects(
          mapped.filter((item) => item.important).map((item) => item.id)
        );
        setIsLoading(false);
      }
    }
    fetchData();
  }, [upd, page, modalType, activeReportTab]);

  useEffect(() => {
    if (activeReportTab === "retargeo") return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/employee`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({}),
    }).then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          setStaff(data);
        });
      }
    });
  }, [activeReportTab]);

  // Retargeo снапшоты хранятся на бэке (по date).

  function getFilteredData() {
    const getFieldRawValue = (el, fieldName) => {
      switch (fieldName) {
        default:
          return el[fieldName];
      }
    };

    const matchesAdvancedFilters = (el) => {
      if (advancedFilters.length === 0) return true;

      const results = advancedFilters.map((cond) => {
        const fieldCfg = filterableFields.find((f) => f.value === cond.field);
        if (!fieldCfg) return true;

        const raw = getFieldRawValue(el, cond.field);

        if (fieldCfg.type === "number") {
          const left = Number(raw);
          const right = Number(cond.value);
          if (Number.isNaN(left) || Number.isNaN(right)) return false;
          switch (cond.operator) {
            case ">":
              return left > right;
            case ">=":
              return left >= right;
            case "<":
              return left < right;
            case "<=":
              return left <= right;
            case "=":
              return left === right;
            case "!=":
              return left !== right;
            default:
              return true;
          }
        }

        const leftStr = (raw ?? "").toString().toLowerCase();
        const rightStr = String(cond.value).toLowerCase();

        switch (cond.operator) {
          case "contains":
            return leftStr.includes(rightStr);
          case "not_contains":
            return !leftStr.includes(rightStr);
          case "=":
            return leftStr === rightStr;
          case "!=":
            return leftStr !== rightStr;
          default:
            return true;
        }
      });

      return advancedLogic === "AND"
        ? results.every(Boolean)
        : results.some(Boolean);
    };

    return filterArr.filter((el) => {
      const projectMatches = searchValue.project
        ? el.project?.toLowerCase().includes(searchValue.project.toLowerCase())
        : true;
      const domainMatches = searchValue.domain
        ? el.domain?.toLowerCase().includes(searchValue.domain.toLowerCase())
        : true;
      const selectedDomainMatches = selectedDomains.length === 0
        ? true
        : selectedDomains.includes(el.domain || "Без домена");
      const importantMatches = onlyImportant
        ? importantProjects.includes(el.id)
        : true;
      const managerMatches = searchValue.manager
        ? [
            el.account_manager,
            el.account_manager_1,
            el.contextologist,
            el.traffic_manager,
          ].some((managerId) => {
            const staffMember = arrStaff.find((staff) => staff.id === managerId);
            return (
              staffMember &&
              staffMember.full_name
                .toLowerCase()
                .includes(searchValue.manager.toLowerCase())
            );
          })
        : true;

      const onlyMyMatches = onlyMyFirstAccount
        ? (() => {
            const manager = arrStaff.find(
              (staff) => staff.id === el.account_manager
            );
            if (!manager || !user?.email) return false;
            return manager.email.toLowerCase() === user.email.toLowerCase();
          })()
        : true;

      const advancedMatches = matchesAdvancedFilters(el);

      return (
        projectMatches &&
        domainMatches &&
        selectedDomainMatches &&
        importantMatches &&
        managerMatches &&
        onlyMyMatches &&
        advancedMatches
      );
    });
  }

  const updateField = async (report_id, key, value) => {
    const payloadKey = key === "external_verifier" ? "external_verificators" : key;
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/update?_id=${report_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
      },
      body: JSON.stringify({ [payloadKey]: value }),
    });

    if (["account_manager", "account_manager_1", "contextologist", "traffic_manager"].includes(key)) {
      setFilter((prev) =>
        prev.map((item) =>
          item.id === report_id ? { ...item, [key]: value } : item
        )
      );
    }
  };



  const hasExpandedDomain = Object.values(expandedDomains).some(Boolean);

  const cycleSortImportant = () => setSortImportant((s) => (s === "default" ? "importantFirst" : "default"));
  const cycleSortStatus = () => setSortStatus((s) => (s === "default" ? "ok" : s === "ok" ? "notOk" : "default"));
  const cycleSortEndCycle = () => setSortEndCycle((s) => (s === "default" ? "desc" : s === "desc" ? "asc" : "default"));

  const columns = [
    {
      Header: () => (
        <button
          type="button"
          onClick={cycleSortImportant}
          style={{
            padding: 0,
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "inherit",
            color: sortImportant !== "default" ? "#3F73F9" : "#7a7a7a",
          }}
          title={sortImportant === "importantFirst" ? "Сначала значимые (клик: сброс)" : "Сортировка: сначала значимые"}
        >
          ★ Знач.
        </button>
      ),
      accessor: "important",
      maxWidth: 80,
      minWidth: 40,
      width: 50,
      isSticky: true,
    },
    {
      Header: "Открыть",
      accessor: "open",
      maxWidth: 400,
      minWidth: 80,
      width: 90,
      isSticky: true,
    },
    {
      Header: () => (
        <button
          type="button"
          onClick={cycleSortStatus}
          style={{
            padding: "2px 6px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "inherit",
            color: sortStatus !== "default" ? "#3F73F9" : "inherit",
          }}
          title={
            sortStatus === "default"
              ? "Статус (клик: OK сверху)"
              : sortStatus === "ok"
                ? "OK сверху (клик: не OK сверху)"
                : "не OK сверху (клик: сброс)"
          }
        >
          Статус {sortStatus === "ok" ? "↓OK" : sortStatus === "notOk" ? "↓не OK" : ""}
        </button>
      ),
      accessor: "status",
      maxWidth: 200,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "Проект",
      accessor: "project",
      maxWidth: 600,
      minWidth: 80,
      width: hasExpandedDomain ? 400 : 300,
      isSticky: true,
    },
    {
      Header: "Домен",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 230,
    },
    {
      Header: "Тип оплаты",
      accessor: "payment_type",
      maxWidth: 200,
      minWidth: 80,
      width: 120,
    },
    {
      Header: "Дата начала цикла",
      accessor: "start_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 110,
    },
    {
      Header: () => (
        <button
          type="button"
          onClick={cycleSortEndCycle}
          style={{
            padding: "2px 6px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "inherit",
            color: sortEndCycle !== "default" ? "#3F73F9" : "inherit",
          }}
          title={
            sortEndCycle === "default"
              ? "Дата окончания цикла (клик: по убыванию)"
              : sortEndCycle === "desc"
                ? "По убыванию (клик: по возрастанию)"
                : "По возрастанию (клик: сброс)"
          }
        >
          Дата окончания цикла {sortEndCycle === "desc" ? "↓" : sortEndCycle === "asc" ? "↑" : ""}
        </button>
      ),
      accessor: "end_cycle_date",
      maxWidth: 400,
      minWidth: 80,
      width: 110,
    },
    {
      id: "views_group_details",
      Header: () => "Показы",
      columns: [
        {
          Header: "ПОКАЗЫ план",
          accessor: "views",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ПОКАЗЫ факт",
          accessor: "views_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ПОКАЗЫ % цели",
          accessor: "views_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      id: "clicks_group_details",
      Header: () => "Клики",
      columns: [
        {
          Header: "КЛИКИ план",
          accessor: "clicks",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "КЛИКИ факт",
          accessor: "clicks_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "КЛИКИ % цели",
          accessor: "clicks_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      id: "leads_group_details",
      Header: () => "Лиды",
      columns: [
        {
          Header: "ЛИДЫ Вал. план",
          accessor: "leads",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ЛИДЫ Вал. факт",
          accessor: "leads_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ЛИДЫ Вал. % цели",
          accessor: "leads_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ЛИДЫ Квал. план",
          accessor: "leads_qual",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ЛИДЫ Квал. факт",
          accessor: "leads_qual_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ЛИДЫ Квал. % цели",
          accessor: "leads_qual_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      id: "postviews_group_details",
      Header: () => "PostView",
      columns: [
        {
          Header: "PV план",
          accessor: "postviews_plan",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "PV факт",
          accessor: "postviews_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "PV % цели",
          accessor: "postviews_goal",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      id: "income_group_details",
      Header: () => "Доход",
      columns: [
        {
          Header: "ДОХОД план",
          accessor: "income",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
        {
          Header: "ДОХОД факт",
          accessor: "income_fact",
          maxWidth: 400,
          minWidth: 80,
          width: 100,
        },
      ],
    },
    {
      Header: "ДРР, % факт",
      accessor: "drr_fact",
      maxWidth: 400,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "БЮДЖЕТ % расхода планового бюджета",
      accessor: "budget_goal",
      maxWidth: 400,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "Аккаунт-менеджер-1",
      accessor: "account_manager",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Аккаунт-менеджер-2",
      accessor: "account_manager_1",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Контекстолог",
      accessor: "contextologist",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Трафик-менеджер",
      accessor: "traffic_manager",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Внешний верификатор",
      accessor: "external_verifier",
      maxWidth: 260,
      minWidth: 120,
      width: 200,
    },
    {
      Header: "Архив",
      accessor: "arсhive",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    ...(["ADMIN", "SUPERUSER"].some((r) => r === role) ? [{
      Header: "Удалить проект",
      accessor: "delete",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    }] : []),
    {
      Header: "Дублировать проект",
      accessor: "dublicate",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    ...(role === "SUPERUSER" ? [{
      Header: "Отчёт марж.",
      accessor: "open_marginality",
      maxWidth: 400,
      minWidth: 80,
      width: 90,
    }] : []),
    {
      Header: "Цвет",
      accessor: "row_color",
      maxWidth: 100,
      minWidth: 80,
      width: 90,
    },
  ];

  const FIXED_COLUMN_KEYS = ["important", "open", "status", "project", "start_cycle_date", "end_cycle_date"];

  const visibleColumnsOrdered = (() => {
    const hideableKeys = HIDEABLE_COLUMNS_CONFIG.map(({ key }) => key);
    const groupedKeys = GROUPED_COLUMNS_CONFIG.map(({ groupKey }) => groupKey);
    const fixed = [];
    const hideable = [];
    const grouped = [];
    const rest = [];

    columns.forEach((col) => {
      const k = col.accessor || col.id;
      if (FIXED_COLUMN_KEYS.includes(k)) {
        fixed.push({ k, col });
      } else if (hideableKeys.includes(k)) {
        hideable.push({ k, col });
      } else if (groupedKeys.includes(k)) {
        grouped.push({ k, col });
      } else {
        rest.push({ k, col });
      }
    });

    const hideableByKey = new Map(hideable.map(({ k, col }) => [k, col]));
    const groupedByKey = new Map(grouped.map(({ k, col }) => [k, col]));

    const orderedVisible = columnsOrder
      .map((key) => {
        if (hideableByKey.has(key)) {
          if (visibleColumns[key] === false) return null;
          return hideableByKey.get(key);
        }
        if (groupedByKey.has(key)) {
          const groupCol = groupedByKey.get(key);
          const visibleSubColumns = (groupCol.columns || []).filter((subColumn) => {
            const subKey = subColumn.accessor || subColumn.id;
            return visibleColumns[subKey] !== false;
          });
          if (visibleSubColumns.length === 0) return null;
          return { ...groupCol, columns: visibleSubColumns };
        }
        return null;
      })
      .filter(Boolean);

    const restVisible = rest
      .filter(({ k }) => visibleColumns[k] !== false)
      .map(({ col }) => col);

    return [...fixed.map(({ col }) => col), ...orderedVisible, ...restVisible];
  })();

  const handleColumnsDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const container = columnsModalScrollRef.current;
    const prevScrollTop = container ? container.scrollTop : null;

    setModalColumnsOrder((prev) => {
      const base = prev || columnsOrder;
      const oldIndex = base.indexOf(active.id);
      const newIndex = base.indexOf(over.id);
      if (oldIndex === -1 || newIndex === -1) return base;
      return arrayMove(base, oldIndex, newIndex);
    });

    if (container && prevScrollTop !== null) {
      requestAnimationFrame(() => {
        container.scrollTop = prevScrollTop;
      });
    }
  };

  const handleToggleColumnVisibility = (key, checked) => {
    if (REQUIRED_GROUP_COLUMN_KEYS.includes(key) && !checked) return;
    const container = columnsModalScrollRef.current;
    const prevScrollTop = container ? container.scrollTop : null;

    setModalVisibleColumns((prev) =>
      normalizeVisibleColumns({
        ...(prev || visibleColumns),
        [key]: checked,
      })
    );

    if (container && prevScrollTop !== null) {
      requestAnimationFrame(() => {
        container.scrollTop = prevScrollTop;
      });
    }
  };

  const SortableColumnItem = ({ id, label, isChecked, onToggle }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      isDragging,
    } = useSortable({ id });

    const style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      cursor: "pointer",
      fontSize: 14,
      padding: "12px 14px",
      borderRadius: 8,
      border: "1px solid",
      borderColor: isChecked ? "#3F73F9" : "#e2e8f0",
      backgroundColor: isChecked ? "#edf2ff" : "#fff",
      transition: "border-color 0.15s, background-color 0.15s, opacity 0.1s, transform 0.2s",
      fontWeight: isChecked ? 500 : 400,
      opacity: isDragging ? 0.6 : 1,
      transform: transform ? `translate3d(${transform.x ?? 0}px, ${transform.y ?? 0}px, 0)` : undefined,
      transformOrigin: "center",
      flexShrink: 0,
      minHeight: 44,
      height: "fit-content",
      boxSizing: "border-box",
    };

    return (
      <label
        ref={setNodeRef}
        style={style}
        {...attributes}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => onToggle(e.target.checked)}
            style={{
              margin: 0,
              width: 18,
              height: 18,
              accentColor: "#3F73F9",
              cursor: "pointer",
            }}
          />
          <span style={{ userSelect: "none" }}>{label}</span>
        </div>
        <span
          {...listeners}
          style={{
            fontSize: 14,
            color: "#94a3b8",
            userSelect: "none",
            cursor: "grab",
            "&:hover": {
              backgroundColor: "#e2e8f0",
            },
          }}
        >
          ⠿
        </span>
      </label>
    );
  };

  const SortableGroupItem = ({ id, label, subColumns }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      isDragging,
    } = useSortable({ id });
    const columnsVisibility = modalVisibleColumns || visibleColumns;
    const isGroupChecked = subColumns.some(
      ({ key }) => columnsVisibility[key] !== false
    );

    const style = {
      border: "1px solid",
      borderColor: isGroupChecked ? "#3F73F9" : "#e2e8f0",
      borderRadius: 8,
      backgroundColor: isGroupChecked ? "#edf2ff" : "#f8fafc",
      padding: "10px 12px",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      opacity: isDragging ? 0.6 : 1,
      transform: transform ? `translate3d(${transform.x ?? 0}px, ${transform.y ?? 0}px, 0)` : undefined,
      transformOrigin: "center",
      transition: "opacity 0.1s, transform 0.2s",
      flexShrink: 0,
      height: "fit-content",
      minHeight: "fit-content",
      boxSizing: "border-box",
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>{label}</span>
          <span
            {...listeners}
            style={{
              fontSize: 14,
              color: "#94a3b8",
              userSelect: "none",
              cursor: "grab",
            }}
          >
            ⠿
          </span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {subColumns.map(({ key, label: subLabel }) => (
            <label
              key={key}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: 13,
                color: "#334155",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={(modalVisibleColumns || visibleColumns)[key] !== false}
                disabled={REQUIRED_GROUP_COLUMN_KEYS.includes(key)}
                onChange={(e) => handleToggleColumnVisibility(key, e.target.checked)}
                style={{
                  margin: 0,
                  width: 16,
                  height: 16,
                  accentColor: "#3F73F9",
                  cursor: "pointer",
                }}
              />
              <span>{subLabel}</span>
            </label>
          ))}
        </div>
      </div>
    );
  };

  const deleteProject = (project_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/delete?_id=${project_id}`, {
      method: "POST",
      headers: myHeaders,
    }).then((res) => {
      if (res.ok) {
        res.json().then(() => {
          setUpd((prev) => !prev);
        });
      }
    });
  }

  const archiveProject = (project_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/archive?_id=${project_id}`, {
      method: "POST",
      headers: myHeaders,
    }).then((res) => {
      if (res.ok) {
        res.json().then(() => {
          setUpd((prev) => !prev);
        });
      }
    });
  }

  const unarchiveProject = (project_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/unarchive?_id=${project_id}`, {
      method: "POST",
      headers: myHeaders,
    }).then((res) => {
      if (res.ok) {
        res.json().then(() => {
          setUpd((prev) => !prev);
        });
      }
    });
  }


  const dublicateProject = (project_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/dublicate?_id=${project_id}`, {
      method: "POST",
      headers: myHeaders
    }).then((res) => {
      if (res.ok) {
        res.json().then(() => {
          setUpd((prev) => !prev);
        });
      }
    });
  }

  const getLimits2Email = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("admin_token"));
  
    try {
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/send-traffic-report2email`, {
        method: "POST",
        headers: myHeaders
      });
      return true;
    } catch {
      return false;
    }
  };

  function getTableData() {
    let data = getFilteredData();

    data = [...data].sort((a, b) => {
      if (sortImportant === "importantFirst") {
        const aImp = importantProjects.includes(a.id) ? 1 : 0;
        const bImp = importantProjects.includes(b.id) ? 1 : 0;
        if (bImp !== aImp) return bImp - aImp;
      }
      if (sortStatus === "ok") {
        const aOk = a.status?.value ? 1 : 0;
        const bOk = b.status?.value ? 1 : 0;
        if (bOk !== aOk) return bOk - aOk;
      }
      if (sortStatus === "notOk") {
        const aOk = a.status?.value ? 1 : 0;
        const bOk = b.status?.value ? 1 : 0;
        if (aOk !== bOk) return aOk - bOk;
      }
      if (sortEndCycle === "asc") {
        const ta = a.end_cycle_date ?? 0;
        const tb = b.end_cycle_date ?? 0;
        if (ta !== tb) return ta - tb;
      }
      if (sortEndCycle === "desc") {
        const ta = a.end_cycle_date ?? 0;
        const tb = b.end_cycle_date ?? 0;
        if (ta !== tb) return tb - ta;
      }
      const domainA = (a.domain || "Без домена").toLowerCase();
      const domainB = (b.domain || "Без домена").toLowerCase();
      if (domainA !== domainB) return domainA.localeCompare(domainB);
      const projectA = (a.project || "").toLowerCase();
      const projectB = (b.project || "").toLowerCase();
      return projectA.localeCompare(projectB);
    });

    const buildRow = (el, options = {}) => {
      const {
        isChild = false,
        isGroupTotal = false,
        groupItems = [],
        parentGroupId = null,
      } = options;

      const items = isGroupTotal ? groupItems : [el];

      const isImportant = isGroupTotal
        ? items.some((item) => importantProjects.includes(item.id))
        : importantProjects.includes(el.id);

      let statusLabel = "Нет";
      let statusColor = "#7A7A7A";

      if (isGroupTotal) {
        const statusValues = items.map((item) => {
          const st = item.status;
          return st && typeof st === "object" ? st.value : null;
        });
        const hasTrue = statusValues.some((v) => v === true);
        const hasFalse = statusValues.some((v) => v === false);
        const hasAny = hasTrue || hasFalse;
        if (!hasAny) {
          statusLabel = "Нет";
          statusColor = "#7A7A7A";
        } else if (hasTrue && !hasFalse) {
          statusLabel = "OK";
          statusColor = "#00B35D";
        } else if (hasFalse && !hasTrue) {
          statusLabel = "не OK";
          statusColor = "#FF4141";
        } else {
          // есть и OK, и не OK в подстроках
          statusLabel = "не OK";
          statusColor = "#FFA500";
        }
      } else {
        const statusObj = el.status;
        const statusValue =
          statusObj && typeof statusObj === "object" ? statusObj.value : null;
        if (statusValue === true) {
          statusLabel = "OK";
          statusColor = "#00B35D";
        } else if (statusValue === false) {
          statusLabel = "не OK";
          statusColor = "#FF4141";
        }
      }

      const manager = arrStaff.find(
        (staff) => staff.id === el.account_manager
      );
      const canToggleImportant =
        ["ADMIN", "SUPERUSER"].some((r) => r === role) ||
        (manager?.email &&
          user?.email &&
          manager.email.toLowerCase() === user.email.toLowerCase());

      const groupExternalVerifierCell = () => {
        const all = new Set();
        items.forEach((item) => {
          const raw = item.external_verifier;
          const arr = Array.isArray(raw)
            ? raw
            : raw
            ? [raw]
            : [];
          arr.forEach((v) => {
            if (v && v !== "Нет") {
              all.add(v);
            }
          });
        });
        const list = Array.from(all);
        const text = list.length ? list.join(", ") : "Нет";
        return <div className="td">{text}</div>;
      };

      const allEqualByKey = (key) => {
        if (!items.length) return { allSame: false, value: null };
        const first = items[0][key];
        const allSame = items.every((item) => item[key] === first);
        return { allSame, value: first };
      };

      const makeStartDateCell = () => {
        if (!isGroupTotal) {
          return (
            <div className="td">
              {formatDatePicker(el.start_cycle_date, true)}
            </div>
          );
        }
        const { allSame, value } = allEqualByKey("start_cycle_date");
        if (!allSame || !value) {
          return <div className="td">—</div>;
        }
        return (
          <div className="td">
            {formatDatePicker(value, true)}
          </div>
        );
      };

      const makeEndDateCell = () => {
        if (!isGroupTotal) {
          return (
            <div
              style={{
                color:
                  el.end_cycle_date * 1000 <=
                  new Date().getTime() + 1 * 24 * 60 * 60 * 1000
                    ? "red"
                    : el.end_cycle_date * 1000 <=
                      new Date().getTime() + 5 * 24 * 60 * 60 * 1000
                    ? "orange"
                    : "black",
              }}
              className="td"
            >
              {formatDatePicker(el.end_cycle_date, true)}
            </div>
          );
        }
        const { allSame, value } = allEqualByKey("end_cycle_date");
        if (!allSame || !value) {
          return <div className="td">—</div>;
        }
        return (
          <div
            style={{
              color:
                value * 1000 <=
                new Date().getTime() + 1 * 24 * 60 * 60 * 1000
                  ? "red"
                  : value * 1000 <=
                    new Date().getTime() + 5 * 24 * 60 * 60 * 1000
                  ? "orange"
                  : "black",
            }}
            className="td"
          >
            {formatDatePicker(value, true)}
          </div>
        );
      };

      const rowVariant = isGroupTotal ? "group" : isChild ? "group-child" : "default";

      return {
        id: el.id,
        rowVariant,
        important: isGroupTotal ? (
          <div className="td">
            {isImportant && (
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ color: "#FF4141" }}
              >
                <path
                  d="M10.17 1H0v10h10.17c.193 0 .38-.058.526-.162a.698.698 0 00.3-.484.648.648 0 00-.185-.522L7.587 6.453A.659.659 0 017.398 6c0-.165.067-.324.189-.453l3.224-3.38A.656.656 0 0011 1.715C11 1.32 10.628 1 10.17 1z"
                  fill="currentColor"
                />
              </svg>
            )}
          </div>
        ) : (
          <div className="td">
            <button
              onClick={async () => {
                if (!canToggleImportant) return;
                const nextValue = !isImportant;
                setImportantProjects((prev) =>
                  nextValue
                    ? [...prev, el.id]
                    : prev.filter((id) => id !== el.id)
                );
                await updateField(el.id, "important", nextValue);
              }}
              style={{
                padding: 0,
                border: "none",
                background: "transparent",
                cursor: canToggleImportant ? "pointer" : "default",
                color: isImportant ? "#FF4141" : "#7A7A7A",
                opacity: isImportant ? 1 : 0,
                transition: "opacity 0.15s ease",
              }}
              onMouseEnter={(e) => {
                if (!isImportant) {
                  e.currentTarget.style.opacity = "1";
                }
              }}
              onMouseLeave={(e) => {
                if (!isImportant) {
                  e.currentTarget.style.opacity = "0";
                }
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.17 1H0v10h10.17c.193 0 .38-.058.526-.162a.698.698 0 00.3-.484.648.648 0 00-.185-.522L7.587 6.453A.659.659 0 017.398 6c0-.165.067-.324.189-.453l3.224-3.38A.656.656 0 0011 1.715C11 1.32 10.628 1 10.17 1z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
        ),
        project: (
          <div
            className="td"
            style={{
              textAlign: "left",
              ...(isChild ? { paddingLeft: 50 } : {}),
            }}
          >
            {el.project}
          </div>
        ),
        domain: (
          <div className="td">
            {el.domain}
          </div>
        ),
        status: (
          <div className="td">
            {isGroupTotal ? (
              <span
                style={{
                  padding: "3px 10px",
                  borderRadius: 5,
                  fontSize: 12,
                  fontWeight: 500,
                  backgroundColor: "#dfe8ff",
                  color: statusColor,
                  display: "inline-block",
                }}
              >
                {statusLabel}
              </span>
            ) : (
              <button
                onClick={() => {
                  setReport_id(el.id);
                  setModalType("status");
                  setModalTableElement(el);
                  setOpenModal(true);
                }}
                style={{
                  padding: "3px 10px",
                  borderRadius: 5,
                  border: "none",
                  fontSize: 12,
                  fontWeight: 500,
                  cursor: "pointer",
                  backgroundColor: "#dfe8ff",
                  color: statusColor,
                }}
              >
                {statusLabel}
              </button>
            )}
          </div>
        ),
      payment_type: isGroupTotal ? (
        <div className="td">
          {(() => {
            const { allSame, value } = allEqualByKey("payment_type");
            if (!value) return "Не выбран";
            if (!allSame) return "CPM/CPC";
            return value;
          })()}
        </div>
      ) : (
        <div className="td">
          {el.payment_type ? (
            el.payment_type
          ) : (
            <select
              style={{ width: "100%", height: 30 }}
              defaultValue=""
              onChange={async (e) => {
                const value = e.target.value || null;
                await updateField(el.id, "payment_type", value);
                setFilter((prev) =>
                  prev.map((item) =>
                    item.id === el.id ? { ...item, payment_type: value } : item
                  )
                );
              }}
            >
              <option value="" disabled>
                Выбрать
              </option>
              <option value="CPM">CPM</option>
              <option value="CPC">CPC</option>
            </select>
          )}
        </div>
      ),
      external_verifier: isGroupTotal ? (
        groupExternalVerifierCell()
      ) : (
        <div className="td">
          <FormControl fullWidth size="small">
            <Select
              multiple
              value={
                Array.isArray(el.external_verifier)
                  ? el.external_verifier
                  : el.external_verifier
                  ? [el.external_verifier]
                  : ["Нет"]
              }
              onChange={async (e) => {
                let value = e.target.value;
                if (typeof value === "string") {
                  value = value.split(",").filter(Boolean);
                }
                const prev =
                  Array.isArray(el.external_verifier)
                    ? el.external_verifier
                    : el.external_verifier
                    ? [el.external_verifier]
                    : ["Нет"];

                let next = Array.isArray(value) ? value : [];

                if (next.includes("Нет") && !prev.includes("Нет")) {
                  next = ["Нет"];
                } else {
                  next = next.filter((v) => v !== "Нет");
                  if (next.length === 0) {
                    next = ["Нет"];
                  }
                }

                const normalized = next;
                await updateField(el.id, "external_verifier", normalized);
                setFilter((prev) =>
                  prev.map((item) =>
                    item.id === el.id
                      ? { ...item, external_verifier: normalized }
                      : item
                  )
                );
              }}
              renderValue={(selected) => {
                if (!selected || selected.length === 0) return "";
                if (selected.length === 1) return selected[0];
                const [first, ...rest] = selected;
                return `${first} и +${rest.length}`;
              }}
              displayEmpty
            >
              {EXTERNAL_VERIFIER_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  <Checkbox
                    checked={
                      Array.isArray(el.external_verifier)
                        ? el.external_verifier.includes(option)
                        : el.external_verifier
                        ? [el.external_verifier].includes(option)
                        : option === "Нет"
                    }
                  />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      ),
      start_cycle_date: makeStartDateCell(),
      end_cycle_date: makeEndDateCell(),
      views: (
        <div
          className="td"
          style={{ color: el.views === 0 ? "#9e9e9e" : undefined }}
        >
          {el.views}
        </div>
      ),
      views_fact: (
        <div
          className="td"
          style={{ color: el.views_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {el.views_fact}
        </div>
      ),
      views_goal: (
        <div
          className="td"
          style={{
            color:
              el.views_goal === 0
                ? "#9e9e9e"
                : el.views_goal <= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.views_goal) ? el.views_goal : (el.views_goal ?? 0).toFixed(2)}%
        </div>
      ),
      clicks: (
        <div
          className="td"
          style={{ color: el.clicks === 0 ? "#9e9e9e" : undefined }}
        >
          {el.clicks}
        </div>
      ),
      clicks_fact: (
        <div
          className="td"
          style={{ color: el.clicks_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.clicks_fact) ? el.clicks_fact : el.clicks_fact.toFixed(2)}
        </div>
      ),
      clicks_goal: (
        <div
          className="td"
          style={{
            color:
              el.clicks_goal === 0
                ? "#9e9e9e"
                : el.clicks_goal <= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.clicks_goal) ? el.clicks_goal : el.clicks_goal.toFixed(2)}%
        </div>
      ),
      leads: (
        <div
          className="td"
          style={{ color: el.leads === 0 ? "#9e9e9e" : undefined }}
        >
          {el.leads}
        </div>
      ),
      leads_fact: (
        <div
          className="td"
          style={{ color: el.leads_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.leads_fact) ? el.leads_fact : el.leads_fact.toFixed(2)}
        </div>
      ),
      leads_goal: (
        <div
          className="td"
          style={{
            color:
              el.leads_goal === 0
                ? "#9e9e9e"
                : el.leads_goal <= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.leads_goal) ? el.leads_goal : el.leads_goal.toFixed(2)}%
        </div>
      ),
      leads_qual: (
        <div
          className="td"
          style={{ color: el.leads_qual === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.leads_qual) ? el.leads_qual : el.leads_qual.toFixed(2)}
        </div>
      ),
      leads_qual_fact: (
        <div
          className="td"
          style={{ color: el.leads_qual_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.leads_qual_fact) ? el.leads_qual_fact : el.leads_qual_fact.toFixed(2)}
        </div>
      ),
      leads_qual_goal: (
        <div
          className="td"
          style={{
            color:
              el.leads_qual_goal === 0
                ? "#9e9e9e"
                : el.leads_qual_goal <= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.leads_qual_goal) ? el.leads_qual_goal : el.leads_qual_goal.toFixed(2)}%
        </div>
      ),
      postviews_plan: (
        <div
          className="td"
          style={{ color: el.postviews_plan === 0 ? "#9e9e9e" : undefined }}
        >
          {el.postviews_plan}
        </div>
      ),
      postviews_fact: (
        <div
          className="td"
          style={{ color: el.postviews_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {el.postviews_fact}
        </div>
      ),
      postviews_goal: (
        <div
          className="td"
          style={{
            color:
              el.postviews_goal === 0
                ? "#9e9e9e"
                : el.postviews_goal <= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.postviews_goal) ? el.postviews_goal : (el.postviews_goal ?? 0).toFixed(2)}%
        </div>
      ),
      income: (
        <div
          className="td"
          style={{ color: el.income === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.income) ? el.income : el.income.toFixed(2)}
        </div>
      ),
      income_fact: (
        <div
          className="td"
          style={{ color: el.income_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.income_fact) ? el.income_fact : el.income_fact.toFixed(2)}
        </div>
      ),
      drr_fact: (
        <div
          className="td"
          style={{ color: el.drr_fact === 0 ? "#9e9e9e" : undefined }}
        >
          {Number.isInteger(el.drr_fact) ? el.drr_fact : el.drr_fact.toFixed(2)}
        </div>
      ),
      budget_goal: (
        <div
          className="td"
          style={{
            color:
              el.budget_goal === 0
                ? "#9e9e9e"
                : el.budget_goal >= 100
                  ? "#ff4141"
                  : "#49e02d",
          }}
        >
          {Number.isInteger(el.budget_goal) ? el.budget_goal : el.budget_goal.toFixed(2)}%
        </div>
      ),

      account_manager: 
        <div className="td">
          {arrStaff.length > 0 ? (
            arrStaff.find((staff) => staff.id === el.account_manager)?.full_name || "Нет"
          ) : (
            "Загрузка..."
          )}
          {["ADMIN", "SUPERUSER"].some((r) => r === role) && (
            <svg
              onClick={() => {
                setReport_id(el.id)
                setFieldAndLabel({
                  field: "account_manager",
                  label: "Аккаунт-менеджер-1",
                })
                setModalType("staff")
                setModalTableElement(el)
                setOpenModal(true)
              }}
              style={{ marginLeft: 10, cursor: "pointer", width: 14, height: 14, flexShrink: 0 }}
              width="14"
              height="14"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184В7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                fill="black"
              />
            </svg>
          )}
        </div>,
      account_manager_1: 
        <div className="td">
          {arrStaff.length > 0 ? (
            arrStaff.find((staff) => staff.id === el.account_manager_1)?.full_name || "Нет"
          ) : (
            "Загрузка..."
          )}
          {["ADMIN", "SUPERUSER"].some((r) => r === role) && (
            <svg
              onClick={() => {
                setReport_id(el.id)
                setFieldAndLabel({
                  field: "account_manager_1",
                  label: "Аккаунт-менеджер-1",
                })
                setModalType("staff")
                setModalTableElement(el)
                setOpenModal(true)
              }}
              style={{ marginLeft: 10, cursor: "pointer", width: 14, height: 14, flexShrink: 0 }}
              width="14"
              height="14"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184В7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                fill="black"
              />
            </svg>
          )}
        </div>,
      contextologist: 
        <div className="td">
          {arrStaff.length > 0 ? (
            arrStaff.find((staff) => staff.id === el.contextologist)?.full_name || "Нет"
          ) : (
            "Загрузка..."
          )}
          {["ADMIN", "SUPERUSER"].some((r) => r === role) && (
            <svg
              onClick={() => {
                setReport_id(el.id)
                setFieldAndLabel({
                  field: "contextologist",
                  label: "Контекстолог",
                })
                setModalType("staff")
                setModalTableElement(el)
                setOpenModal(true)
              }}
              style={{ marginLeft: 10, cursor: "pointer", width: 14, height: 14, flexShrink: 0 }}
              width="14"
              height="14"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184В7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957З"
                fill="black"
              />
            </svg>
          )}
        </div>,
      traffic_manager: 
        <div className="td">
          {arrStaff.length > 0 ? (
            arrStaff.find((staff) => staff.id === el.traffic_manager)?.full_name || "Нет"
          ) : (
            "Загрузка..."
          )}
          {["ADMIN", "SUPERUSER"].some((r) => r === role) && (
            <svg
              onClick={() => {
                setReport_id(el.id)
                setFieldAndLabel({
                  field: "traffic_manager",
                  label: "Трафик менеджер",
                })
                setModalType("staff")
                setModalTableElement(el)
                setOpenModal(true)
              }}
              style={{ marginLeft: 10, cursor: "pointer", width: 14, height: 14, flexShrink: 0 }}
              width="14"
              height="14"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184В7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957З"
                fill="black"
              />
            </svg>
          )}
        </div>,
      open: (
        <button
          onClick={() => {
            setReport_id(el.id)
            setOpenModal(true)
            setModalType("detail")
          }}
          style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
          Открыть 
        </button>
      ),
      ...(role === "SUPERUSER" ? {
        open_marginality: (
          <button
            onClick={() => {
              setReport_id(el.id)
              setOpenModal(true)
              setModalType("marginality")
            }}
            style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
            Открыть 
          </button>
        )
      } : {}),
      ...(["ADMIN", "SUPERUSER"].some((r) => r === role) ? {
        delete: (
          <button
            onClick={() => {
              confirm("Вы уверены что хотите удалить проект - " + el.project + " ?") && deleteProject(el.id)
            }}
            style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
            Удалить 
          </button>
        ),
      } : {}),
      dublicate: (
        <button
          onClick={() => {
            confirm("Вы уверены что хотите создать дубликат проекта - " + el.project + " ?") && dublicateProject(el.id)
          }}
          style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
          Дублировать
        </button>
      ),
      arсhive: (
        <button
          onClick={() => {
            if (!["ADMIN", "SUPERUSER"].some((r) => r === role)) return alert("Управлять архивом может только администратор и суперпользователь");
            confirm(`Вы уверены что хотите ${page === "all" ? "архивировать" : "разархивировать"} проект - ` + el.project + " ?") && page === "all" ? archiveProject(el.id) : unarchiveProject(el.id)
          }}
          style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
          {page === "all" ? "Архивировать" : "Разархивировать" }
        </button>
      ),
      direct_connect: (
        <button
        disabled={searchParams.get('report_id') === el.id ? true : false}
          style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: searchParams.get('report_id') === el.id ? "gray" : "#DFE8FF", color: searchParams.get('report_id') === el.id ? "white" : "#3F73F9" }}>
          {searchParams.get('report_id') === el.id ? "Подключено - Test" : "Подключить"}
        </button>
      ),
      row_color: isChild && parentGroupId ? (
        <div className="td" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ fontSize: 12, color: "#7a7a7a" }}>-</span>
        </div>
      ) : (
        <div className="td" style={{ position: "relative" }}>
          <FormControl fullWidth size="small">
            <Select
              value={getRowColor(el.id, isGroupTotal) || ""}
              onChange={(e) => {
                const color = e.target.value;
                if (color) {
                  saveRowColor(el.id, color);
                } else {
                  const newColors = { ...rowColors };
                  delete newColors[el.id];
                  setRowColors(newColors);
                  try {
                    localStorage.setItem('campaigns_row_colors', JSON.stringify(newColors));
                  } catch (e) {
                    console.error('Failed to remove row color:', e);
                  }
                }
              }}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: 4,
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                      }}
                    />
                  );
                }
                return (
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      backgroundColor: selected,
                      border: "1px solid #ddd",
                    }}
                  />
                );
              }}
            >
              <MenuItem value="">
                <em>Без цвета</em>
              </MenuItem>
              {COLOR_OPTIONS.map((color) => (
                <MenuItem key={color.value} value={color.value}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 4,
                        backgroundColor: color.value,
                        border: "1px solid #ddd",
                      }}
                    />
                    <span>{color.label}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      ),
    };
    };

    const sortActive = sortImportant !== "default" || sortStatus !== "default" || sortEndCycle !== "default";
    if (selectedDomains.length > 0 || sortActive) {
      return data.map((el) => buildRow(el));
    }

    // "Все проекты": группировка по доменам с раскрытием дубликатов
    const grouped = data.reduce((acc, el) => {
      const domain = el.domain || "Без домена";
      if (!acc[domain]) acc[domain] = [];
      acc[domain].push(el);
      return acc;
    }, {});

    const rows = [];
    let groupIndexCounter = -1;

    Object.keys(grouped)
      .sort()
      .forEach((domain) => {
        const items = grouped[domain];
        const isExpanded = !!expandedDomains[domain];

        if (items.length === 1) {
          rows.push(buildRow(items[0]));
          return;
        }

        groupIndexCounter += 1;
        const groupColorIndex = groupIndexCounter % 10;

        const numericKeys = [
          "views",
          "views_fact",
          "clicks",
          "clicks_fact",
          "leads",
          "leads_fact",
          "leads_qual",
          "leads_qual_fact",
          "postviews_plan",
          "postviews_fact",
          "income",
          "income_fact",
          "budget",
          "budget_fact",
          "budget_production",
          "fact_consumption",
          "drr_fact",
        ];

        const groupRowData = { ...items[0] };
        const entityName = items[0]?.entity_name;

        numericKeys.forEach((key) => {
          const sum = items.reduce((acc, item) => {
            const value = Number(item[key]);
            return acc + (Number.isFinite(value) ? value : 0);
          }, 0);
          groupRowData[key] = sum;
        });

        const goalKeys = [
          "views_goal",
          "clicks_goal",
          "leads_goal",
          "leads_qual_goal",
          "postviews_goal",
          "budget_goal",
        ];

        goalKeys.forEach((key) => {
          const { sum, count } = items.reduce(
            (acc, item) => {
              const value = Number(item[key]);
              if (Number.isFinite(value)) {
                acc.sum += value;
                acc.count += 1;
              }
              return acc;
            },
            { sum: 0, count: 0 }
          );
          groupRowData[key] = count > 0 ? sum / count : 0;
        });

        const totalBudgetFact = Number(groupRowData.budget_fact) || 0;
        const totalBudgetProduction =
          Number(groupRowData.budget_production) || 0;
        const totalFactConsumption = totalBudgetFact + totalBudgetProduction;
        groupRowData.fact_consumption = totalFactConsumption;

        const totalIncomeFact = Number(groupRowData.income_fact) || 0;
        groupRowData.drr_fact =
          totalIncomeFact > 0
            ? (totalFactConsumption / totalIncomeFact) * 100
            : 0;

        groupRowData.id = `group-${domain}`;
        groupRowData.project = entityName
          ? `${entityName} - ${domain}`
          : `${domain}`;
        groupRowData.domain = domain;
        groupRowData._isGroupTotal = true;

        const groupRow = buildRow(groupRowData, {
          isGroupTotal: true,
          groupItems: items,
        });

        groupRow.project = (
          <div
            className="td"
            style={{ display: "flex", alignItems: "center" }}
          >
            <button
              onClick={() =>
                setExpandedDomains((prev) => ({
                  ...prev,
                  [domain]: !prev[domain],
                }))
              }
              style={{
                padding: 0,
                marginRight: 6,
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: "#000",
                fontSize: 20,
                lineHeight: 1,
              }}
            >
              {isExpanded ? "▾" : "▸"}
            </button>
            <span>
              {entityName ? `${entityName} — ${domain}` : `${domain}`}
            </span>
          </div>
        );

        groupRow.open = (
          <button
            disabled
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
              opacity: 0.6,
              cursor: "default",
            }}
          >
            Открыть
          </button>
        );
        groupRow.open_marginality = (
          <button
            disabled
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
              opacity: 0.6,
              cursor: "default",
            }}
          >
            Открыть
          </button>
        );
        groupRow.delete = (
          <button
            disabled
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
              opacity: 0.6,
              cursor: "default",
            }}
          >
            Удалить
          </button>
        );
        groupRow.dublicate = (
          <button
            disabled
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
              opacity: 0.6,
              cursor: "default",
            }}
          >
            Дублировать
          </button>
        );
        groupRow.arсhive = (
          <button
            disabled
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
              opacity: 0.6,
              cursor: "default",
            }}
          >
            {page === "all" ? "Архивировать" : "Разархивировать"}
          </button>
        );
        groupRow.direct_connect = <div className="td"></div>;
        groupRow._groupIndex = groupColorIndex;
        groupRow._isGroupTotal = true;

        const sameManagerId = (key) => {
          if (!items.length) return null;
          const firstId = items[0][key];
          if (!firstId) return null;
          return items.every((item) => item[key] === firstId) ? firstId : null;
        };

        const makeManagerSummaryCell = (key) => {
          const id = sameManagerId(key);
          if (!id) return <div className="td"></div>;
          const staff = arrStaff.find((staff) => staff.id === id);
          return <div className="td">{staff ? staff.full_name : "Нет"}</div>;
        };

        groupRow.account_manager = makeManagerSummaryCell("account_manager");
        groupRow.account_manager_1 = makeManagerSummaryCell("account_manager_1");
        groupRow.contextologist = makeManagerSummaryCell("contextologist");
        groupRow.traffic_manager = makeManagerSummaryCell("traffic_manager");

        rows.push(groupRow);

        if (isExpanded) {
          items.forEach((el) => {
            const childRow = buildRow(el, { isChild: true, parentGroupId: `group-${domain}` });
            childRow._groupIndex = groupColorIndex;
            childRow._isGroupChild = true;
            childRow._parentGroupId = `group-${domain}`;
            rows.push(childRow);
          });
        }
      });

    return rows;
  }
  const domainsForList = Array.from(
    new Set(
      filterArr
        .filter((el) => {
          const projectMatches = searchValue.project
            ? el.project?.toLowerCase().includes(searchValue.project.toLowerCase())
            : true;
          const domainMatches = searchValue.domain
            ? el.domain?.toLowerCase().includes(searchValue.domain.toLowerCase())
            : true;
          const managerMatches = searchValue.manager
            ? [
                el.account_manager,
                el.account_manager_1,
                el.contextologist,
                el.traffic_manager,
              ].some((managerId) => {
                const staffMember = arrStaff.find((staff) => staff.id === managerId);
                return (
                  staffMember &&
                  staffMember.full_name
                    .toLowerCase()
                    .includes(searchValue.manager.toLowerCase())
                );
              })
            : true;
          const importantMatchesFilter = onlyImportant
            ? importantProjects.includes(el.id)
            : true;
          const onlyMyMatchesFilter = onlyMyFirstAccount
            ? (() => {
                const manager = arrStaff.find(
                  (staff) => staff.id === el.account_manager
                );
                if (!manager || !user?.email) return false;
                return (
                  manager.email.toLowerCase() === user.email.toLowerCase()
                );
              })()
            : true;

          const basePass =
            projectMatches &&
            domainMatches &&
            managerMatches &&
            importantMatchesFilter &&
            onlyMyMatchesFilter;

          if (!basePass) return false;

          if (advancedFilters.length === 0) return true;

          const advancedPass = (() => {
            const getFieldRawValue = (row, fieldName) => {
              switch (fieldName) {
                default:
                  return row[fieldName];
              }
            };

            const results = advancedFilters.map((cond) => {
              const fieldCfg = filterableFields.find(
                (f) => f.value === cond.field
              );
              if (!fieldCfg) return true;

              const raw = getFieldRawValue(el, cond.field);

              if (fieldCfg.type === "number") {
                const left = Number(raw);
                const right = Number(cond.value);
                if (Number.isNaN(left) || Number.isNaN(right)) return false;
                switch (cond.operator) {
                  case ">":
                    return left > right;
                  case ">=":
                    return left >= right;
                  case "<":
                    return left < right;
                  case "<=":
                    return left <= right;
                  case "=":
                    return left === right;
                  case "!=":
                    return left !== right;
                  default:
                    return true;
                }
              }

              const leftStr = (raw ?? "").toString().toLowerCase();
              const rightStr = String(cond.value).toLowerCase();

              switch (cond.operator) {
                case "contains":
                  return leftStr.includes(rightStr);
                case "not_contains":
                  return !leftStr.includes(rightStr);
                case "=":
                  return leftStr === rightStr;
                case "!=":
                  return leftStr !== rightStr;
                default:
                  return true;
              }
            });

            return advancedLogic === "AND"
              ? results.every(Boolean)
              : results.some(Boolean);
          })();

          return advancedPass;
        })
        .map((el) => el.domain || "Без домена")
    )
  ).sort();

  return (
    <div className="logs campaigns-reports-page" style={{ width: "100%", height: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 14 }}>
        <button
          style={{
            color: activeReportTab === "production" ? "#3F73F9" : "#7a7a7a",
            fontSize: "15px",
            fontWeight: "500",
            borderBottom: activeReportTab === "production" ? "2px solid #3F73F9" : "2px solid transparent",
            paddingBottom: 6,
          }}
          onClick={() => switchReportTab("production")}
        >
          Отчёт производства
        </button>
        <button
          style={{
            color: activeReportTab === "retargeo" ? "#3F73F9" : "#7a7a7a",
            fontSize: "15px",
            fontWeight: "500",
            borderBottom: activeReportTab === "retargeo" ? "2px solid #3F73F9" : "2px solid transparent",
            paddingBottom: 6,
          }}
          onClick={() => switchReportTab("retargeo")}
        >
          Отчёт производства Retargeo
        </button>
      </div>

      {activeReportTab === "retargeo" ? (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 14 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <input
              value={retargeoSearch}
              onChange={(e) => setRetargeoSearch(e.target.value)}
              className="searchEmploee"
              placeholder="Поиск по названию РК или почте клиента"
              style={{ minWidth: 320 }}
            />
            <select
              value={retargeoClickRuFilter}
              onChange={(e) => setRetargeoClickRuFilter(e.target.value)}
              style={{ height: 36, border: "1px solid #e2e8f0", borderRadius: 8, padding: "0 10px" }}
            >
              <option value="all">Click.ru: все</option>
              <option value="click.ru">Только click.ru</option>
              <option value="без click.ru">Без click.ru</option>
            </select>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 150 }}>
                <DatePickerTest
                  value={retargeoReportDateUnix(retargeoReportDate)}
                  onChange={(dateStr) => {
                    if (typeof dateStr === "string" && dateStr) setRetargeoReportDate(dateStr);
                  }}
                />
              </div>
            </div>
              <span style={{ fontSize: 12, color: "#7a7a7a" }}>
                Найдено: {retargeoTotalRecords}
              </span>
            </div>

            <button
              type="button"
              onClick={handleRetargeoExport}
              style={{
                width: "fit-content",
                backgroundColor: "#dfe8ff",
                color: "#3f73f9",
                padding: "8px 14px",
                height: 36,
                fontSize: 14,
                borderRadius: 8,
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Скачать CSV
            </button>
          </div>
          <div style={{ width: "100%", overflowX: "auto", overflowY: "auto", height: "78%" }}>
            {retargeoIsLoading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 140 }}>
                Собираем данные...
              </div>
            ) : (
              <DataTable data={retargeoRows} columns={retargeoColumns} />
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 18, marginBottom: 10 }}>
            <button
              style={{
                width: "fit-content",
                backgroundColor: retargeoCurrentPage === 1 ? "#e0e0e0" : "#dfe8ff",
                color: retargeoCurrentPage === 1 ? "#999" : "#3f73f9",
                padding: "8px 20px",
                fontSize: 14,
                borderRadius: 5,
                border: "none",
                cursor: retargeoCurrentPage === 1 ? "not-allowed" : "pointer",
              }}
              onClick={() => handleRetargeoPageChange("prev")}
              disabled={retargeoCurrentPage === 1}
            >
              Назад
            </button>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>
              <span>{retargeoCurrentPage} / {retargeoTotalPages}</span>
            </div>
            <button
              style={{
                width: "fit-content",
                backgroundColor: retargeoCurrentPage === retargeoTotalPages ? "#e0e0e0" : "#dfe8ff",
                color: retargeoCurrentPage === retargeoTotalPages ? "#999" : "#3f73f9",
                padding: "8px 20px",
                fontSize: 14,
                borderRadius: 5,
                border: "none",
                cursor: retargeoCurrentPage === retargeoTotalPages ? "not-allowed" : "pointer",
              }}
              onClick={() => handleRetargeoPageChange("next")}
              disabled={retargeoCurrentPage === retargeoTotalPages}
            >
              Дальше
            </button>
          </div>
        </>
      ) : (
      <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
        <div className="filters" style={{ marginTop: 0 }}>
          <input
            onChange={(e) =>
              setSearchValue((prev) => ({ ...prev, project: e.target.value }))
            }
            className="searchEmploee"
            placeholder="По названию проекта"
          />
          <input
            onChange={(e) =>
              setSearchValue((prev) => ({ ...prev, domain: e.target.value }))
            }
            className="searchEmploee"
            placeholder="По сайту проекта"
          />
          <input
            onChange={(e) =>
              setSearchValue((prev) => ({ ...prev, manager: e.target.value }))
            }
            className="searchEmploee"
            placeholder="По сотруднику"
          />
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 12,
              color: "#7a7a7a",
              marginTop: 6,
            }}
          >
            <input
              type="checkbox"
              checked={onlyImportant}
              onChange={(e) => setOnlyImportant(e.target.checked)}
              style={{ margin: 0, width: 15, height: 15 }}
            />
            Только значимые проекты
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 12,
              color: "#7a7a7a",
              marginTop: 6,
            }}
          >
            <input
              type="checkbox"
              checked={onlyMyFirstAccount}
              onChange={(e) => setOnlyMyFirstAccount(e.target.checked)}
              style={{ margin: 0, width: 15, height: 15 }}
            />
            Только проекты, где я 1-й аккаунт
          </label>
        </div>
        <button
          onClick={async () => {
            const result = await getLimits2Email();
            if (result) {
              enqueueSnackbar("Отчёт по лимитам отправлен вам на почту.", {
                variant: "info",
                autoHideDuration: 3000,
                anchorOrigin: { vertical: "top", horizontal: "right" },
              });
            } else {
              enqueueSnackbar("Не получилось отправить отчёт по лимитам.", {
                variant: "error",
                autoHideDuration: 3000,
                anchorOrigin: { vertical: "top", horizontal: "right" },
              });
            }
          }}
          style={{ marginTop: 25, width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", height: 35, fontSize: 14, borderRadius: 5 }}>
          Получить отчёт по лимитам
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px", gap: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", width: "fit-content", gap: "20px" }}>
          <button style={{ color: page === "all" ? "#3F73F9" : "#7a7a7a", fontSize: "14px", fontWeight: "400" }} onClick={() => setPage("all")}>Активные проекты</button>
          <button style={{ color: page === "archive" ? "#3F73F9" : "#7a7a7a", fontSize: "14px", fontWeight: "400" }} onClick={() => setPage("archive")}>Архив</button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          
          <span style={{ fontSize: 12, color: "#7a7a7a" }}>
            {selectedDomains.length === 0 ? "Фильтр по домену: Все проекты" : `Фильтр по домену: выбрано ${selectedDomains.length}`}
          </span>
          <button
            type="button"
            onClick={() => setIsDomainFilterOpen(true)}
            style={{
              fontSize: 13,
              padding: "6px 12px",
              borderRadius: 8,
              border: "1px solid #3F73F9",
              backgroundColor: "#fff",
              color: "#3F73F9",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#edf2ff";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Список проектов
          </button>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <button
              type="button"
              onClick={() => setIsAdvancedFilterOpen(true)}
              style={{
                fontSize: 13,
                padding: "6px 12px",
                borderRadius: 8,
                border: "1px solid #3F73F9",
                backgroundColor: "#fff",
                color: "#3F73F9",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#edf2ff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              Расширенный фильтр
            </button>
            <button
              type="button"
              onClick={() => setIsColumnsModalOpen(true)}
              style={{
                fontSize: 13,
                padding: "6px 12px",
                borderRadius: 8,
                border: "1px solid #3F73F9",
                backgroundColor: "#fff",
                color: "#3F73F9",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#edf2ff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              Настройка столбцов
            </button>
          </div>
        </div>
      </div>

      <div style={{ overflowX: "auto", width: "100%", overflowY: "auto", height: "90%" }}>
        {isLoading && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <p>Загрузка данных ...</p>
          </div>
        )}
        {!isLoading && (
          <DataTable
            data={getTableData()}
            columns={visibleColumnsOrdered}
            getRowProps={(row) => {
              const isImportant = importantProjects.includes(row.original.id);
              const variant = row.original.rowVariant;
              const isGroupTotal = row.original._isGroupTotal;
              const isGroupChild = row.original._isGroupChild;
              const parentGroupId = row.original._parentGroupId;
              const classNames = [];

              if (variant === "group") {
                classNames.push("row-group");
              }
              if (variant === "group-child") {
                classNames.push("row-group-child");
              }

              const props = {};

              let backgroundColor = null;
              const rowId = row.original.id;

              if (isGroupChild && parentGroupId) {
                const parentColor = getRowColor(parentGroupId, true);
                if (parentColor) {
                  backgroundColor = parentColor;
                  classNames.push("row-custom-color");
                } else {
                  backgroundColor = "#f5f5f5";
                  classNames.push("row-group-default");
                }
              } else if (isGroupTotal) {
                const savedColor = getRowColor(rowId, true);
                if (savedColor) {
                  backgroundColor = savedColor;
                  classNames.push("row-custom-color");
                } else {
                  backgroundColor = "#f5f5f5";
                  classNames.push("row-group-default");
                }
              } else {
                const savedColor = getRowColor(rowId, false);
                if (savedColor) {
                  backgroundColor = savedColor;
                  classNames.push("row-custom-color");
                }
              }

              if (backgroundColor) {
                if (classNames.includes("row-custom-color")) {
                  props.style = { ...(props.style || {}), "--row-bg": backgroundColor };
                } else {
                  props.style = { ...(props.style || {}), backgroundColor };
                }
              }

              if (isImportant && backgroundColor) {
                props.style = { ...(props.style || {}), "--row-bg": backgroundColor };
              }

              if (classNames.length > 0) {
                props.className = classNames.join(" ");
              }

              return props;
            }}
          />
        )}
      </div>
      <Modal
        open={isAdvancedFilterOpen}
        onClose={() => setIsAdvancedFilterOpen(false)}
      >
        <Box sx={advancedFilterModalStyles}>
          <div
            style={{
              marginTop: 4,
              padding: "12px 14px 14px",
              borderRadius: 10,
              backgroundColor: "#fff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              display: "flex",
              flexDirection: "column",
              gap: 14,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 8,
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                Расширенный фильтр проектов
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {advancedFilters.length > 0 && (
                  <button
                    type="button"
                    onClick={() => setAdvancedFilters([])}
                    style={{
                      fontSize: 12,
                      color: "#64748b",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "2px 6px",
                      borderRadius: 6,
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.color = "#3F73F9";
                      e.currentTarget.style.backgroundColor = "#f1f5f9";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.color = "#64748b";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    Сбросить все
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setIsAdvancedFilterOpen(false)}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    fontSize: 16,
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f5f9";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#fff";
                  }}
                >
                  ×
                </button>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1.4fr auto 1.6fr auto",
                gap: 10,
                alignItems: "end",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: "#64748b" }}>
                  Поле
                </label>
                <select
                  value={newFilterField}
                  onChange={(e) => {
                    const nextField = e.target.value;
                    setNewFilterField(nextField);
                    const fieldCfg = filterableFields.find(
                      (f) => f.value === nextField
                    );
                    if (fieldCfg?.type === "number") {
                      setNewFilterOperator(">");
                    } else {
                      setNewFilterOperator("contains");
                    }
                  }}
                  style={{
                    height: 36,
                    fontSize: 13,
                    padding: "0 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    color: "#334155",
                    minWidth: 0,
                  }}
                >
                  {filterableFields.map((f) => (
                    <option key={f.value} value={f.value}>
                      {f.label}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: "#64748b" }}>
                  Условие
                </label>
                <select
                  value={newFilterOperator}
                  onChange={(e) => setNewFilterOperator(e.target.value)}
                  style={{
                    height: 36,
                    fontSize: 13,
                    padding: "0 10px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    color: "#334155",
                    width: 120,
                  }}
                >
                  {(() => {
                    const fieldCfg = filterableFields.find(
                      (f) => f.value === newFilterField
                    );
                    if (fieldCfg?.type === "number") {
                      return [">", ">=", "<", "<=", "=", "!="].map((op) => (
                        <option key={op} value={op}>
                          {op}
                        </option>
                      ));
                    }
                    return ["contains", "not_contains", "=", "!="].map((op) => (
                      <option key={op} value={op}>
                        {op === "contains"
                          ? "содержит"
                          : op === "not_contains"
                          ? "не содержит"
                          : op}
                      </option>
                    ));
                  })()}
                </select>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: "#64748b" }}>
                  Значение
                </label>
                <input
                  value={newFilterValue}
                  onChange={(e) => setNewFilterValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && newFilterValue.trim()) {
                      setAdvancedFilters((prev) => [
                        ...prev,
                        {
                          id: Date.now(),
                          field: newFilterField,
                          operator: newFilterOperator,
                          value: newFilterValue,
                        },
                      ]);
                      setNewFilterValue("");
                    }
                  }}
                  style={{
                    height: 36,
                    fontSize: 13,
                    padding: "0 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#fff",
                    color: "#334155",
                    minWidth: 0,
                  }}
                  placeholder="Введите значение"
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  if (!newFilterValue.trim()) return;
                  setAdvancedFilters((prev) => [
                    ...prev,
                    {
                      id: Date.now(),
                      field: newFilterField,
                      operator: newFilterOperator,
                      value: newFilterValue,
                    },
                  ]);
                  setNewFilterValue("");
                }}
                style={{
                  height: 36,
                  fontSize: 13,
                  fontWeight: 500,
                  padding: "0 16px",
                  borderRadius: 8,
                  border: "none",
                  backgroundColor: "#3F73F9",
                  color: "#fff",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  boxShadow: "0 1px 2px rgba(63,115,249,0.3)",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2d5dd9";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(63,115,249,0.4)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#3F73F9";
                  e.currentTarget.style.boxShadow = "0 1px 2px rgba(63,115,249,0.3)";
                }}
              >
                Добавить
              </button>
            </div>

            {advancedFilters.length > 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8,
                    paddingTop: 6,
                    maxHeight: 150,
                    overflowY: "auto",
                  }}
                >
                  {advancedFilters.map((cond) => {
                    const fieldCfg = filterableFields.find(
                      (f) => f.value === cond.field
                    );
                    const opLabel =
                      cond.operator === "contains"
                        ? "содержит"
                        : cond.operator === "not_contains"
                        ? "не содержит"
                        : cond.operator;
                    return (
                      <div
                        key={cond.id}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          padding: "6px 10px 6px 12px",
                          borderRadius: 8,
                          backgroundColor: "#f1f5f9",
                          border: "1px solid #e2e8f0",
                          fontSize: 12,
                          color: "#334155",
                        }}
                      >
                        <span style={{ whiteSpace: "nowrap" }}>
                          <strong style={{ color: "#475569" }}>
                            {fieldCfg?.label || cond.field}
                          </strong>
                          {" "}{opLabel}{" "}
                          {cond.value}
                        </span>
                        <button
                          type="button"
                          onClick={() =>
                            setAdvancedFilters((prev) =>
                              prev.filter((f) => f.id !== cond.id)
                            )
                          }
                          style={{
                            width: 20,
                            height: 20,
                            border: "none",
                            background: "#cbd5e1",
                            color: "#fff",
                            cursor: "pointer",
                            fontSize: 14,
                            lineHeight: 1,
                            padding: 0,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = "#94a3b8";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = "#cbd5e1";
                          }}
                        >
                          ×
                        </button>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    paddingTop: 8,
                    borderTop: "1px solid #e2e8f0",
                  }}
                >
                  <span style={{ fontSize: 12, color: "#64748b", fontWeight: 500 }}>
                    Логика:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      borderRadius: 8,
                      border: "1px solid #e2e8f0",
                      overflow: "hidden",
                    }}
                  >
                    {["AND", "OR"].map((logic) => (
                      <button
                        key={logic}
                        type="button"
                        onClick={() => setAdvancedLogic(logic)}
                        style={{
                          padding: "6px 14px",
                          fontSize: 12,
                          fontWeight: 500,
                          border: "none",
                          cursor: "pointer",
                          backgroundColor:
                            advancedLogic === logic ? "#3F73F9" : "#fff",
                          color:
                            advancedLogic === logic ? "#fff" : "#64748b",
                        }}
                        onMouseOver={(e) => {
                          if (advancedLogic !== logic) {
                            e.currentTarget.style.backgroundColor = "#f1f5f9";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (advancedLogic !== logic) {
                            e.currentTarget.style.backgroundColor = "#fff";
                          }
                        }}
                      >
                        {logic === "AND" ? "Все условия (И)" : "Любое (ИЛИ)"}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </Box>
      </Modal>
      <Modal
        open={isDomainFilterOpen}
        onClose={() => setIsDomainFilterOpen(false)}
      >
        <Box sx={advancedFilterModalStyles}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 8,
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                Фильтр по списку проектов (домены)
              </span>
              <button
                type="button"
                onClick={() => setIsDomainFilterOpen(false)}
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  fontSize: 16,
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#64748b",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff";
                }}
              >
                ×
              </button>
            </div>

            <div style={{ fontSize: 12, color: "#64748b" }}>
              Выберите домен, по которому нужно показать проекты. По умолчанию отображаются все проекты.
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                maxHeight: 350,
                overflowY: "auto",
              }}
            >
              {(() => {
                const isAllActive = selectedDomains.length === 0;
                return (
                  <button
                    key="all-projects"
                    onClick={() => setSelectedDomains([])}
                    style={{
                      padding: "4px 10px",
                      borderRadius: 16,
                      border: "1px solid",
                      borderColor: isAllActive ? "#3F73F9" : "#3b3b3b",
                      backgroundColor: isAllActive ? "#dfe8ff" : "transparent",
                      color: isAllActive ? "#3F73F9" : "#000",
                      fontSize: 13,
                      cursor: "pointer",
                      maxWidth: 260,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Все проекты
                  </button>
                );
              })()}
              {domainsForList.map((domain) => {
                const isActive = selectedDomains.includes(domain);
                return (
                  <button
                    key={domain}
                    onClick={() =>
                      setSelectedDomains((prev) =>
                        prev.includes(domain)
                          ? prev.filter((d) => d !== domain)
                          : [...prev, domain]
                      )
                    }
                    style={{
                      padding: "4px 10px",
                      borderRadius: 16,
                      border: "1px solid",
                      borderColor: isActive ? "#3F73F9" : "#3b3b3b",
                      backgroundColor: isActive ? "#dfe8ff" : "transparent",
                      color: isActive ? "#3F73F9" : "#000",
                      fontSize: 13,
                      cursor: "pointer",
                      maxWidth: 260,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={domain}
                  >
                    {domain}
                  </button>
                );
              })}
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
              <button
                type="button"
                onClick={() => setIsDomainFilterOpen(false)}
                style={{
                  padding: "6px 14px",
                  borderRadius: 8,
                  border: "none",
                  backgroundColor: "#3F73F9",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2d5dd9";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#3F73F9";
                }}
              >
                Применить
              </button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={isColumnsModalOpen}
        onClose={() => setIsColumnsModalOpen(false)}
      >
        <Box sx={advancedFilterModalStyles} style={{ width: "600px"}}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 4,
              padding: "12px 14px 14px",
              borderRadius: 10,
              backgroundColor: "#fff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: 8,
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                Видимость столбцов
              </span>
              <button
                type="button"
                onClick={() => setIsColumnsModalOpen(false)}
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  fontSize: 16,
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#64748b",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff";
                }}
              >
                ×
              </button>
            </div>
            <div style={{ fontSize: 13, color: "#64748b", lineHeight: 1.4 }}>
              Первые 4 столбца и даты цикла скрыть и перемещать нельзя. Остальные обычные столбцы и группы можно включать/выключать (для обычных) и перетаскивать, чтобы менять порядок. Подстолбцы внутри групп перетаскивать нельзя.
            </div>
            <div
              ref={columnsModalScrollRef}
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                padding: "2px 0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                {FIXED_COLUMNS_CONFIG.map(({ key, label }) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                      fontSize: 14,
                      padding: "10px 14px",
                      borderRadius: 8,
                      border: "1px dashed #e2e8f0",
                      backgroundColor: "#f8fafc",
                      color: "#94a3b8",
                    }}
                  >
                    <span style={{ userSelect: "none" }}>{label}</span>
                    <span style={{ fontSize: 11 }}>Фиксированный</span>
                  </div>
                ))}
                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleColumnsDragEnd}
                  autoScroll={{
                    acceleration: 10,
                    canScroll(element) {
                      return element === columnsModalScrollRef.current;
                    },
                  }}
                  modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
                >
                  <SortableContext
                    items={modalColumnsOrder || columnsOrder}
                    strategy={verticalListSortingStrategy}
                  >
                    {(modalColumnsOrder || columnsOrder).map((key) => {
                      const regularMeta = HIDEABLE_COLUMNS_CONFIG.find((c) => c.key === key);
                      const groupedMeta = GROUPED_COLUMNS_CONFIG.find((c) => c.groupKey === key);
                      if (groupedMeta) {
                        return (
                          <SortableGroupItem
                            key={key}
                            id={key}
                            label={groupedMeta.groupLabel}
                            subColumns={groupedMeta.columns}
                          />
                        );
                      }
                      if (!regularMeta) return null;
                      const label = regularMeta.label;
                      const isChecked =
                        (modalVisibleColumns || visibleColumns)[key] !== false;

                      return (
                        <SortableColumnItem
                          key={key}
                          id={key}
                          label={label}
                          isChecked={isChecked}
                          onToggle={(checked) => handleToggleColumnVisibility(key, checked)}
                        />
                      );
                    })}
                  </SortableContext>
                </DndContext>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4, gap: 12 }}>
              <button
                type="button"
                onClick={() => {
                  setModalVisibleColumns({ ...defaultVisibleColumns });
                  setModalColumnsOrder([...defaultColumnsOrder]);
                }}
                style={{
                  padding: "6px 14px",
                  borderRadius: 8,
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#fff",
                  color: "#64748b",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                  e.currentTarget.style.borderColor = "#cbd5e1";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                Сбросить
              </button>
              <button
                type="button"
                onClick={() => {
                  setVisibleColumns(modalVisibleColumns || visibleColumns);
                  setColumnsOrder(modalColumnsOrder || columnsOrder);
                  setIsColumnsModalOpen(false);
                }}
                style={{
                  padding: "6px 14px",
                  borderRadius: 8,
                  border: "none",
                  backgroundColor: "#3F73F9",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2d5dd9";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#3F73F9";
                }}
              >
                Готово
              </button>
            </div>
          </div>
        </Box>
      </Modal>
      <OpenModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        type={modalType}
        report_id={report_id}
        arrStaff={arrStaff}
        updateField={updateField}
        modalTableElement={modalTableElement}
        field={fieldAndLabel.field}
        label={fieldAndLabel.label}
        userEmail={user?.email}
        onUpdated={() => setUpd((prev) => !prev)}
      />
      </>
      )}
    </div>
  );
}

export default CampaignsReports;
